(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5373,9831],{

/***/ 1296:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[feature]",
      function () {
        return __webpack_require__(133);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Textarea; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



function Textarea(props) {
    var placeholder = props.placeholder, placeholderIcon = props.placeholderIcon, value = props.value, maxCount = props.maxCount, background = props.background, setValue = props.setValue, onKeyDown = props.onKeyDown;
    var textareaRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var handleInputChange = function(e) {
        var inputValue = e.currentTarget.value;
        if (maxCount) {
            if (inputValue.length > maxCount) {
                setValue(inputValue.slice(0, maxCount));
            } else {
                setValue(inputValue);
            }
        } else {
            setValue(inputValue);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("relative h-full w-full"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                onKeyDown: onKeyDown,
                value: value,
                onChange: handleInputChange,
                ref: textareaRef,
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(background ? background : "bg-color-cell", "h-full w-full text-blue-800 outline-none", "no-scrollbar resize-none")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                onClick: function() {
                    var ref;
                    return (ref = textareaRef.current) === null || ref === void 0 ? void 0 : ref.focus();
                },
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(value === "" ? "flex" : "hidden", "absolute left-0 top-0 z-20 [--icon-color:var(--color-blue-600)]", "cursor-text items-center gap-[4px] pl-[2px]"),
                children: [
                    placeholderIcon && placeholderIcon,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-[16px] font-400 text-color-placeholder",
                        children: placeholder
                    })
                ]
            }),
            maxCount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "absolute bottom-0 right-[10px] flex gap-[2px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-[13px] font-400 text-blue-800",
                        children: value.length
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "text-[13px] font-400 text-blue-400",
                        children: [
                            "/ ",
                            maxCount
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 4551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mg": function() { return /* binding */ useDashboardController; },
/* harmony export */   "zG": function() { return /* binding */ SESSION_LIMIT; }
/* harmony export */ });
/* unused harmony exports createSessionsRecord, extractSessionsToGroups, getDateCategory */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(2670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(253);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(7582);
/* harmony import */ var _utils_client_auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1816);
/* harmony import */ var _utils_queryfy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(6154);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(9204);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pages_ad_examples__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8605);
/* harmony import */ var pages_ai_gallery__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2142);
/* harmony import */ var pages_video_templates__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4168);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8767);
/* harmony import */ var sections_history_generations__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5170);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(4455);
/* harmony import */ var _utils_functions__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(2308);
/* harmony import */ var _utils_upload_file__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(342);
/* harmony import */ var _utils_video__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6961);
/* provided dependency */ var process = __webpack_require__(3454);






















var SESSION_LIMIT = 15;
var dashboardReducer = function(state, action) {
    var updateSession = function updateSession(id, updater, realState) {
        if (state.activePage !== "chat") {
            return state.chat;
        }
        var currentState = realState !== null && realState !== void 0 ? realState : state.chat;
        var currentSession = currentState.content[id];
        if (currentSession === undefined) {
            console.error("Updating session that does not exist");
            return currentState;
        }
        var updatedGroups = currentState.sessionsGroup;
        var newSession = updater(currentSession);
        if (newSession.interacted_at !== currentSession.interacted_at || newSession.status !== currentSession.status) {
            updatedGroups = extractSessionsToGroups([
                newSession
            ], updatedGroups);
        }
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, currentState), {
            sessionsGroup: updatedGroups,
            content: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, currentState.content), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, id, newSession))
        });
    };
    switch(action.name){
        case "video_gpt_state":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                activePage: "videoGpt",
                videoGpt: {
                    content: action.projectList,
                    text: "",
                    projectsDisplay: "column",
                    popupsData: state.videoGpt.popupsData
                }
            });
        case "chat_state":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                activePage: "chat",
                chat: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.chat), {
                    content: action.content,
                    sessionsGroup: extractSessionsToGroups(Object.values(action.content).map(function(s) {
                        return s;
                    }).filter(Boolean), state.chat.sessionsGroup)
                })
            });
        case "home_state":
            var _filter;
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                activePage: "home",
                home: {
                    content: action.history,
                    filter: (_filter = action.filter) !== null && _filter !== void 0 ? _filter : [
                        "deform",
                        "ai_restyle",
                        "ai_photo",
                        "text_to_image",
                        "text_to_video", 
                    ],
                    selectedTool: null
                }
            });
        case "discover_state":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                activePage: "discover",
                discover: {
                    filter: "ai-gallery",
                    q: null,
                    categoryId: null,
                    content: {
                        initialFiltersGallery: pages_ai_gallery__WEBPACK_IMPORTED_MODULE_4__.indexFiltersGallery,
                        initialFiltersTemplates: pages_video_templates__WEBPACK_IMPORTED_MODULE_5__.indexFiltersTemplates,
                        initialFiltersAdExamples: pages_ad_examples__WEBPACK_IMPORTED_MODULE_3__.indexFiltersAdExamples,
                        initialTemplates: null,
                        availableFiltersTemplates: action.availableFiltersTemplates,
                        initialGallery: null,
                        availableFiltersGallery: action.availableFiltersGallery,
                        initialAdExamples: null
                    }
                }
            });
        case "add_ai_studio_content":
            if (state.activePage !== "home") {
                return state;
            }
            var addedHistoryContent = filterAndConcatHistory(state.home.content, action.newContent, false);
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                activePage: "home",
                home: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.home), {
                    content: addedHistoryContent
                })
            });
        case "add_ai_studio_content_from_start":
            {
                if (state.activePage !== "home") {
                    return state;
                }
                var addedHistoryContent1 = filterAndConcatHistory(state.home.content, action.newContent, true);
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                    activePage: "home",
                    home: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.home), {
                        content: addedHistoryContent1
                    })
                });
            }
        case "add_video_gpt_content":
            if (state.activePage !== "videoGpt") {
                return state;
            }
            var addedContent = removeIfExist(state.videoGpt.content, action.newContent);
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                videoGpt: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.videoGpt), {
                    content: addedContent
                })
            });
        case "set_video_gpt_text":
            if (state.activePage !== "videoGpt") {
                return state;
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                videoGpt: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.videoGpt), {
                    text: action.text
                })
            });
        case "change_projects_display":
            if (state.activePage !== "videoGpt") {
                return state;
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                videoGpt: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.videoGpt), {
                    projectsDisplay: action.display
                })
            });
        case "change_discover_filter":
            if (state.activePage !== "discover") {
                return state;
            }
            var _q, _categoryId;
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                discover: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.discover), {
                    filter: action.filter,
                    q: (_q = action.q) !== null && _q !== void 0 ? _q : null,
                    categoryId: (_categoryId = action.categoryId) !== null && _categoryId !== void 0 ? _categoryId : null
                })
            });
        case "remake_session":
            if (state.activePage !== "videoGpt") {
                return state;
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                videoGpt: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.videoGpt), {
                    content: [
                        action.remaked, 
                    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(state.videoGpt.content))
                })
            });
        case "chat_with_initial_message":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                activePage: "chat",
                chat: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.chat), {
                    initialMessage: action.initialMessage
                })
            });
        case "select_ai_studio_tool":
            if (state.activePage !== "home") {
                return state;
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                home: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.home), {
                    selectedTool: action.selectedTool
                })
            });
        case "delete_history_item":
            if (state.activePage !== "home") {
                return state;
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                home: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.home), {
                    content: state.home.content.filter(function(i) {
                        return i.id !== action.id;
                    })
                })
            });
        case "load_popups_data":
            if (state.activePage !== "videoGpt") {
                return state;
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                videoGpt: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.videoGpt), {
                    popupsData: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, action.data), {
                        captions: action.captions
                    })
                })
            });
        case "change_child_name":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                activeChild: action.childName
            });
        case "chat_empty_state":
            if (state.activePage !== "chat") {
                return state;
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                chat: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.chat), {
                    selectedSession: null
                })
            });
        case "chat_set_session_status":
            var ref;
            if (state.activePage !== "chat" || ((ref = state.chat.content[action.sessionId]) === null || ref === void 0 ? void 0 : ref.status) === "deleted") {
                return state;
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                chat: updateSession(action.sessionId, function(old) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, old), {
                        status: action.sessionStatus,
                        errorType: action.errorType
                    });
                })
            });
        case "chat_update_uploaded_files":
            if (state.activePage !== "chat") {
                return state;
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                chat: updateSession(action.sessionId, function(old) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, old), {
                        uploadedMedias: action.uploadedMedias
                    });
                })
            });
        case "chat_add_new_session":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                activePage: "chat",
                chat: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.chat), {
                    selectedSession: action.newSession.id,
                    content: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.chat.content), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, action.newSession.id, action.newSession)),
                    sessionsGroup: extractSessionsToGroups([
                        action.newSession
                    ], state.chat.sessionsGroup)
                }),
                videoGpt: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.videoGpt), {
                    content: [
                        action.newSession, 
                    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(state.videoGpt.content))
                })
            });
        case "chat_select_session":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                chat: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.chat), {
                    selectedSession: action.sessionId
                })
            });
        case "chat_change_session_name":
            var updated = updateSession(action.sessionId, function(old) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, old), {
                    name: action.newName
                });
            });
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                chat: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, updated), {
                    sessionsGroup: state.chat.sessionsGroup.map(function(g) {
                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, g), {
                            sessions: g.sessions.map(function(s) {
                                if (s.id === action.sessionId) {
                                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, s), {
                                        name: action.newName
                                    });
                                }
                                return s;
                            })
                        });
                    })
                }),
                videoGpt: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.videoGpt), {
                    content: state.videoGpt.content.map(function(s) {
                        if (s.id === action.sessionId) {
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, s), {
                                name: action.newName
                            });
                        }
                        return s;
                    })
                })
            });
        case "chat_delete_session":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                chat: updateSession(action.sessionId, function(old) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, old), {
                        status: "deleted"
                    });
                }),
                videoGpt: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.videoGpt), {
                    content: state.videoGpt.content.map(function(s) {
                        if (s.id === action.sessionId) {
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, s), {
                                status: "deleted"
                            });
                        }
                        return s;
                    })
                })
            });
        case "chat_add_new_group":
            if (state.activePage !== "chat") {
                return state;
            }
            var sessionsGroup = extractSessionsToGroups(action.newSessions, state.chat.sessionsGroup);
            var addedSessions = {};
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = action.newSessions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var newSession = _step.value;
                    if (!state.chat.content[newSession.id]) {
                        addedSessions[newSession.id] = newSession;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                chat: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.chat), {
                    content: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.chat.content, addedSessions),
                    sessionsGroup: sessionsGroup
                })
            });
        case "chat_update_sessions":
            if (state.activePage !== "chat") {
                return state;
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                chat: action.updatedSessions.reduce(function(oldState, id) {
                    return updateSession(id, function(oldSession) {
                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, oldSession), {
                            status: "waiting"
                        });
                    }, oldState);
                }, state.chat)
            });
        case "chat_populate_messages":
            if (state.activePage !== "chat") {
                return state;
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                chat: updateSession(action.id, function(old) {
                    var ref;
                    var showRating = (ref = action.messages.map(function(m) {
                        if (m.type === "response" && m.name === "completed") {
                            return m.generation.show_rating;
                        }
                    }).filter(Boolean).at(0)) !== null && ref !== void 0 ? ref : false;
                    var _sessionName;
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, old), {
                        status: action.sessionStatus,
                        messages: action.messages,
                        name: (_sessionName = action.sessionName) !== null && _sessionName !== void 0 ? _sessionName : old.name,
                        errorType: action.errorType,
                        interacted_at: action.sessionInteractedAt,
                        showRating: showRating
                    });
                })
            });
        case "chat_reset_session":
            if (state.activePage !== "chat") {
                return state;
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                chat: updateSession(action.sessionId, function(old) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, old), {
                        status: action.status,
                        messages: action.messages
                    });
                })
            });
        case "chat_retry_session":
            if (state.activePage !== "chat") {
                return state;
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                chat: updateSession(action.sessionId, function(old) {
                    var ref;
                    var ref1;
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, old), {
                        errorType: undefined,
                        status: action.status,
                        messages: (ref1 = (ref = old.messages) === null || ref === void 0 ? void 0 : ref.filter(function(m) {
                            return m.id !== action.temporaryMessageId;
                        })) !== null && ref1 !== void 0 ? ref1 : null
                    });
                })
            });
        case "chat_add_request":
            if (state.activePage !== "chat") {
                return state;
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                chat: updateSession(action.sessionId, function(old) {
                    var _messages;
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, old), {
                        started: action.started,
                        interacted_at: action.interacted_at,
                        status: "client-loading",
                        messages: [
                            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                                id: action.temporaryId,
                                sent_at: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_15__/* .dateToSortableString */ .nU)(new Date()),
                                type: "request"
                            }, action.request), 
                        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((_messages = old.messages) !== null && _messages !== void 0 ? _messages : []))
                    });
                })
            });
        case "chat_change_rating_value":
            var session = state.chat.content[action.id];
            if (session === undefined) {
                return state;
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                chat: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.chat), {
                    content: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.chat.content), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, action.id, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, session), {
                        showRating: false
                    })))
                })
            });
        case "chat_add_response":
            var ref1;
            if (((ref1 = state.chat.content[action.sessionId]) === null || ref1 === void 0 ? void 0 : ref1.status) === "deleted") {
                return state;
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                chat: updateSession(action.sessionId, function(old) {
                    var ref;
                    var _newSessionName, ref1;
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, old), {
                        status: action.status,
                        name: (_newSessionName = action.newSessionName) !== null && _newSessionName !== void 0 ? _newSessionName : old.name,
                        showRating: action.response.name === "completed" ? action.response.generation.show_rating : undefined,
                        messages: [
                            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                                id: action.responseId,
                                sent_at: action.sentAt,
                                type: "response"
                            }, action.response), 
                        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((ref1 = (ref = old.messages) === null || ref === void 0 ? void 0 : ref.map(function(m) {
                            if (m.type !== "request") {
                                return m;
                            }
                            if (m.id !== action.requestUpdate.id) {
                                return m;
                            }
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, m), {
                                sent_at: action.requestUpdate.sentAt,
                                id: action.requestUpdate.realId
                            });
                        })) !== null && ref1 !== void 0 ? ref1 : []))
                    });
                })
            });
        case "chat_change_temp_session":
            var newGroups = extractSessionsToGroups([
                action.newSession
            ], state.chat.sessionsGroup);
            newGroups[0].sessions = newGroups[0].sessions.filter(function(s) {
                return s.id !== action.temporaryId;
            });
            if (Number(state.chat.selectedSession) > 0) {
                var _obj;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                    chat: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.chat), {
                        content: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.chat.content), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, action.newSession.id, action.newSession), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, action.temporaryId, undefined), _obj)),
                        sessionsGroup: newGroups
                    }),
                    videoGpt: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.videoGpt), {
                        content: state.videoGpt.content.filter(function(s) {
                            return s.id !== action.temporaryId;
                        })
                    })
                });
            } else {
                var _obj1;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                    chat: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.chat), {
                        selectedSession: action.newSession.id,
                        content: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.chat.content), (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj1, action.newSession.id, action.newSession), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj1, action.temporaryId, undefined), _obj1)),
                        sessionsGroup: newGroups
                    }),
                    videoGpt: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state.videoGpt), {
                        content: state.videoGpt.content.filter(function(s) {
                            return s.id !== action.temporaryId;
                        })
                    })
                });
            }
    }
};
function createSessionsRecord(sessions) {
    var initial = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sessions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var session = _step.value;
            initial[session.id] = session;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return initial;
}
function useDashboardController(initialData) {
    var initializaeUploadedMedias = function initializaeUploadedMedias(length) {
        var id = state.chat.selectedSession;
        if (!id) return;
        var initial = new Array(length).fill(null);
        dispatch({
            name: "chat_update_uploaded_files",
            sessionId: id,
            uploadedMedias: {
                medias: initial,
                status: "idle"
            }
        });
    };
    var appendFileCreator = function appendFileCreator(index, minDuration) {
        return function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(files) {
                var ref, ref1, id, uploadedMedias, newUploaded;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            id = state.chat.selectedSession;
                            if (!id) return [
                                2
                            ];
                            uploadedMedias = (ref = state.chat.content[id]) === null || ref === void 0 ? void 0 : (ref1 = ref.uploadedMedias) === null || ref1 === void 0 ? void 0 : ref1.medias;
                            if (uploadedMedias === undefined || uploadedMedias === null) return [
                                2
                            ];
                            return [
                                4,
                                Promise.all(uploadedMedias.map(function() {
                                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(elem, i) {
                                        var file, isImage, imgElem, video, uploadedVideoLength, isVideoLengthMatched;
                                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!(i === index)) return [
                                                        3,
                                                        5
                                                    ];
                                                    file = files[0];
                                                    isImage = file.type.includes("image");
                                                    if (!isImage) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        (0,_utils_video__WEBPACK_IMPORTED_MODULE_10__/* .getLoadedImage */ .um)(file)
                                                    ];
                                                case 1:
                                                    imgElem = _state.sent();
                                                    return [
                                                        2,
                                                        {
                                                            blob: file,
                                                            aspect: imgElem.width / imgElem.height,
                                                            isVideoLengthMatched: true,
                                                            thumb_url: null,
                                                            resource_url: URL.createObjectURL(file),
                                                            media_type: "image"
                                                        }
                                                    ];
                                                case 2:
                                                    return [
                                                        4,
                                                        (0,_utils_video__WEBPACK_IMPORTED_MODULE_10__/* .getLoadedVideo */ .GF)(file)
                                                    ];
                                                case 3:
                                                    video = _state.sent();
                                                    return [
                                                        4,
                                                        (0,_utils_video__WEBPACK_IMPORTED_MODULE_10__/* .getVideoDurationMillis */ .nr)(file)
                                                    ];
                                                case 4:
                                                    uploadedVideoLength = _state.sent() / 1000;
                                                    isVideoLengthMatched = uploadedVideoLength >= minDuration;
                                                    return [
                                                        2,
                                                        {
                                                            blob: file,
                                                            aspect: video.width / video.height,
                                                            isVideoLengthMatched: isVideoLengthMatched,
                                                            thumb_url: null,
                                                            resource_url: URL.createObjectURL(file),
                                                            media_type: "video"
                                                        }
                                                    ];
                                                case 5:
                                                    return [
                                                        2,
                                                        elem
                                                    ];
                                            }
                                        });
                                    });
                                    return function(elem, i) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 1:
                            newUploaded = _state.sent();
                            dispatch({
                                name: "chat_update_uploaded_files",
                                uploadedMedias: {
                                    medias: newUploaded,
                                    status: "idle"
                                },
                                sessionId: id
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(files) {
                return _ref.apply(this, arguments);
            };
        }();
    };
    var removeUploadedFile = function removeUploadedFile(index) {
        var ref, ref1;
        var id = state.chat.selectedSession;
        if (!id) return;
        var uploadedMedias = (ref = state.chat.content[id]) === null || ref === void 0 ? void 0 : (ref1 = ref.uploadedMedias) === null || ref1 === void 0 ? void 0 : ref1.medias;
        if (uploadedMedias === undefined || uploadedMedias === null) {
            return;
        }
        var removed = uploadedMedias.map(function(elem, i) {
            if (i === index) {
                return null;
            }
            return elem;
        });
        dispatch({
            name: "chat_update_uploaded_files",
            uploadedMedias: {
                medias: removed,
                status: "idle"
            },
            sessionId: id
        });
    };
    var enterShortCut = function enterShortCut(id, name) {
        dispatch({
            name: "chat_change_session_name",
            sessionId: id,
            newName: name
        });
        renameSession(id, name);
    };
    var checkListChatWhenGenerating = function checkListChatWhenGenerating() {
        return /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
            var ref;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!state.chat.selectedSession) {
                            console.error("No state");
                            return [
                                2
                            ];
                        }
                        if (!(((ref = state.chat.content[state.chat.selectedSession]) === null || ref === void 0 ? void 0 : ref.status) !== "deleted")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            populateSession(state.chat.selectedSession)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
    };
    var clearChatScreen = function clearChatScreen() {
        dispatch({
            name: "chat_empty_state"
        });
        var query = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, router.query);
        var params = Object.entries(query).map(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
            if (key !== "initial_message" && key !== "session_id") {
                return "".concat(key, "=").concat(value);
            }
        }).join("&");
        router.push("/chat?".concat(params));
    };
    var changeShowRatingValue = function changeShowRatingValue() {
        if (state.chat.selectedSession === null) {
            return;
        }
        dispatch({
            name: "chat_change_rating_value",
            id: state.chat.selectedSession
        });
    };
    var changeActiveChild = function changeActiveChild(name) {
        dispatch({
            name: "change_child_name",
            childName: name
        });
    };
    var selectAiStudioTool = function selectAiStudioTool(tool) {
        if (tool === null) {
            window.history.pushState({
                path: "/home"
            }, "", "/home");
        } else {
            window.history.pushState({
                path: "/home?tool=".concat(tool)
            }, "", "/home?tool=".concat(tool));
        }
        dispatch({
            name: "select_ai_studio_tool",
            selectedTool: tool
        });
    };
    var pushUrl = function pushUrl(page) {
        if (true) {
            window.history.pushState("/".concat(page), "", "/".concat(page));
        }
    };
    var changeProjectsDisplay = function changeProjectsDisplay(display) {
        dispatch({
            name: "change_projects_display",
            display: display
        });
    };
    var changeDiscoverFilter = function changeDiscoverFilter(filter, q, categoryId) {
        var query = {
            filter: filter
        };
        if (q) {
            query = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, query), {
                q: q
            });
        }
        if (categoryId) {
            query = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, query), {
                categoryId: categoryId
            });
        }
        if (true) {
            var params = (0,_utils_queryfy__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(query);
            var newUrl = "/discover".concat(params);
            window.history.pushState({
                path: newUrl
            }, "", newUrl);
        }
        dispatch({
            name: "change_discover_filter",
            filter: filter,
            q: q,
            categoryId: categoryId
        });
    };
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useReducer)(dashboardReducer, createPagesData(initialData)), state = ref6[0], dispatch = ref6[1];
    var userInfo = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)().userInfo;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var _selectedSession;
    var lastMessage = (ref = state.chat.content[(_selectedSession = state.chat.selectedSession) !== null && _selectedSession !== void 0 ? _selectedSession : -1]) === null || ref === void 0 ? void 0 : (ref1 = ref.messages) === null || ref1 === void 0 ? void 0 : ref1.at(0);
    var _selectedSession1, ref7;
    var lastMessageId = (ref7 = (ref4 = (ref2 = state.chat.content[(_selectedSession1 = state.chat.selectedSession) !== null && _selectedSession1 !== void 0 ? _selectedSession1 : -1]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.messages) === null || ref3 === void 0 ? void 0 : ref3.at(0)) === null || ref4 === void 0 ? void 0 : ref4.id) !== null && ref7 !== void 0 ? ref7 : null;
    var lastResponse = (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.type) === "response" ? lastMessage : null;
    var isFirstTime = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(true);
    function selectMediaCreator(files) {
        return _selectMediaCreator.apply(this, arguments);
    }
    function _selectMediaCreator() {
        _selectMediaCreator = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(files) {
            var ref, id, newUploaded, file, isImage, imgElem, video, temporaryMessageId, temporaryMedia, extension, urls, _upload, ref1, ref2;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        id = state.chat.selectedSession;
                        if (!id) return [
                            2
                        ];
                        file = files.at(0);
                        if (!file) return [
                            2
                        ];
                        isImage = file.type.includes("image");
                        if (!isImage) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,_utils_video__WEBPACK_IMPORTED_MODULE_10__/* .getLoadedImage */ .um)(file)
                        ];
                    case 1:
                        imgElem = _state.sent();
                        newUploaded = {
                            blob: file,
                            aspect: imgElem.width / imgElem.height,
                            resource_url: URL.createObjectURL(file),
                            media_type: "image",
                            thumb_url: null
                        };
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            (0,_utils_video__WEBPACK_IMPORTED_MODULE_10__/* .getLoadedVideo */ .GF)(file)
                        ];
                    case 3:
                        video = _state.sent();
                        newUploaded = {
                            blob: file,
                            aspect: video.videoWidth / video.videoHeight,
                            resource_url: URL.createObjectURL(file),
                            thumb_url: null,
                            media_type: "video"
                        };
                        _state.label = 4;
                    case 4:
                        temporaryMessageId = Math.round(Math.random() * -1000000);
                        if (newUploaded.media_type === "video") {
                            temporaryMedia = {
                                media_type: "video",
                                resource_url: newUploaded.resource_url,
                                aspect: newUploaded.aspect,
                                thumb_url: null
                            };
                            dispatch({
                                name: "chat_add_request",
                                sessionId: id,
                                request: {
                                    name: "video",
                                    choice: temporaryMedia,
                                    index: -1
                                },
                                temporaryId: temporaryMessageId,
                                interacted_at: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_15__/* .dateToSortableString */ .nU)(new Date()),
                                started: "Today"
                            });
                        } else {
                            temporaryMedia = {
                                media_type: "image",
                                resource_url: newUploaded.resource_url,
                                aspect: newUploaded.aspect
                            };
                            dispatch({
                                name: "chat_add_request",
                                sessionId: id,
                                request: {
                                    name: "image",
                                    choice: temporaryMedia,
                                    index: -1
                                },
                                temporaryId: temporaryMessageId,
                                interacted_at: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_15__/* .dateToSortableString */ .nU)(new Date()),
                                started: "Today"
                            });
                        }
                        if (!newUploaded.blob) {
                            throw new Error("");
                        }
                        extension = _utils_upload_file__WEBPACK_IMPORTED_MODULE_9__/* .mimeTypeMapper */ .O[(ref = newUploaded.blob) === null || ref === void 0 ? void 0 : ref.type];
                        if (!extension) {
                            throw new Error("file not supported");
                        }
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_19__/* ["default"].post */ .Z.post("/api/wizard-upload", {
                                extension: extension,
                                session_id: id
                            }).then(function(r) {
                                return r.data;
                            })
                        ];
                    case 5:
                        urls = _state.sent();
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_19__/* ["default"].put */ .Z.put((_upload = urls.upload) !== null && _upload !== void 0 ? _upload : "", newUploaded.blob)
                        ];
                    case 6:
                        _state.sent();
                        if (!isImage) return [
                            3,
                            8
                        ];
                        return [
                            4,
                            sendMessage({
                                name: "media_source",
                                medias: [
                                    {
                                        media_type: "image",
                                        resource_url: (ref1 = urls === null || urls === void 0 ? void 0 : urls.download) !== null && ref1 !== void 0 ? ref1 : "",
                                        aspect: newUploaded.aspect
                                    }
                                ]
                            }, true)
                        ];
                    case 7:
                        _state.sent();
                        return [
                            3,
                            10
                        ];
                    case 8:
                        return [
                            4,
                            sendMessage({
                                name: "media_source",
                                medias: [
                                    {
                                        media_type: "video",
                                        resource_url: (ref2 = urls === null || urls === void 0 ? void 0 : urls.download) !== null && ref2 !== void 0 ? ref2 : "",
                                        aspect: newUploaded.aspect,
                                        thumb_url: null
                                    }
                                ]
                            }, true)
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            2
                        ];
                }
            });
        });
        return _selectMediaCreator.apply(this, arguments);
    }
    function uploadAndSendMedias() {
        return _uploadAndSendMedias.apply(this, arguments);
    }
    function _uploadAndSendMedias() {
        _uploadAndSendMedias = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
            var ref, ref1, id, uploadedMedias, temporaryMessageId, temporaryMedias;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        id = state.chat.selectedSession;
                        if (!id) return [
                            2
                        ];
                        uploadedMedias = (ref = state.chat.content[id]) === null || ref === void 0 ? void 0 : (ref1 = ref.uploadedMedias) === null || ref1 === void 0 ? void 0 : ref1.medias;
                        if (!uploadedMedias || uploadedMedias.length === 0) {
                            return [
                                2
                            ];
                        }
                        temporaryMessageId = Math.round(Math.random() * -1000000);
                        return [
                            4,
                            Promise.all(uploadedMedias.filter(Boolean).map(function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(m) {
                                    var ref, isVideo, _blob, videoElem, _blob1, imgElem;
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                isVideo = (ref = m.blob) === null || ref === void 0 ? void 0 : ref.type.startsWith("video");
                                                if (!isVideo) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    (0,_utils_video__WEBPACK_IMPORTED_MODULE_10__/* .getLoadedVideo */ .GF)((_blob = m.blob) !== null && _blob !== void 0 ? _blob : new Blob())
                                                ];
                                            case 1:
                                                videoElem = _state.sent();
                                                return [
                                                    2,
                                                    {
                                                        media_type: "video",
                                                        resource_url: m.resource_url,
                                                        aspect: videoElem.width / videoElem.height,
                                                        thumb_url: null
                                                    }
                                                ];
                                            case 2:
                                                return [
                                                    4,
                                                    (0,_utils_video__WEBPACK_IMPORTED_MODULE_10__/* .getLoadedImage */ .um)((_blob1 = m.blob) !== null && _blob1 !== void 0 ? _blob1 : new Blob())
                                                ];
                                            case 3:
                                                imgElem = _state.sent();
                                                return [
                                                    2,
                                                    {
                                                        media_type: "image",
                                                        resource_url: m.resource_url,
                                                        aspect: imgElem.width / imgElem.height
                                                    }
                                                ];
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(m) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 1:
                        temporaryMedias = _state.sent();
                        dispatch({
                            name: "chat_add_request",
                            sessionId: id,
                            request: {
                                name: "media_source",
                                medias: temporaryMedias
                            },
                            temporaryId: temporaryMessageId,
                            interacted_at: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_15__/* .dateToSortableString */ .nU)(new Date()),
                            started: "Today"
                        });
                        dispatch({
                            name: "chat_update_uploaded_files",
                            uploadedMedias: {
                                medias: uploadedMedias,
                                status: "uploading"
                            },
                            sessionId: id
                        });
                        return [
                            4,
                            Promise.all(uploadedMedias.filter(Boolean).map(function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(uploadedMedia) {
                                    var ref, ref1, extension, urls, ref2, isVideo, ref3, ref4;
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!uploadedMedia.blob) {
                                                    throw new Error("");
                                                }
                                                extension = _utils_upload_file__WEBPACK_IMPORTED_MODULE_9__/* .mimeTypeMapper */ .O[(ref = uploadedMedia.blob) === null || ref === void 0 ? void 0 : ref.type];
                                                if (!extension) {
                                                    throw new Error("file not supported");
                                                }
                                                return [
                                                    4,
                                                    axios__WEBPACK_IMPORTED_MODULE_19__/* ["default"].post */ .Z.post("/api/wizard-upload", {
                                                        extension: extension,
                                                        session_id: id
                                                    }).then(function(r) {
                                                        return r.data;
                                                    }).catch(function() {
                                                        return dispatch({
                                                            name: "chat_update_uploaded_files",
                                                            uploadedMedias: {
                                                                medias: uploadedMedias,
                                                                status: "fail"
                                                            },
                                                            sessionId: id
                                                        });
                                                    })
                                                ];
                                            case 1:
                                                urls = _state.sent();
                                                return [
                                                    4,
                                                    axios__WEBPACK_IMPORTED_MODULE_19__/* ["default"].put */ .Z.put((ref2 = urls === null || urls === void 0 ? void 0 : urls.upload) !== null && ref2 !== void 0 ? ref2 : "", uploadedMedia === null || uploadedMedia === void 0 ? void 0 : uploadedMedia.blob)
                                                ];
                                            case 2:
                                                _state.sent();
                                                isVideo = (ref1 = uploadedMedia.blob) === null || ref1 === void 0 ? void 0 : ref1.type.startsWith("video");
                                                if (isVideo) {
                                                    ;
                                                    return [
                                                        2,
                                                        {
                                                            media_type: "video",
                                                            resource_url: (ref3 = urls === null || urls === void 0 ? void 0 : urls.download) !== null && ref3 !== void 0 ? ref3 : "",
                                                            aspect: uploadedMedia.aspect,
                                                            thumb_url: null
                                                        }
                                                    ];
                                                } else {
                                                    ;
                                                    return [
                                                        2,
                                                        {
                                                            media_type: "image",
                                                            resource_url: (ref4 = urls === null || urls === void 0 ? void 0 : urls.download) !== null && ref4 !== void 0 ? ref4 : "",
                                                            aspect: uploadedMedia.aspect
                                                        }
                                                    ];
                                                }
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(uploadedMedia) {
                                    return _ref.apply(this, arguments);
                                };
                            }())).then(function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(medias) {
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    sendMessage({
                                                        name: "media_source",
                                                        medias: medias
                                                    }, true).then(function() {
                                                        return dispatch({
                                                            name: "chat_update_uploaded_files",
                                                            uploadedMedias: {
                                                                medias: uploadedMedias,
                                                                status: "done"
                                                            },
                                                            sessionId: id
                                                        });
                                                    })
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                        }
                                    });
                                });
                                return function(medias) {
                                    return _ref.apply(this, arguments);
                                };
                            }())
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _uploadAndSendMedias.apply(this, arguments);
    }
    function populateSession(id) {
        return _populateSession.apply(this, arguments);
    }
    function _populateSession() {
        _populateSession = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(id) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_19__/* ["default"].post */ .Z.post("/api/wizard-list-chat", {
                                session_id: id
                            }).then(function(r) {
                                var updatedMessages = r.data;
                                var errorType = undefined;
                                if (updatedMessages.session_status === "error") {
                                    errorType = "unknown";
                                } else if (updatedMessages.session_status === "retryable_error") {
                                    errorType = "retry";
                                }
                                dispatch({
                                    id: id,
                                    name: "chat_populate_messages",
                                    sessionStatus: updatedMessages.session_status,
                                    messages: updatedMessages.messages,
                                    sessionName: updatedMessages.session_name,
                                    sessionInteractedAt: updatedMessages.session_interacted_at,
                                    errorType: errorType
                                });
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _populateSession.apply(this, arguments);
    }
    var profilePicture = userInfo.details.profilePic;
    function renameSession(id, newName) {
        return _renameSession.apply(this, arguments);
    }
    function _renameSession() {
        _renameSession = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(id, newName) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch({
                            name: "chat_change_session_name",
                            sessionId: id,
                            newName: newName
                        });
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_19__/* ["default"].post */ .Z.post("/api/wizard-rename-session", {
                                session_id: id,
                                name: newName
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _renameSession.apply(this, arguments);
    }
    function remakeSession(id) {
        return _remakeSession.apply(this, arguments);
    }
    function _remakeSession() {
        _remakeSession = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(id) {
            var temporaryId;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        temporaryId = Math.round(Math.random() * -1000000);
                        dispatch({
                            name: "chat_add_new_session",
                            newSession: {
                                id: temporaryId,
                                name: "New Session",
                                interacted_at: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_15__/* .dateToSortableString */ .nU)(new Date()),
                                started: "Today",
                                messages: [],
                                status: "client-loading",
                                uploadedMedias: {
                                    medias: [],
                                    status: "idle"
                                },
                                thumbnail_url: null
                            }
                        });
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_19__/* ["default"].post */ .Z.post("/api/wizard-remake-session", {
                                session_id: id
                            }).then(function(response) {
                                var newSession = {
                                    id: response.data.id,
                                    name: response.data.name,
                                    started: getDateCategory(response.data.interacted_at),
                                    status: response.data.status,
                                    interacted_at: response.data.interacted_at,
                                    messages: response.data.messages.map(function(m) {
                                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, m), {
                                            fakeId: m.id
                                        });
                                    }).reverse(),
                                    uploadedMedias: {
                                        medias: [],
                                        status: "idle"
                                    },
                                    thumbnail_url: null
                                };
                                dispatch({
                                    name: "chat_change_temp_session",
                                    newSession: newSession,
                                    temporaryId: temporaryId
                                });
                                pushSessionUrl(response.data.id);
                            }).catch(function(e) {
                                if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(e, axios__WEBPACK_IMPORTED_MODULE_21__/* .AxiosError */ .d7)) {
                                    getErrorMessage(e, temporaryId);
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _remakeSession.apply(this, arguments);
    }
    function deleteSession(id) {
        return _deleteSession.apply(this, arguments);
    }
    function _deleteSession() {
        _deleteSession = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(id) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch({
                            name: "chat_delete_session",
                            sessionId: id
                        });
                        if (state.chat.selectedSession === id) {
                            clearChatScreen();
                        }
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_19__/* ["default"].post */ .Z.post("/api/wizard-delete-session", {
                                session_id: id
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _deleteSession.apply(this, arguments);
    }
    var pushSessionUrl = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function(id) {
        var query = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, router.query), {
            session_id: id
        });
        var params = Object.entries(query).map(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
            if (key !== "initial_message" && key !== "feature") {
                if (id) {
                    return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
                }
            }
        }).join("&");
        router.push("/chat?".concat(params));
    }, [
        router
    ]);
    function selectSession(id) {
        return _selectSession.apply(this, arguments);
    }
    function _selectSession() {
        _selectSession = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(id) {
            var selectedSession, isRealId;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (state.activePage !== "chat") {
                            changeSelectedPage("chat");
                        }
                        selectedSession = state.chat.content[id];
                        if (!selectedSession) {
                            console.error("How did you do this?");
                            return [
                                2
                            ];
                        }
                        dispatch({
                            name: "chat_select_session",
                            sessionId: id
                        });
                        isRealId = id > 0;
                        if (isRealId) {
                            pushSessionUrl(id);
                        }
                        if (selectedSession.status === "waiting") {
                            sendMessage({
                                name: "continue"
                            }, true, id);
                        }
                        if (!!(selectedSession === null || selectedSession === void 0 ? void 0 : selectedSession.messages)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            populateSession(id)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return _selectSession.apply(this, arguments);
    }
    function loadMoreSessions(offset) {
        return _loadMoreSessions.apply(this, arguments);
    }
    function _loadMoreSessions() {
        _loadMoreSessions = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(offset) {
            var result;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getChatSessions(offset)
                        ];
                    case 1:
                        result = _state.sent();
                        if (state.activePage === "videoGpt") {
                            dispatch({
                                name: "add_video_gpt_content",
                                newContent: result.map(function(session) {
                                    return {
                                        id: session.id,
                                        name: session.name,
                                        interacted_at: session.interacted_at,
                                        thumbnail_url: session.thumbnail_url,
                                        messages: session.messages,
                                        uploadedMedias: session.uploadedMedias,
                                        started: session.started,
                                        status: session.status
                                    };
                                })
                            });
                        } else if (state.activePage === "chat") {
                            dispatch({
                                name: "chat_add_new_group",
                                newSessions: result
                            });
                        }
                        return [
                            2,
                            result.map(function(x) {
                                return x.id;
                            })
                        ];
                }
            });
        });
        return _loadMoreSessions.apply(this, arguments);
    }
    function getChatSessions(offset) {
        return _getChatSessions.apply(this, arguments);
    }
    function _getChatSessions() {
        _getChatSessions = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(offset) {
            var result;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_19__/* ["default"].get */ .Z.get("/api/wizard-list-sessions", {
                                params: {
                                    offset: offset,
                                    limit: SESSION_LIMIT
                                }
                            }).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        return _getChatSessions.apply(this, arguments);
    }
    var pendingSessions = Object.values(state.chat.content).filter(function(session) {
        return (session === null || session === void 0 ? void 0 : session.status) === "visualizing";
    }).map(function(filteredSession) {
        return filteredSession === null || filteredSession === void 0 ? void 0 : filteredSession.id;
    }).filter(Boolean);
    function checkSessionStatuses() {
        return _checkSessionStatuses.apply(this, arguments);
    }
    function _checkSessionStatuses() {
        _checkSessionStatuses = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
            var statuses, updatedSessions;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (pendingSessions.length === 0) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_19__/* ["default"].post */ .Z.post("/api/wizard-job-statuses", {
                                session_ids: pendingSessions
                            }).then(function(r) {
                                return r.data;
                            })
                        ];
                    case 1:
                        statuses = _state.sent().statuses;
                        updatedSessions = statuses.filter(function(s) {
                            var ref;
                            return s.status === "completed" && ((ref = state.chat.content[s.session_id]) === null || ref === void 0 ? void 0 : ref.status) !== "deleted";
                        }).map(function(s) {
                            return s.session_id;
                        });
                        dispatch({
                            name: "chat_update_sessions",
                            updatedSessions: updatedSessions
                        });
                        if (state.chat.selectedSession && updatedSessions.includes(state.chat.selectedSession)) {
                            sendMessage({
                                name: "continue"
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _checkSessionStatuses.apply(this, arguments);
    }
    (0,react_query__WEBPACK_IMPORTED_MODULE_7__.useQuery)({
        queryKey: [
            "visualizing-check",
            pendingSessions
        ],
        queryFn: checkSessionStatuses,
        refetchInterval: 5000,
        enabled: pendingSessions.length > 0
    });
    var _selectedSession2;
    var selectedSession = state.chat.selectedSession ? (_selectedSession2 = state.chat.content[state.chat.selectedSession]) !== null && _selectedSession2 !== void 0 ? _selectedSession2 : null : null;
    var isActiveSessionGeneratingOrLoading = (selectedSession === null || selectedSession === void 0 ? void 0 : selectedSession.status) === "generating" || (selectedSession === null || selectedSession === void 0 ? void 0 : selectedSession.status) === "loading" || (selectedSession === null || selectedSession === void 0 ? void 0 : selectedSession.status) === "waiting" || (selectedSession === null || selectedSession === void 0 ? void 0 : selectedSession.status) === "analyzing" || (lastResponse === null || lastResponse === void 0 ? void 0 : lastResponse.name) === "visualizing" || (lastResponse === null || lastResponse === void 0 ? void 0 : lastResponse.name) === "generating" || (lastResponse === null || lastResponse === void 0 ? void 0 : lastResponse.name) === "analyzing";
    (0,react_query__WEBPACK_IMPORTED_MODULE_7__.useQuery)({
        queryKey: [
            "generating-check",
            isActiveSessionGeneratingOrLoading,
            state.chat.selectedSession, 
        ],
        queryFn: checkListChatWhenGenerating(),
        refetchInterval: 5000,
        enabled: isActiveSessionGeneratingOrLoading
    });
    function duplicateSession() {
        return _duplicateSession.apply(this, arguments);
    }
    function _duplicateSession() {
        _duplicateSession = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
            var id, session, name, temporaryId;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        id = state.chat.selectedSession;
                        if (!id) return [
                            2
                        ];
                        session = state.chat.content[id];
                        if (!session) {
                            return [
                                2
                            ];
                        }
                        name = session.name;
                        if (name !== "New Session") {
                            name += " (copy)";
                        }
                        temporaryId = Math.round(Math.random() * -1000000);
                        dispatch({
                            name: "chat_add_new_session",
                            newSession: {
                                id: temporaryId,
                                name: name,
                                interacted_at: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_15__/* .dateToSortableString */ .nU)(new Date()),
                                started: "Today",
                                messages: [],
                                status: "client-loading",
                                uploadedMedias: {
                                    medias: [],
                                    status: "idle"
                                },
                                thumbnail_url: null
                            }
                        });
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_19__/* ["default"].post */ .Z.post("/api/wizard-duplicate-session", {
                                session_id: id
                            }).then(function(response) {
                                var messages = response.data.messages.map(function(m) {
                                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, m), {
                                        fakeId: m.id
                                    });
                                }).reverse();
                                if (messages.length !== 0) {
                                    dispatch({
                                        name: "chat_change_temp_session",
                                        newSession: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, response.data), {
                                            messages: messages,
                                            started: "Today",
                                            uploadedMedias: {
                                                medias: [],
                                                status: "idle"
                                            },
                                            thumbnail_url: null
                                        }),
                                        temporaryId: temporaryId
                                    });
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _duplicateSession.apply(this, arguments);
    }
    function resetSession(next) {
        return _resetSession.apply(this, arguments);
    }
    function _resetSession() {
        _resetSession = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(next) {
            var id;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        id = state.chat.selectedSession;
                        if (!id) return [
                            2
                        ];
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_19__/* ["default"].post */ .Z.post("/api/wizard-reset-session", {
                                next: next,
                                session_id: id
                            }).then(function(response) {
                                var messages = response.data.messages.map(function(m) {
                                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, m), {
                                        fakeId: m.id
                                    });
                                }).reverse();
                                if (messages.length !== 0) {
                                    dispatch({
                                        name: "chat_reset_session",
                                        messages: messages,
                                        sessionId: id,
                                        status: response.data.status
                                    });
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _resetSession.apply(this, arguments);
    }
    var getErrorMessage = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(e, id, temporaryMessageId) {
            var ref, status;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        status = (ref = e.response) === null || ref === void 0 ? void 0 : ref.status;
                        switch(status){
                            case 430:
                                return [
                                    3,
                                    1
                                ];
                            case 412:
                                return [
                                    3,
                                    3
                                ];
                            case 431:
                                return [
                                    3,
                                    4
                                ];
                            case 432:
                                return [
                                    3,
                                    5
                                ];
                        }
                        return [
                            3,
                            6
                        ];
                    case 1:
                        return [
                            4,
                            populateSession(id).catch(function() {
                                return console.error("couldnt refresh");
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 3:
                        dispatch({
                            name: "chat_set_session_status",
                            sessionId: id,
                            sessionStatus: "retryable_error",
                            errorType: "retry",
                            temporaryMessageId: temporaryMessageId
                        });
                        return [
                            3,
                            7
                        ];
                    case 4:
                        dispatch({
                            name: "chat_set_session_status",
                            sessionId: id,
                            sessionStatus: "error",
                            errorType: "upgrade"
                        });
                        return [
                            3,
                            7
                        ];
                    case 5:
                        dispatch({
                            name: "chat_set_session_status",
                            sessionId: id,
                            sessionStatus: "error",
                            errorType: "upgrade-tokens"
                        });
                        return [
                            3,
                            7
                        ];
                    case 6:
                        dispatch({
                            name: "chat_set_session_status",
                            sessionId: id,
                            sessionStatus: "error",
                            errorType: "unknown"
                        });
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function(e, id, temporaryMessageId) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var setHomeState = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(state.home.content.length !== 0)) return [
                        3,
                        1
                    ];
                    dispatch({
                        name: "home_state",
                        history: state.home.content,
                        filter: state.home.filter
                    });
                    return [
                        3,
                        3
                    ];
                case 1:
                    dispatch({
                        name: "home_state",
                        history: []
                    });
                    return [
                        4,
                        (0,sections_history_generations__WEBPACK_IMPORTED_MODULE_8__/* .fetchVideos */ .WI)([
                            "deform",
                            "ai_restyle",
                            "ai_photo",
                            "text_to_image",
                            "text_to_video"
                        ], 0).then(function(r) {
                            return dispatch({
                                name: "home_state",
                                history: r
                            });
                        })
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        state.home.content,
        state.home.filter
    ]);
    var setDiscoverState = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
        var ref, availableFiltersGallery, availableFiltersTemplates;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all([
                            axios__WEBPACK_IMPORTED_MODULE_19__/* ["default"].get */ .Z.get("/api/gallery-filters").then(function(r) {
                                return r.data;
                            }),
                            axios__WEBPACK_IMPORTED_MODULE_19__/* ["default"].get */ .Z.get("/api/tutorial-filters").then(function(r) {
                                return r.data;
                            })
                        ])
                    ];
                case 1:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), availableFiltersGallery = ref[0], availableFiltersTemplates = ref[1];
                    dispatch({
                        name: "discover_state",
                        availableFiltersGallery: availableFiltersGallery,
                        availableFiltersTemplates: availableFiltersTemplates
                    });
                    return [
                        2
                    ];
            }
        });
    }), []);
    var setChatState = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
        var sessions;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(state.chat.sessionsGroup.length !== 0)) return [
                        3,
                        1
                    ];
                    dispatch({
                        name: "chat_state",
                        content: state.chat.content
                    });
                    return [
                        3,
                        4
                    ];
                case 1:
                    if (!(state.videoGpt.content.length !== 0)) return [
                        3,
                        2
                    ];
                    dispatch({
                        name: "chat_state",
                        content: createSessionsRecord(state.videoGpt.content)
                    });
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        getChatSessions(0)
                    ];
                case 3:
                    sessions = _state.sent();
                    dispatch({
                        name: "chat_state",
                        content: sessions
                    });
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        state.chat.content,
        state.chat.sessionsGroup.length,
        state.videoGpt.content, 
    ]);
    function getPopupsData() {
        return _getPopupsData.apply(this, arguments);
    }
    function _getPopupsData() {
        _getPopupsData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_19__/* ["default"].get */ .Z.get("/api/wizard-get-inputs").then(function(r) {
                                return r.data;
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _getPopupsData.apply(this, arguments);
    }
    function getCaptionsData() {
        return _getCaptionsData.apply(this, arguments);
    }
    function _getCaptionsData() {
        _getCaptionsData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_19__/* ["default"].post */ .Z.post("/api/caption-templates", {
                                offset: 0,
                                limit: 40
                            }).then(function(r) {
                                return r.data;
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _getCaptionsData.apply(this, arguments);
    }
    var setVideoGptState = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
        var projectList, ref, popupsData, captions;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(state.videoGpt.content.length !== 0)) return [
                        3,
                        1
                    ];
                    dispatch({
                        name: "video_gpt_state",
                        projectList: state.videoGpt.content
                    });
                    return [
                        3,
                        3
                    ];
                case 1:
                    return [
                        4,
                        getChatSessions(0)
                    ];
                case 2:
                    projectList = _state.sent();
                    dispatch({
                        name: "video_gpt_state",
                        projectList: projectList.map(function(session) {
                            return {
                                id: session.id,
                                name: session.name,
                                messages: null,
                                status: session.status,
                                started: session.started,
                                interacted_at: session.interacted_at,
                                uploadedMedias: session.uploadedMedias,
                                thumbnail_url: session.thumbnail_url
                            };
                        })
                    });
                    _state.label = 3;
                case 3:
                    if (!(state.videoGpt.popupsData === null)) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        Promise.all([
                            getPopupsData(),
                            getCaptionsData()
                        ])
                    ];
                case 4:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), popupsData = ref[0], captions = ref[1];
                    dispatch({
                        name: "load_popups_data",
                        data: popupsData,
                        captions: captions
                    });
                    _state.label = 5;
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        state.videoGpt.content,
        state.videoGpt.popupsData
    ]);
    var changeSelectedPage = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(pageName) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(pageName){
                    case "home":
                        pushUrl("home");
                        setHomeState();
                        break;
                    case "videoGpt":
                        pushUrl("video-gpt");
                        setVideoGptState();
                        break;
                    case "chat":
                        pushUrl("chat");
                        setChatState();
                        break;
                    case "discover":
                        pushUrl("discover");
                        setDiscoverState();
                        break;
                }
                return [
                    2
                ];
            });
        });
        return function(pageName) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setVideoGptState,
        setChatState,
        setHomeState,
        setDiscoverState, 
    ]);
    var startNewSession = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(options, inputs) {
            var isDebug, temporaryId, temporaryMessageId, messages, ref, ref1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (state.activePage !== "chat") {
                            changeSelectedPage("chat");
                        }
                        isDebug = process.env.NEXT_PUBLIC_DEBUG === "true";
                        temporaryId = Math.round(Math.random() * -1000000);
                        temporaryMessageId = Math.round(Math.random() * -1000000);
                        messages = [];
                        if (options.initial_message) {
                            messages.push({
                                id: temporaryMessageId,
                                sent_at: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_15__/* .dateToSortableString */ .nU)(new Date()),
                                type: "request",
                                name: "text",
                                message: options.initial_message
                            });
                        } else if (inputs) {
                            if (inputs.message.type === "medias") {
                                messages.push({
                                    id: temporaryMessageId,
                                    sent_at: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_15__/* .dateToSortableString */ .nU)(new Date()),
                                    type: "request",
                                    name: "media_source",
                                    medias: inputs.message.resources
                                });
                            } else {
                                messages.push({
                                    id: temporaryMessageId,
                                    sent_at: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_15__/* .dateToSortableString */ .nU)(new Date()),
                                    type: "request",
                                    name: "text",
                                    message: inputs.message.content
                                });
                            }
                        }
                        dispatch({
                            name: "chat_add_new_session",
                            newSession: {
                                id: temporaryId,
                                name: "New Session",
                                interacted_at: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_15__/* .dateToSortableString */ .nU)(new Date()),
                                started: "Today",
                                messages: messages,
                                status: "client-loading",
                                uploadedMedias: {
                                    medias: [],
                                    status: "idle"
                                },
                                thumbnail_url: null
                            }
                        });
                        if (!inputs) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_19__/* ["default"].post */ .Z.post("/api/wizard-start-session-with-inputs", inputs).then(function(response) {
                                var newSession = {
                                    id: response.data.id,
                                    name: response.data.name,
                                    started: getDateCategory(response.data.interacted_at),
                                    status: response.data.status,
                                    interacted_at: response.data.interacted_at,
                                    messages: response.data.messages.map(function(m) {
                                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, m), {
                                            fakeId: m.id
                                        });
                                    }).reverse(),
                                    uploadedMedias: {
                                        medias: [],
                                        status: "idle"
                                    },
                                    thumbnail_url: null
                                };
                                dispatch({
                                    name: "chat_change_temp_session",
                                    newSession: newSession,
                                    temporaryId: temporaryId
                                });
                                if (state.chat.selectedSession === null && state.activePage === "chat") {
                                    pushSessionUrl(response.data.id);
                                }
                            }).catch(function(e) {
                                if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(e, axios__WEBPACK_IMPORTED_MODULE_21__/* .AxiosError */ .d7)) {
                                    getErrorMessage(e, temporaryId);
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_19__/* ["default"].post */ .Z.post("/api/wizard-start-session", {
                                context: {
                                    website_url: options.website_url,
                                    initial_message: options.initial_message
                                },
                                group: (ref1 = (ref = state.chat.group) === null || ref === void 0 ? void 0 : ref.id) !== null && ref1 !== void 0 ? ref1 : null,
                                tag: isDebug || state.chat.group ? "test" : null
                            }).then(function(response) {
                                var newSession = {
                                    id: response.data.id,
                                    name: response.data.name,
                                    started: getDateCategory(response.data.interacted_at),
                                    status: response.data.status,
                                    interacted_at: response.data.interacted_at,
                                    messages: response.data.messages.map(function(m) {
                                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, m), {
                                            fakeId: m.id
                                        });
                                    }).reverse(),
                                    uploadedMedias: {
                                        medias: [],
                                        status: "idle"
                                    },
                                    thumbnail_url: null
                                };
                                dispatch({
                                    name: "chat_change_temp_session",
                                    newSession: newSession,
                                    temporaryId: temporaryId
                                });
                                if (state.chat.selectedSession === null) {
                                    pushSessionUrl(response.data.id);
                                }
                            }).catch(function(e) {
                                if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(e, axios__WEBPACK_IMPORTED_MODULE_21__/* .AxiosError */ .d7)) {
                                    getErrorMessage(e, temporaryId);
                                }
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(options, inputs) {
            return _ref.apply(this, arguments);
        };
    }(), [
        state.activePage,
        state.chat.selectedSession,
        state.chat.group,
        changeSelectedPage,
        pushSessionUrl,
        getErrorMessage, 
    ]);
    function retrySession() {
        return _retrySession.apply(this, arguments);
    }
    function _retrySession() {
        _retrySession = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
            var ref, ref1, _selectedSession, lastMessage, lastMessageId, changedStatus;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!state.chat.selectedSession) return [
                            2
                        ];
                        lastMessage = (ref = state.chat.content[(_selectedSession = state.chat.selectedSession) !== null && _selectedSession !== void 0 ? _selectedSession : -1]) === null || ref === void 0 ? void 0 : ref.messages;
                        if (!lastMessage) return [
                            2
                        ];
                        lastMessageId = (ref1 = lastMessage.at(0)) === null || ref1 === void 0 ? void 0 : ref1.id;
                        if (!lastMessageId) return [
                            2
                        ];
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_19__/* ["default"].post */ .Z.post("/api/wizard-retry-session", {
                                session_id: state.chat.selectedSession
                            }).then(function(r) {
                                return r.data.status;
                            })
                        ];
                    case 1:
                        changedStatus = _state.sent();
                        dispatch({
                            name: "chat_retry_session",
                            sessionId: state.chat.selectedSession,
                            temporaryMessageId: lastMessageId,
                            status: changedStatus
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _retrySession.apply(this, arguments);
    }
    function sendMessage(request, dontAddRequest, sessionId) {
        return _sendMessage.apply(this, arguments);
    }
    function _sendMessage() {
        _sendMessage = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(request, dontAddRequest, sessionId) {
            var ref, ref1, ref2, id, sessionStatus, lastMessage, lastMessageId, lastMessageType, isDebug, payload, temporaryId;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!state.chat.selectedSession) {
                            console.error("State is null and you are trying to send message");
                            return [
                                2
                            ];
                        }
                        id = sessionId !== null && sessionId !== void 0 ? sessionId : state.chat.selectedSession;
                        sessionStatus = (ref = state.chat.content[id]) === null || ref === void 0 ? void 0 : ref.status;
                        if (sessionStatus === "deleted") return [
                            2
                        ];
                        lastMessage = (ref1 = state.chat.content[id]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.messages) === null || ref2 === void 0 ? void 0 : ref2.at(0);
                        lastMessageId = lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.id;
                        lastMessageType = lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.type;
                        if (lastMessageId === undefined || lastMessageType === "request") {
                            return [
                                2
                            ];
                        }
                        isDebug = process.env.NEXT_PUBLIC_DEBUG === "true";
                        payload = {
                            session_id: id,
                            request: request,
                            last_response_id: lastMessageId,
                            tag: isDebug || state.chat.group ? "test" : null
                        };
                        temporaryId = Math.random() * -1000000;
                        if (!dontAddRequest) {
                            dispatch({
                                name: "chat_add_request",
                                request: request,
                                temporaryId: temporaryId,
                                sessionId: id,
                                interacted_at: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_15__/* .dateToSortableString */ .nU)(new Date()),
                                started: "Today"
                            });
                        }
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_19__/* ["default"].post */ .Z.post("/api/wizard-send-message", payload, {
                                timeout: 120000
                            }).then(function(r) {
                                dispatch({
                                    name: "chat_add_response",
                                    sessionId: id,
                                    status: r.data.session_status,
                                    response: r.data.response,
                                    responseId: r.data.response.id,
                                    sentAt: r.data.response.sent_at,
                                    requestUpdate: {
                                        id: temporaryId,
                                        realId: r.data.request.id,
                                        sentAt: r.data.request.sent_at
                                    },
                                    sessionNameChanged: r.data.session_name_changed,
                                    newSessionName: r.data.new_session_name
                                });
                                dispatch({
                                    name: "chat_set_session_status",
                                    sessionId: id,
                                    sessionStatus: r.data.session_status
                                });
                            }).catch(function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(e) {
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                                        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(e, axios__WEBPACK_IMPORTED_MODULE_21__/* .AxiosError */ .d7)) {
                                            getErrorMessage(e, id, temporaryId);
                                        }
                                        return [
                                            2
                                        ];
                                    });
                                });
                                return function(e) {
                                    return _ref.apply(this, arguments);
                                };
                            }())
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _sendMessage.apply(this, arguments);
    }
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        if (initialData.name === "chat" && initialData.initialPage.initialMessage && isFirstTime.current) {
            isFirstTime.current = false;
            var message = initialData.initialPage.initialMessage;
            var context = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_22__/* .isStringUrl */ .b)(message);
            startNewSession(context, null);
        }
    }, [
        initialData.initialPage,
        initialData.name,
        startNewSession, 
    ]);
    function refetchNewJobs(limit) {
        return _refetchNewJobs.apply(this, arguments);
    }
    function _refetchNewJobs() {
        _refetchNewJobs = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(limit) {
            var filter, newContent;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        filter = [
                            "deform",
                            "ai_restyle",
                            "ai_photo",
                            "text_to_image",
                            "text_to_video"
                        ];
                        if (state.activePage === "home") {
                            filter = state.home.filter;
                        }
                        return [
                            4,
                            (0,sections_history_generations__WEBPACK_IMPORTED_MODULE_8__/* .fetchVideos */ .WI)(filter, 0, limit)
                        ];
                    case 1:
                        newContent = _state.sent();
                        dispatch({
                            name: "add_ai_studio_content_from_start",
                            newContent: newContent
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _refetchNewJobs.apply(this, arguments);
    }
    var inProgressJobIds = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)([]);
    var lastQuery = (0,react_query__WEBPACK_IMPORTED_MODULE_7__.useQuery)({
        queryFn: sections_history_generations__WEBPACK_IMPORTED_MODULE_8__/* .fetchLast */ .Yx,
        queryKey: [
            "deforum-last",
            "user",
            "pro"
        ],
        refetchInterval: sections_history_generations__WEBPACK_IMPORTED_MODULE_8__/* .STATUS_UPDATE_MILLIS */ .f2,
        onSuccess: function onSuccess(data) {
            if (!data) {
                return;
            }
            var newIds = new Set(data.map(function(param) {
                var id = param.id;
                return id;
            }));
            var jobNotInProgress = inProgressJobIds.current.filter(function(inProgressJobId) {
                return !newIds.has(inProgressJobId);
            }).length;
            if (jobNotInProgress !== 0) {
                refetchNewJobs(jobNotInProgress);
            }
            inProgressJobIds.current = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(newIds.values());
        }
    });
    var _length;
    var currentRunningJobs = (_length = (ref5 = lastQuery.data) === null || ref5 === void 0 ? void 0 : ref5.filter(function(job) {
        return job.status === "in-queue" || job.status === "in-progress";
    }).length) !== null && _length !== void 0 ? _length : -1;
    var hasConcurrentJobs = (0,_utils_client_auth__WEBPACK_IMPORTED_MODULE_0__/* .getUserEntitlements */ .xx)(userInfo.entitlements).hasConcurrentJobs;
    var canTryAgain = currentRunningJobs < (0,sections_history_generations__WEBPACK_IMPORTED_MODULE_8__/* .getConcurrentJobCount */ .Re)(hasConcurrentJobs);
    function deleteHistoryItem(id) {
        return _deleteHistoryItem.apply(this, arguments);
    }
    function _deleteHistoryItem() {
        _deleteHistoryItem = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(id) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch({
                            name: "delete_history_item",
                            id: id
                        });
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_19__/* ["default"].post */ .Z.post("/api/deforum-delete", {
                                id: id
                            }).catch(function() {
                                return console.error("cant delete");
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _deleteHistoryItem.apply(this, arguments);
    }
    function loadMoreHistoryContent(offset) {
        return _loadMoreHistoryContent.apply(this, arguments);
    }
    function _loadMoreHistoryContent() {
        _loadMoreHistoryContent = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(offset) {
            var filter, result;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        filter = [
                            "deform",
                            "ai_restyle",
                            "ai_photo",
                            "text_to_image",
                            "text_to_video"
                        ];
                        if (state.activePage === "home") {
                            filter = state.home.filter;
                        }
                        return [
                            4,
                            (0,sections_history_generations__WEBPACK_IMPORTED_MODULE_8__/* .fetchVideos */ .WI)(filter, offset)
                        ];
                    case 1:
                        result = _state.sent();
                        dispatch({
                            name: "add_ai_studio_content",
                            newContent: result
                        });
                        return [
                            2,
                            result.map(function(x) {
                                return x.id;
                            })
                        ];
                }
            });
        });
        return _loadMoreHistoryContent.apply(this, arguments);
    }
    var chatController = {
        clearChatScreen: clearChatScreen,
        changeShowRatingValue: changeShowRatingValue,
        lastMessageId: lastMessageId,
        selectMediaCreator: selectMediaCreator,
        retrySession: retrySession,
        remakeSession: remakeSession,
        resetSession: resetSession,
        duplicateSession: duplicateSession,
        initializaeUploadedMedias: initializaeUploadedMedias,
        appendFileCreator: appendFileCreator,
        removeUploadedFile: removeUploadedFile,
        uploadAndSendMedias: uploadAndSendMedias,
        enterShortCut: enterShortCut,
        profilePicture: profilePicture,
        lastResponse: lastResponse,
        sendMessage: sendMessage,
        deleteSession: deleteSession,
        renameSession: renameSession,
        loadMoreSessions: loadMoreSessions,
        startNewSession: startNewSession,
        selectSession: selectSession
    };
    return {
        changeSelectedPage: changeSelectedPage,
        deleteHistoryItem: deleteHistoryItem,
        changeProjectsDisplay: changeProjectsDisplay,
        selectAiStudioTool: selectAiStudioTool,
        changeDiscoverFilter: changeDiscoverFilter,
        home: state.home,
        videoGpt: state.videoGpt,
        chat: state.chat,
        discover: state.discover,
        activePage: state.activePage,
        loadMoreHistoryContent: loadMoreHistoryContent,
        activeChild: state.activeChild,
        changeActiveChild: changeActiveChild,
        lastQuery: lastQuery,
        canTryAgain: canTryAgain,
        chatController: chatController
    };
}
function filterAndConcatHistory(oldContent, newContent, newContentFromBeginning) {
    var newContentIds = new Set(newContent.map(function(param) {
        var id = param.id;
        return id;
    }));
    var oldContentFiltered = oldContent.filter(function(old) {
        return !newContentIds.has(old.id);
    });
    if (newContentFromBeginning) {
        var _endTime, _endTime1;
        return newContent.concat(oldContentFiltered).sort(function(a, b) {
            return new Date(new Date((_endTime = b.endTime) !== null && _endTime !== void 0 ? _endTime : new Date())).getTime() - new Date(new Date((_endTime1 = a.endTime) !== null && _endTime1 !== void 0 ? _endTime1 : new Date())).getTime();
        });
    } else {
        var _endTime2, _endTime3;
        return oldContentFiltered.concat(newContent).sort(function(a, b) {
            return new Date(new Date((_endTime2 = b.endTime) !== null && _endTime2 !== void 0 ? _endTime2 : new Date())).getTime() - new Date(new Date((_endTime3 = a.endTime) !== null && _endTime3 !== void 0 ? _endTime3 : new Date())).getTime();
        });
    }
}
function removeIfExist(oldContent, newContent) {
    var sessionMap = new Map();
    oldContent.forEach(function(session) {
        sessionMap.set(session.id, session);
    });
    newContent.forEach(function(session) {
        sessionMap.set(session.id, session);
    });
    var result = Array.from(sessionMap.values()).sort(function(a, b) {
        return new Date(new Date(b.interacted_at)).getTime() - new Date(new Date(a.interacted_at)).getTime();
    });
    return result;
}
function createPagesData(initialData) {
    var initialPage = initialData.initialPage, name = initialData.name;
    var emptyChat = {
        content: [],
        sessionsGroup: [],
        selectedSession: null,
        initialInputs: null,
        initialMessage: null,
        group: null
    };
    var emptyHome = {
        content: [],
        projectsDisplay: "column",
        text: "",
        popupsData: null
    };
    var emptyDiscover = {
        content: {
            initialGallery: null,
            initialFiltersGallery: null,
            initialTemplates: null,
            initialFiltersTemplates: null,
            initialAdExamples: null,
            initialFiltersAdExamples: null,
            availableFiltersGallery: null,
            availableFiltersTemplates: null
        },
        filter: "ad-examples",
        q: null,
        categoryId: null
    };
    var emptyAiStudio = {
        content: [],
        filter: [
            "deform",
            "ai_restyle",
            "ai_photo",
            "text_to_image",
            "text_to_video", 
        ],
        selectedTool: null
    };
    switch(name){
        case "home":
            return {
                activePage: "home",
                activeChild: null,
                home: initialPage,
                videoGpt: emptyHome,
                discover: emptyDiscover,
                chat: emptyChat
            };
        case "videoGpt":
            return {
                activePage: "videoGpt",
                activeChild: null,
                home: emptyAiStudio,
                videoGpt: initialPage,
                chat: {
                    content: createSessionsRecord(initialPage.content),
                    sessionsGroup: [],
                    selectedSession: null,
                    initialInputs: null,
                    initialMessage: null,
                    group: null
                },
                discover: emptyDiscover
            };
        case "chat":
            return {
                activePage: "chat",
                activeChild: null,
                chat: {
                    content: initialPage.content,
                    sessionsGroup: initialPage.sessionsGroup,
                    selectedSession: initialPage.selectedSession,
                    initialInputs: initialPage.initialInputs,
                    initialMessage: initialPage.initialMessage,
                    group: initialPage.group
                },
                discover: emptyDiscover,
                home: emptyAiStudio,
                videoGpt: emptyHome
            };
        case "discover":
            return {
                activePage: "discover",
                activeChild: null,
                discover: initialPage,
                chat: emptyChat,
                home: emptyAiStudio,
                videoGpt: emptyHome
            };
    }
}
function extractSessionsToGroups(newSessions, existingGroups) {
    var ref, ref1, ref2, ref3;
    var sessionSet = new Set();
    var existingTodayGroup = (ref = existingGroups.find(function(g) {
        return g.started === "Today";
    })) === null || ref === void 0 ? void 0 : ref.sessions;
    var todayGroup = createGroup("Today", newSessions, existingTodayGroup !== null && existingTodayGroup !== void 0 ? existingTodayGroup : [], sessionSet);
    var existingThisWeekGroup = (ref1 = existingGroups.find(function(g) {
        return g.started === "This week";
    })) === null || ref1 === void 0 ? void 0 : ref1.sessions;
    var thisWeekGroup = createGroup("This week", newSessions, existingThisWeekGroup !== null && existingThisWeekGroup !== void 0 ? existingThisWeekGroup : [], sessionSet);
    var existingThisMonthGroup = (ref2 = existingGroups.find(function(g) {
        return g.started === "This month";
    })) === null || ref2 === void 0 ? void 0 : ref2.sessions;
    var thisMonthGroup = createGroup("This month", newSessions, existingThisMonthGroup !== null && existingThisMonthGroup !== void 0 ? existingThisMonthGroup : [], sessionSet);
    var existingThisYearGroup = (ref3 = existingGroups.find(function(g) {
        return g.started === "This year";
    })) === null || ref3 === void 0 ? void 0 : ref3.sessions;
    var thisYearGroup = createGroup("This year", newSessions, existingThisYearGroup !== null && existingThisYearGroup !== void 0 ? existingThisYearGroup : [], sessionSet);
    var resultSesionsGroups = [
        todayGroup,
        thisWeekGroup,
        thisMonthGroup,
        thisYearGroup, 
    ];
    return resultSesionsGroups;
}
var filterArray = function(pages) {
    var dataSet = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Set();
    return pages.filter(function(page) {
        if (dataSet.has(page.id)) {
            return false;
        }
        dataSet.add(page.id);
        return true;
    });
};
function createGroup(groupName, sessions, existingGroup, sessionSet) {
    var resultsesions = filterArray(sessions.filter(function(s) {
        return s.started === groupName;
    }).map(function(g) {
        return {
            id: g.id,
            name: g.name,
            interacted_at: g.interacted_at
        };
    }).concat(existingGroup).sort(function(a, b) {
        return new Date(b.interacted_at).getTime() - new Date(a.interacted_at).getTime();
    }), sessionSet);
    var resultGroup = {
        started: groupName,
        sessions: resultsesions
    };
    return resultGroup;
}
function getDateCategory(dateString) {
    var currentDate = new Date();
    var inputDate = new Date(dateString);
    var currentYear = currentDate.getFullYear();
    var currentMonth = currentDate.getMonth();
    var currentWeek = getWeekNumber(currentDate);
    var currentDay = currentDate.getDate();
    var inputYear = inputDate.getFullYear();
    var inputMonth = inputDate.getMonth();
    var inputWeek = getWeekNumber(inputDate);
    var inputDay = inputDate.getDate();
    if (currentYear === inputYear) {
        if (currentMonth === inputMonth) {
            if (currentDay === inputDay) {
                return "Today";
            } else if (currentWeek === inputWeek) {
                return "This week";
            } else {
                return "This month";
            }
        } else {
            return "This year";
        }
    } else {
        return "This year";
    }
}
function getWeekNumber(date) {
    var d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    var weekNo = Math.ceil(((d.valueOf() - yearStart.valueOf()) / 86400000 + 1) / 7);
    return weekNo;
}


/***/ }),

/***/ 133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "captionsResponseSchema": function() { return /* binding */ captionsResponseSchema; },
  "default": function() { return /* binding */ UserFeatureDistributer; },
  "getInputsResponseSchema": function() { return /* binding */ getInputsResponseSchema; },
  "sessionsListResponseSchema": function() { return /* binding */ sessionsListResponseSchema; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./comps/advanced-profile.tsx
var advanced_profile = __webpack_require__(8673);
// EXTERNAL MODULE: ./comps/footer/index.tsx + 4 modules
var footer = __webpack_require__(8109);
// EXTERNAL MODULE: ./comps/header/index.tsx + 2 modules
var header = __webpack_require__(1083);
// EXTERNAL MODULE: ./comps/meta.tsx
var meta = __webpack_require__(624);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 34 modules
var esm = __webpack_require__(2213);
// EXTERNAL MODULE: ./pages/feature/[feature].tsx + 22 modules
var _feature_ = __webpack_require__(8336);
// EXTERNAL MODULE: ./comps/button.tsx
var comps_button = __webpack_require__(5896);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./comps/ai-tools/icons.tsx
var icons = __webpack_require__(1455);
// EXTERNAL MODULE: ./comps/dropdown.tsx + 1 modules
var comps_dropdown = __webpack_require__(3153);
// EXTERNAL MODULE: ./utils/cdn.ts
var cdn = __webpack_require__(177);
// EXTERNAL MODULE: ./utils/errors.tsx
var errors = __webpack_require__(3882);
// EXTERNAL MODULE: ./utils/notification.tsx
var notification = __webpack_require__(4371);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(8767);
;// CONCATENATED MODULE: ./sections/dashboard/active-job.tsx













function ActiveJob(props) {
    var _video = props.video, status = _video.status, thumbnail = _video.thumbnail, estimatedSeconds = _video.estimatedSeconds, id = _video.id, isVideo = _video.isVideo, tool = _video.tool;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ceil = Math.ceil(estimatedSeconds / 60);
    var minutes = ceil < 1 ? 1 : ceil;
    var t = (0,esm/* useTranslation */.$G)().t;
    var notify = (0,react.useContext)(notification/* NotificationContext */.u).notify;
    var queryClient = (0,es.useQueryClient)();
    function handleCancel() {
        return _handleCancel.apply(this, arguments);
    }
    function _handleCancel() {
        _handleCancel = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        return [
                            4,
                            (0,errors/* mutateWithNotify */.D8)(notify, function() {
                                return axios/* default.post */.Z.post("/api/deforum-cancel", {
                                    id: id
                                }).then(function(res) {
                                    return res.data;
                                });
                            }, t("txt_successfully_canceled"), t("txt_error_canceling"))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            queryClient.invalidateQueries("deforum-last")
                        ];
                    case 2:
                        _state.sent();
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleCancel.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("relative flex h-[80px] justify-between hover:bg-blue-100", "group w-full shrink-0 rounded-[6px] p-[8px] text-blue-800"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-[8px]",
                children: [
                    isVideo && thumbnail ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        src: thumbnail,
                        loop: true,
                        playsInline: true,
                        muted: true,
                        autoPlay: true,
                        className: (0,clsx_m/* default */.Z)("aspect-1 h-[64px] object-cover", "rounded-[5px]")
                    }) : thumbnail ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: thumbnail,
                        alt: "thumbnail",
                        className: (0,clsx_m/* default */.Z)("aspect-1 h-[64px] object-cover", "rounded-[5px]")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)(tool === "text_to_image" && "rounded-[6px] bg-blue-200", "flex aspect-1 h-full items-center justify-center", "[--icon-color:var(--color-blue-500)]"),
                        children: [
                            tool === "text_to_image" && (0,icons/* textToImageIcon */.f7)(),
                            tool === "text_to_video" && (0,icons/* textToVideoIcon */.Cz)(),
                            tool === "ai_suggest" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,cdn/* assetUrl */.p)("/general/model-icon.svg"),
                                alt: "model icon"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)("flex h-full flex-col justify-center gap-1"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: " text-[14px] text-blue-800",
                                children: [
                                    t("txt_status"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: status === "in-progress" ? t("txt_in_progress") : t("txt_in_queue")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: " text-[14px] text-blue-800",
                                children: [
                                    t("txt_remaining"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: t("fs_minutes_short", {
                                            count: minutes
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_dropdown/* DropDown */.vb, {
                className: (0,clsx_m/* default */.Z)(status !== "in-queue" ? "hidden" : "flex"),
                trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)("h-[28px] w-[28px] rounded-[6px] bg-blue-100 group-hover:flex", "hidden items-center justify-center hover:bg-blue-200"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,cdn/* assetUrl */.p)("/general/more-gray.svg"),
                        alt: "more icon",
                        className: "w-[15px]"
                    })
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)(props.isLast ? "top-[-55px]" : "top-[50px] ", "absolute right-0 w-[175px] border", "rounded-[8px] border-color-separator bg-color-popup-cell", "p-[10px] [box-shadow:0px_0px_10px_rgba(0,0,0,0.13)]"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: handleCancel,
                        disabled: loading,
                        className: (0,clsx_m/* default */.Z)("rounded-[8px] text-[14px] hover:bg-blue-100", "px-[8px] py-[12px] font-500 text-blue-800", "w-full text-start disabled:pointer-events-none"),
                        children: t("lbl_cancel")
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./comps/image.tsx + 1 modules
var comps_image = __webpack_require__(9612);
// EXTERNAL MODULE: ./comps/header/avatar-with-menu.tsx
var avatar_with_menu = __webpack_require__(5007);
;// CONCATENATED MODULE: ./comps/header/dashboard-header.tsx









function DashboardHeader(props) {
    var activePage = props.activePage, isClosed = props.isClosed, lastQuery = props.lastQuery, setSubscriptionPopupOpen = props.setSubscriptionPopupOpen, setCloseSidebar = props.setCloseSidebar, changeSelectedPage = props.changeSelectedPage;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)(isClosed ? "desktop:left-[0px] desktop:w-screen" : "desktop:left-[240px] desktop:w-[calc(100%-240px)]", "fixed z-[99] bg-color-dashboard-bg py-[6px] pl-2 pr-4 tablet:px-5 desktop:pl-6 desktop:pr-[30px]", "flex h-[58px] items-center justify-between border-b tablet:h-[70px]", "w-full border-color-separator transition-all duration-[170ms] ease-in-out"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative flex flex-row items-center gap-[10px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: function(e) {
                                e.preventDefault();
                                setCloseSidebar(!isClosed);
                            },
                            className: (0,clsx_m/* default */.Z)("peer rounded-[6px] outline-none transition-all", "[--icon-color:var(--color-blue-800)] hover:bg-blue-100"),
                            children: MenuIcon()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)("left-[0px]", "absolute opacity-0 transition-opacity peer-hover:opacity-100", "pointer-events-none top-[44px] z-50 select-none"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)("relative h-[31px] w-[124px] rounded-[8px] bg-color-tooltip", "flex items-center justify-center gap-[4px]"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[13px] font-400 tracking-[0.4px] text-blue-50",
                                        children: isClosed ? t("txt_open_sidebar") : t("txt_close_sidebar")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[13px] font-400 text-blue-500",
                                        children: isClosed ? "( ] )" : "( [ )"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,clsx_m/* default */.Z)("h-[10px] w-[10px] bg-color-tooltip", "absolute left-[11px] z-[-1] rotate-45 rounded-[2px]", "top-[-4px]")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (0,clsx_m/* default */.Z)("flex text-[18px] font-700 text-blue-800", "leading-[16px] tracking-[0.36px]"),
                            children: t("lbl_".concat(activePage))
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-[15px] desktop:gap-[12px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveJobs, {
                            lastQuery: lastQuery
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* UpgradeButton */.Yz, {
                            setSubscriptionPopupOpen: setSubscriptionPopupOpen
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_with_menu/* AvatarWithMenu */.e, {
                            changeSelectedPage: changeSelectedPage,
                            setSubscriptionPopupOpen: setSubscriptionPopupOpen
                        })
                    ]
                })
            ]
        })
    });
}
function ActiveJobs(props) {
    var // [
    // 	{
    // 		status: "in-queue" as const,
    // 		id: 1234,
    // 		tool: "text_to_image" as const,
    // 		estimatedSeconds: 1212,
    // 		isVideo: false,
    // 		prompt: "kdsj",
    // 	},
    ref;
    var lastQuery = props.lastQuery;
    var ref1 = (0,react.useState)(false), isJobsOpen = ref1[0], setJobsOpen = ref1[1];
    var t = (0,esm/* useTranslation */.$G)().t;
    var jobsCount = lastQuery.data ? lastQuery.data.filter(function(job) {
        return job.status === "in-queue" || job.status === "in-progress";
    }).length : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex h-[50px] w-[50px] items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                id: "active-jobs-container",
                onClick: function() {
                    return setJobsOpen(function(o) {
                        return !o;
                    });
                },
                className: (0,clsx_m/* default */.Z)("h-[36px] w-[36px] rounded-[4px] hover:bg-blue-100", "absolute left-1/2 top-1/2 z-20 -translate-x-1/2 -translate-y-1/2", "flex items-center justify-center transition-colors"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                    source: "/general/ai-job",
                    format: "png?a",
                    className: "h-[24px] w-[24px]"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)(jobsCount > 0 ? "flex" : "hidden", "absolute right-1 top-1 z-30", "h-[18px] w-[18px] rounded-full bg-[#FF3166]", "flex items-center justify-center border border-color-surface-cell"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-[12px] font-600 text-[#FAF9FB]",
                    children: jobsCount
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function(e) {
                    if (e.currentTarget) {
                        if (e.currentTarget.id !== "active-jobs-container") {
                            setJobsOpen(false);
                        }
                    }
                },
                className: (0,clsx_m/* default */.Z)(!isJobsOpen && "hidden", "fixed left-0 top-0 z-10 h-full w-full")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function(e) {
                    if (e.currentTarget.id !== "active-jobs-container") {
                        setJobsOpen(false);
                    }
                },
                className: (0,clsx_m/* default */.Z)(isJobsOpen ? "flex" : "hidden", "fixed z-10 h-screen w-screen bg-color-popup tablet:hidden", "left-0 top-[58px]")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "active-jobs-container",
                className: (0,clsx_m/* default */.Z)(isJobsOpen ? "flex" : "hidden", "left-0 top-0 z-20 w-screen translate-y-[48px] tablet:w-auto", "fixed shrink-0 tablet:drop-shadow-[0px_0px_30px_rgba(0,0,0,0.13)]", "tablet:left-auto tablet:right-[10px] tablet:top-[10px]", "active-jobs-container no-scrollbar tablet:overflow-y-scroll"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("bg-color-popup-cell tablet:w-[380px] tablet:rounded-[10px]", "flex w-full flex-col gap-[16px] px-[8px]", "no-scrollbar max-h-[420px] overflow-y-scroll pt-[22px]", "pb-[10px] tablet:max-h-[320px]", jobsCount === 0 && "h-[320px] tablet:h-[320px]"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (0,clsx_m/* default */.Z)("text-[18px] font-600 tablet:tracking-[0.36px]", "ml-[8px] text-blue-900"),
                            children: t("txt_active_jobs")
                        }),
                        jobsCount === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(advanced_profile/* LockIconContainer */.U$, {
                            className: "!gap-0 text-[16px] font-500 text-blue-500",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(advanced_profile/* LockIcon */.mB, {
                                    source: "/general/empty-jobs",
                                    format: "svg",
                                    className: "h-[74px] w-[74px]"
                                }),
                                t("txt_no_active_jobs")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)("flex w-full flex-col"),
                            children: (ref = lastQuery.data) === null || ref === void 0 ? void 0 : ref.filter(function(j) {
                                return j.status === "in-queue" || j.status === "in-progress";
                            }).map(function(job, index) {
                                var ref, ref1;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveJob, {
                                    video: job,
                                    isLast: ((ref = lastQuery.data) === null || ref === void 0 ? void 0 : ref.filter(function(j) {
                                        return j.status === "in-queue" || j.status === "in-progress";
                                    }).length) === 1 + index || ((ref1 = lastQuery.data) === null || ref1 === void 0 ? void 0 : ref1.filter(function(j) {
                                        return j.status === "in-queue" || j.status === "in-progress";
                                    }).length) === 1
                                }, job.id);
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var MenuIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8.60625 22.5H23.3937M8.60625 16H23.3937M8.60625 9.5H23.3937",
            stroke: "var(--icon-color)",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

// EXTERNAL MODULE: ./comps/subscription-popup.tsx + 1 modules
var subscription_popup = __webpack_require__(9460);
// EXTERNAL MODULE: ./utils/branch.ts
var branch = __webpack_require__(2404);
// EXTERNAL MODULE: ./utils/breakpoints.tsx
var breakpoints = __webpack_require__(1156);
// EXTERNAL MODULE: ./utils/client-auth.tsx
var client_auth = __webpack_require__(1816);
// EXTERNAL MODULE: ./utils/indexed.tsx
var utils_indexed = __webpack_require__(788);
// EXTERNAL MODULE: ./utils/login-redirect.tsx
var login_redirect = __webpack_require__(7592);
// EXTERNAL MODULE: ./node_modules/@kartyom/shared-components/dist/index.js
var dist = __webpack_require__(8976);
// EXTERNAL MODULE: ./controllers/dashboard.ts
var controllers_dashboard = __webpack_require__(4551);
// EXTERNAL MODULE: ./controllers/editors.ts
var controllers_editors = __webpack_require__(17);
// EXTERNAL MODULE: ./sections/dashboard/content.tsx
var content = __webpack_require__(2711);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(2670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./comps/textarea.tsx
var comps_textarea = __webpack_require__(1411);
// EXTERNAL MODULE: ./utils/coins.tsx
var coins = __webpack_require__(279);
// EXTERNAL MODULE: ./node_modules/react-dropzone/dist/es/index.js + 4 modules
var dist_es = __webpack_require__(2512);
// EXTERNAL MODULE: ./comps/simple-drop-area.tsx
var simple_drop_area = __webpack_require__(356);
// EXTERNAL MODULE: ./utils/video.tsx
var utils_video = __webpack_require__(6961);
;// CONCATENATED MODULE: ./sections/dashboard/styles-popup.tsx












function StylesPopup(props) {
    var setIsOpen = props.setIsOpen, isOpen = props.isOpen, selectors = props.selectors, inputsRequest = props.inputsRequest, selectedGender = props.selectedGender, submitData = props.submitData;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), musicPopup = ref[0], setMusicPopup = ref[1];
    var ref1 = (0,react.useState)(false), voicePopup = ref1[0], setVoicePopup = ref1[1];
    var ref2 = (0,react.useState)(false), captionsPopup = ref2[0], setCaptionsPopup = ref2[1];
    var actorsSelector = selectors[0];
    var voiceoverSelector = selectors[1];
    var musicSelector = selectors[2];
    var ratioSelector = selectors[3];
    var captionsSelector = selectors[4];
    (0,dist/* useShortCut */.Xg)({
        shortCut: "Escape",
        handler: function() {
            if (isOpen) setIsOpen(false);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "styles-popup",
                onClick: function(e) {
                    var target = e.currentTarget;
                    if ((0,_instanceof/* default */.Z)(target, HTMLElement)) {
                        if (target.id === "styles-popup") {
                            setIsOpen(false);
                        }
                    }
                },
                className: (0,clsx_m/* default */.Z)("fixed z-[103] h-[100svh] w-screen items-end tablet:items-center", "left-0 top-0 flex justify-center transition-all", !isOpen && "pointer-events-none opacity-0")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: function(e) {
                    return e.stopPropagation();
                },
                className: (0,clsx_m/* default */.Z)("fixed bottom-0 left-0 z-[103]", "flex flex-col bg-color-surface-cell tablet:pb-0", "transition-transform duration-300 tablet:transition-opacity", "max-h-[90svh] w-full tablet:h-[631px] tablet:w-[700px] desktop:h-[631px] desktop:w-[934px]", "rounded-t-[10px] border border-color-separator tablet:rounded-[10px]", "tablet:bottom-1/2 tablet:left-1/2 tablet:-translate-x-1/2 tablet:translate-y-1/2", !isOpen && "pointer-events-none translate-y-full tablet:translate-y-0 tablet:opacity-0"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex h-[69px] w-full shrink-0 flex-row items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function(e) {
                                    e.preventDefault();
                                    setIsOpen(false);
                                },
                                className: "pl-[14px] [--icon-color:var(--color-blue-800)] tablet:pl-[15px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    width: "28",
                                    height: "28",
                                    viewBox: "0 0 28 28",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M16.334 21L9.33398 14L16.334 7",
                                        stroke: "var(--icon-color)",
                                        strokeWidth: "2.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[20px] font-700 text-blue-800 tablet:text-[24px]",
                                children: t("txt_edit_style")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-[42px] tablet:w-[43px]"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "no-scrollbar flex w-full flex-col gap-5 overflow-y-auto pb-[95px] tablet:h-[464px] tablet:max-h-[464px] tablet:flex-row tablet:gap-0 tablet:overflow-auto tablet:pb-0 tablet:pl-5 desktop:overflow-visible",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Actors, {
                                selector: actorsSelector,
                                selected: inputsRequest.actors.id
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "no-scrollbar flex flex-1 flex-col gap-5 tablet:w-[282px] tablet:overflow-y-auto tablet:px-5 desktop:w-[327px] desktop:overflow-visible",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CaptionsDropdown, {
                                        selector: captionsSelector,
                                        selected: inputsRequest.captions,
                                        setIsOpen: setCaptionsPopup
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VoiceoverDropdown, {
                                        selector: voiceoverSelector,
                                        selectedGender: selectedGender,
                                        selected: inputsRequest.voices,
                                        setIsOpen: setVoicePopup
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MusicDropdown, {
                                        selector: musicSelector,
                                        selected: inputsRequest.music,
                                        setIsOpen: setMusicPopup
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Aspects, {
                                        selector: ratioSelector,
                                        selected: inputsRequest.aspects
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fixed bottom-0 left-0 flex w-full items-center justify-center bg-color-surface-cell px-4 py-5 tablet:relative tablet:bg-[unset] tablet:px-[30px] tablet:py-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                            primary: true,
                            onClick: submitData,
                            text: "txt_submit",
                            className: "!h-[50px] !w-full !min-w-0 desktop:!w-[340px]"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CaptionsPopup, {
                isOpen: captionsPopup,
                setIsOpen: setCaptionsPopup,
                selected: inputsRequest.captions,
                selector: captionsSelector
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MusicPopup, {
                isOpen: musicPopup,
                setIsOpen: setMusicPopup,
                selector: musicSelector,
                selected: inputsRequest.music
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VoicePopup, {
                isOpen: voicePopup,
                setIsOpen: setVoicePopup,
                selector: voiceoverSelector,
                selected: inputsRequest.voices,
                selectedGender: selectedGender
            })
        ]
    });
}
function CaptionsPopup(props) {
    var isOpen = props.isOpen, setIsOpen = props.setIsOpen, selector = props.selector, selected = props.selected;
    var t = (0,esm/* useTranslation */.$G)().t;
    if (selector.type !== "captions") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "captions-popup",
                onClick: function(e) {
                    var target = e.currentTarget;
                    if ((0,_instanceof/* default */.Z)(target, HTMLElement)) {
                        if (target.id === "captions-popup") {
                            setIsOpen(false);
                        }
                    }
                },
                className: (0,clsx_m/* default */.Z)("fixed z-[103] h-[100svh] w-screen items-end tablet:hidden", "left-0 top-0 flex justify-center bg-color-popup transition-all", !isOpen && "pointer-events-none opacity-0")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: function(e) {
                    return e.stopPropagation();
                },
                className: (0,clsx_m/* default */.Z)("fixed bottom-0 left-0 z-[103] tablet:hidden", "flex flex-col gap-1 bg-color-surface-cell", "px-2 pt-3 transition-transform duration-300", "max-h-[60svh] w-screen rounded-t-[10px]", !isOpen && "pointer-events-none translate-y-full"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex h-8 w-full items-center justify-between px-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[16px] font-600 text-blue-800",
                                children: t(selector.name)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function(e) {
                                    e.preventDefault();
                                    setIsOpen(false);
                                },
                                className: "[--icon-color:var(--color-blue-800)]",
                                children: (0,icons/* newCloseIcon */.DS)("20", "20")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "no-scrollbar grid grid-cols-2 gap-3 overflow-y-auto py-3",
                        children: selector.info.data.map(function(s) {
                            var thumbnail = s.thumbnail, id = s.id;
                            if (!thumbnail || !id) return;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function(e) {
                                    e.preventDefault();
                                    selector.action(id, thumbnail);
                                    setIsOpen(false);
                                },
                                className: (0,clsx_m/* default */.Z)("flex h-[60px] max-h-[60px] w-full shrink-0 items-center justify-center rounded-lg px-2", "bg-blue-100 py-1 transition-all", selected.id === id && "border-2 border-primary-500 bg-primary-100"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: thumbnail,
                                    alt: "Caption image",
                                    className: "h-full"
                                })
                            }, id);
                        })
                    })
                ]
            })
        ]
    });
}
function CaptionsDropdown(props) {
    var selector = props.selector, selected = props.selected, setIsOpen = props.setIsOpen;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), dropdownOpen = ref[0], setDropdownOpen = ref[1];
    if (selector.type !== "captions") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-2 px-5 tablet:px-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-[17px] font-400 text-blue-500",
                children: t(selector.name)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                onClick: function(e) {
                    e.preventDefault();
                    setIsOpen(true);
                },
                className: (0,clsx_m/* default */.Z)("flex h-[56px] w-full items-center justify-between tablet:hidden", "gap-[8px] rounded-[6px] bg-color-surface px-[8px]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-3 shrink-0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex h-full flex-1 items-center justify-center gap-[2px] py-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: selected.thumb_url,
                            alt: "Caption image",
                            className: "h-full"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center gap-[2px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                            source: "/general/arrow",
                            format: "svg",
                            className: "h-[12px] w-[12px] rotate-90 transition-all group-focus-within:-rotate-90"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_dropdown/* DropDownWithState */.Ar, {
                isOpen: dropdownOpen,
                setIsOpen: setDropdownOpen,
                className: "group z-[69] hidden tablet:block",
                triggerClassName: "w-full",
                trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("flex h-[56px] w-full items-center justify-between", "gap-[8px] rounded-[6px] bg-color-surface px-[8px]"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-5 shrink-0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex h-full flex-1 items-center justify-center gap-[2px] py-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: selected.thumb_url,
                                alt: "Caption image",
                                className: "h-full"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center gap-[2px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                source: "/general/arrow",
                                format: "svg",
                                className: (0,clsx_m/* default */.Z)("h-[20px] w-[20px] transition-all", dropdownOpen ? "-rotate-90" : "rotate-90")
                            })
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)("absolute left-0 top-[62px] z-30 flex bg-color-cell", "h-[350px] flex-col rounded-[6px] border border-color-separator p-[6px]", "no-scrollbar w-full gap-[2px] overflow-y-scroll [box-shadow:0px_0px_10px_rgba(0,0,0,0.13)]"),
                    children: selector.info.data.map(function(s) {
                        var thumbnail = s.thumbnail, id = s.id;
                        if (!thumbnail || !id) return;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: function(e) {
                                e.preventDefault();
                                setDropdownOpen(false);
                                selector.action(id, thumbnail);
                            },
                            className: (0,clsx_m/* default */.Z)("flex h-[60px] max-h-[60px] shrink-0 items-center justify-center rounded-md px-2 py-1", "hover:bg-color-surface", selected.id === id && "bg-color-surface"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: thumbnail,
                                alt: "Caption image",
                                className: "h-full"
                            })
                        }, id);
                    })
                })
            }, selector.info.type)
        ]
    });
}
function VoicePopup(props) {
    var isOpen = props.isOpen, setIsOpen = props.setIsOpen, selector = props.selector, selected = props.selected, selectedGender = props.selectedGender;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(null), selectedAudio = ref[0], setSelectedAudio = ref[1];
    if (selector.type !== "voices") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "voice-popup",
                onClick: function(e) {
                    var target = e.currentTarget;
                    if ((0,_instanceof/* default */.Z)(target, HTMLElement)) {
                        if (target.id === "voice-popup") {
                            setIsOpen(false);
                        }
                    }
                },
                className: (0,clsx_m/* default */.Z)("fixed z-[103] h-[100svh] w-screen items-end tablet:hidden", "left-0 top-0 flex justify-center bg-color-popup transition-all", !isOpen && "pointer-events-none opacity-0")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: function(e) {
                    return e.stopPropagation();
                },
                className: (0,clsx_m/* default */.Z)("fixed bottom-0 left-0 z-[103] tablet:hidden", "flex flex-col gap-1 bg-color-surface-cell", "px-2 pt-3 transition-transform duration-300", "max-h-[50svh] w-screen rounded-t-[10px]", !isOpen && "pointer-events-none translate-y-full"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: " flex h-8 w-full items-center justify-between px-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[16px] font-600 text-blue-800",
                                children: t(selector.name)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function(e) {
                                    e.preventDefault();
                                    setIsOpen(false);
                                },
                                className: "[--icon-color:var(--color-blue-800)]",
                                children: (0,icons/* newCloseIcon */.DS)("20", "20")
                            })
                        ]
                    }),
                    isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "no-scrollbar flex flex-col gap-1 overflow-y-auto py-3",
                        children: selector.info.data.filter(function(elem) {
                            return elem.gender === selectedGender || !selectedGender;
                        }).map(function(s) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Voiceover, {
                                voice: s,
                                isSelected: s.id === selected.id,
                                setSelectedAudio: setSelectedAudio,
                                selector: selector,
                                selectedAudio: selectedAudio,
                                onClick: function() {
                                    return setIsOpen(false);
                                }
                            }, s.id);
                        })
                    })
                ]
            })
        ]
    });
}
function MusicPopup(props) {
    var isOpen = props.isOpen, setIsOpen = props.setIsOpen, selector = props.selector, selected = props.selected;
    var t = (0,esm/* useTranslation */.$G)().t;
    if (selector.type !== "music") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "music-popup",
                onClick: function(e) {
                    var target = e.currentTarget;
                    if ((0,_instanceof/* default */.Z)(target, HTMLElement)) {
                        if (target.id === "music-popup") {
                            setIsOpen(false);
                        }
                    }
                },
                className: (0,clsx_m/* default */.Z)("fixed z-[103] h-[100svh] w-screen items-end tablet:hidden", "left-0 top-0 flex justify-center bg-color-popup transition-all", !isOpen && "pointer-events-none opacity-0")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: function(e) {
                    return e.stopPropagation();
                },
                className: (0,clsx_m/* default */.Z)("fixed bottom-0 left-0 z-[103] tablet:hidden", "flex flex-col gap-1 bg-color-surface-cell", "px-2 pt-3 transition-transform duration-300", "max-h-[50svh] w-screen rounded-t-[10px]", !isOpen && "pointer-events-none translate-y-full"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex h-8 w-full items-center justify-between px-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[16px] font-600 text-blue-800",
                                children: t(selector.name)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function(e) {
                                    e.preventDefault();
                                    setIsOpen(false);
                                },
                                className: "[--icon-color:var(--color-blue-800)]",
                                children: (0,icons/* newCloseIcon */.DS)("20", "20")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "no-scrollbar flex flex-col gap-1 overflow-y-auto py-3",
                        children: selector.info.data.map(function(music) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function(e) {
                                    e.preventDefault();
                                    var _id;
                                    selector.action((_id = music.id) !== null && _id !== void 0 ? _id : "", music.name);
                                    setIsOpen(false);
                                },
                                className: (0,clsx_m/* default */.Z)("flex w-full items-center justify-start p-2 text-[17px] font-400 text-blue-800", "rounded-md transition-colors hover:bg-color-surface", selected.name === music.name && "bg-color-surface"),
                                children: music.name
                            }, music.id);
                        })
                    })
                ]
            })
        ]
    });
}
function Aspects(props) {
    var selector = props.selector, selected = props.selected;
    var t = (0,esm/* useTranslation */.$G)().t;
    var scrollContainerRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(true), prevDisabled = ref[0], setPrevDisabled = ref[1];
    var ref1 = (0,react.useState)(false), nextDisabled = ref1[0], setNextDisabled = ref1[1];
    var scrollLeft = function() {
        if (!scrollContainerRef.current) {
            return;
        }
        var prev = getPrevVisibleChild(scrollContainerRef.current);
        if (!prev) {
            return;
        }
        prev.scrollIntoView({
            block: "center",
            inline: "start",
            behavior: "smooth"
        });
    };
    var scrollRight = function() {
        if (!scrollContainerRef.current) {
            return;
        }
        var next = getNextVisibleChild(scrollContainerRef.current);
        if (!next) {
            return;
        }
        next.scrollIntoView({
            block: "center",
            inline: "end",
            behavior: "smooth"
        });
    };
    var updateButtonStatus = (0,react.useCallback)(function() {
        var nextDisabled = false;
        if (scrollContainerRef.current && scrollContainerRef.current.scrollWidth <= scrollContainerRef.current.clientWidth) {
            nextDisabled = true;
        }
        if (scrollContainerRef.current && getNextVisibleChild(scrollContainerRef.current)) {
            nextDisabled = false;
        }
        if (scrollContainerRef.current && !getNextVisibleChild(scrollContainerRef.current)) {
            nextDisabled = true;
        }
        setNextDisabled(nextDisabled);
        var prevDisabled = true;
        if (scrollContainerRef.current && getPrevVisibleChild(scrollContainerRef.current)) {
            prevDisabled = false;
        }
        setPrevDisabled(prevDisabled);
    }, [
        scrollContainerRef
    ]);
    (0,react.useEffect)(function() {
        updateButtonStatus();
    }, [
        updateButtonStatus
    ]);
    if (selector.type !== "aspect") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex w-full flex-col gap-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "px-5 text-[17px] font-400 text-blue-500 tablet:px-0",
                children: t(selector.name)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onScroll: updateButtonStatus,
                        ref: scrollContainerRef,
                        className: "no-scrollbar flex flex-row gap-[6px] overflow-x-scroll rounded-lg px-5 tablet:px-0",
                        children: selector.info.data.map(function(aspect) {
                            var aspectSize = getAspectsSizes(aspect.name);
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                onClick: function(e) {
                                    e.preventDefault();
                                    var _id;
                                    selector.action((_id = aspect.id) !== null && _id !== void 0 ? _id : "", aspect.name);
                                },
                                className: (0,clsx_m/* default */.Z)("flex h-10 shrink-0 flex-row items-center gap-1 rounded-lg px-[10px] py-3", "transition-all", selected.id === aspect.id ? "bg-primary-50 inner-border-2 inner-border-primary-500" : "bg-color-surface inner-border inner-border-blue-200"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex h-5 w-5 shrink-0 items-center justify-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                width: aspectSize.width,
                                                height: aspectSize.height
                                            },
                                            className: "rounded-[2.5px] border border-blue-400"
                                        })
                                    }),
                                    removeAspectsName(aspect.name)
                                ]
                            }, aspect.id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        id: "scroll-left",
                        disabled: prevDisabled,
                        style: {
                            filter: "drop-shadow(0px 2.353px 13.647px rgba(123, 128, 158, 0.12))"
                        },
                        className: (0,clsx_m/* default */.Z)("absolute top-[calc(50%-11px)] hidden h-[22px] w-[22px]", "items-center justify-center rounded-full bg-color-cell", "[--icon-color:var(--color-blue-600)] disabled:pointer-events-none", "disabled:opacity-0 desktop:flex", "left-2 border border-color-separator"),
                        onClick: scrollLeft,
                        children: (0,icons/* ButtonArrowIcon */.hd)()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        id: "scroll-right",
                        disabled: nextDisabled,
                        style: {
                            filter: "drop-shadow(0px 2.353px 13.647px rgba(123, 128, 158, 0.12))"
                        },
                        className: (0,clsx_m/* default */.Z)("absolute top-[calc(50%-11px)] hidden h-[22px] w-[22px]", "rotate-180 items-center justify-center rounded-full bg-color-cell", "[--icon-color:var(--color-blue-600)] disabled:pointer-events-none", "disabled:opacity-0 desktop:flex", "right-2 border border-color-separator"),
                        onClick: scrollRight,
                        children: (0,icons/* ButtonArrowIcon */.hd)()
                    })
                ]
            })
        ]
    });
}
function getAspectsSizes(name) {
    switch(name){
        case "Portrait (9:16)":
            return {
                width: "14px",
                height: "20px"
            };
        case "Landscape (16:9)":
            return {
                width: "20px",
                height: "14px"
            };
        case "Square (1:1)":
            return {
                width: "20px",
                height: "20px"
            };
        case "4:5":
            return {
                width: "16px",
                height: "20px"
            };
        case "5:4":
            return {
                width: "20px",
                height: "16px"
            };
        default:
            return {
                width: "20px",
                height: "20px"
            };
    }
}
function removeAspectsName(name) {
    switch(name){
        case "Portrait (9:16)":
            return "9:16";
        case "Landscape (16:9)":
            return "16:9";
        case "Square (1:1)":
            return "1:1";
        default:
            return name;
    }
}
function MusicDropdown(props) {
    var selector = props.selector, selected = props.selected, setIsOpen = props.setIsOpen;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), musicDropdown = ref[0], setMusicDropdown = ref[1];
    if (selector.type !== "music") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-2 px-5 tablet:px-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-[17px] font-400 text-blue-500",
                children: t(selector.name)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                onClick: function(e) {
                    e.preventDefault();
                    setIsOpen(true);
                },
                className: (0,clsx_m/* default */.Z)("flex h-[48px] w-full items-center justify-between", "gap-[8px] rounded-[6px] bg-color-surface px-[8px] tablet:hidden"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center gap-[2px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (0,clsx_m/* default */.Z)("max-w-[70px] truncate text-[15px] font-500 text-blue-800"),
                            children: selected.name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center gap-[2px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                            source: "/general/arrow",
                            format: "svg",
                            className: "h-[12px] w-[12px] rotate-90 transition-all group-focus-within:-rotate-90"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_dropdown/* DropDownWithState */.Ar, {
                isOpen: musicDropdown,
                setIsOpen: setMusicDropdown,
                className: "group z-[67] hidden tablet:block",
                triggerClassName: "w-full",
                trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("flex h-[48px] w-full items-center justify-between", "gap-[8px] rounded-[6px] bg-color-surface px-[8px]"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center gap-[2px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,clsx_m/* default */.Z)("max-w-[70px] truncate text-[15px] font-500 text-blue-800"),
                                children: selected.name
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center gap-[2px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                source: "/general/arrow",
                                format: "svg",
                                className: (0,clsx_m/* default */.Z)("h-[20px] w-[20px] transition-all", musicDropdown ? "-rotate-90" : "rotate-90")
                            })
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)("absolute left-0 top-[55px] z-30 flex bg-color-cell", "h-[220px] flex-col rounded-[6px] border border-color-separator p-[6px]", "no-scrollbar w-full gap-[2px] overflow-y-scroll [box-shadow:0px_0px_10px_rgba(0,0,0,0.13)]"),
                    children: selector.info.data.map(function(s) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: function(e) {
                                e.preventDefault();
                                setMusicDropdown(false);
                                var _id;
                                selector.action((_id = s.id) !== null && _id !== void 0 ? _id : "", s.name);
                            },
                            className: (0,clsx_m/* default */.Z)("flex items-center justify-start rounded-md px-2 py-2 text-[17px] font-400 text-blue-800", "hover:bg-color-surface", selected.name === s.name && "bg-color-surface"),
                            children: s.name
                        }, s.id);
                    })
                })
            }, selector.info.type)
        ]
    });
}
function Actors(props) {
    var selector = props.selector, selected = props.selected;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(selector.info.data.map(function(actor) {
        return actor.thumbnail;
    })), thumbnails = ref[0], setThumbnails = ref[1];
    // Function to update the thumbnail for a specific actor
    var updateThumbnail = function(index, newThumbnail) {
        setThumbnails(function(prevThumbnails) {
            var newThumbnails = (0,_to_consumable_array/* default */.Z)(prevThumbnails);
            newThumbnails[index] = newThumbnail;
            return newThumbnails;
        });
    };
    if (selector.type !== "actors") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex shrink-0 flex-col gap-[10px] tablet:h-full tablet:max-h-[464px] tablet:w-[362px] desktop:w-[547px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "h-5 px-5 text-[17px] font-400 text-blue-500 tablet:px-0",
                children: t(selector.name)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "no-scrollbar flex flex-1 shrink-0 flex-row gap-2 overflow-x-scroll rounded-[12px] px-5 tablet:grid tablet:h-[434px] tablet:max-h-[434px] tablet:grid-cols-2 tablet:overflow-y-scroll tablet:px-0 desktop:grid-cols-3",
                children: selector.info.data.map(function(actor, index) {
                    var thumb = thumbnails[index];
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        onPointerEnter: function() {
                            updateThumbnail(index, actor.animated_thumbnail);
                        },
                        onPointerLeave: function() {
                            if (selected === actor.id) return;
                            updateThumbnail(index, actor.thumbnail);
                        },
                        onClick: function(e) {
                            e.preventDefault();
                            updateThumbnail(index, actor.animated_thumbnail);
                            selector.action(actor.id, actor.name, actor.thumbnail, actor.gender);
                        },
                        className: (0,clsx_m/* default */.Z)("h-[158px] w-[120px]", "shrink-0 rounded-[12px] tablet:h-[201px] tablet:w-full", "flex flex-col items-center justify-center gap-2 transition-all", selected === actor.id ? "border-2 border-primary-500 bg-primary-50" : "border border-blue-200 bg-color-surface"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[90px] w-[90px] shrink-0 overflow-hidden rounded-full bg-blue-200 tablet:h-[130px] tablet:w-[130px]",
                                children: thumb ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: thumb,
                                    alt: actor.name + " image",
                                    className: "h-full w-full object-cover"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex h-full w-full items-center justify-center [--icon-color:var(--color-blue-900)]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoActorImage, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[18px] font-400 text-blue-700",
                                children: t(actor.name)
                            })
                        ]
                    }, actor.id);
                })
            })
        ]
    });
}
function VoiceoverDropdown(props) {
    var handleAudioPlay = function handleAudioPlay() {
        if (!audioRef.current) {
            return;
        }
        if (audioRef.current.paused) {
            audioRef.current.src = selected.preview_url;
            setPlayAudioButton(true);
            audioRef.current.play().catch(function() {
                return console.error("Cannot play");
            });
        } else {
            audioRef.current.src = selected.preview_url;
            setPlayAudioButton(false);
            audioRef.current.pause();
        }
    };
    var selector = props.selector, selectedGender = props.selectedGender, selected = props.selected, setIsOpen = props.setIsOpen;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(null), selectedAudio = ref[0], setSelectedAudio = ref[1];
    var audioRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), playAudioButton = ref1[0], setPlayAudioButton = ref1[1];
    var ref2 = (0,react.useState)(false), dropdown = ref2[0], setDropdown = ref2[1];
    (0,react.useEffect)(function() {
        var frameId;
        function renderNextFrame() {
            var audio = audioRef.current;
            if (!audio) {
                return;
            }
            if (audio.currentTime === audio.duration) {
                audio.currentTime = 0;
                audio.pause();
                setPlayAudioButton(false);
            }
            frameId = requestAnimationFrame(function() {
                renderNextFrame();
            });
        }
        renderNextFrame();
        return function() {
            if (frameId !== null) {
                cancelAnimationFrame(frameId);
            }
        };
    }, [
        audioRef
    ]);
    if (selector.type !== "voices") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-2 px-5 tablet:px-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-[17px] font-400 text-blue-500",
                children: t(selector.name)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: function(e) {
                    e.preventDefault();
                    setIsOpen(true);
                },
                className: (0,clsx_m/* default */.Z)("flex h-[56px] w-full items-center justify-between", "gap-[8px] rounded-[6px] bg-color-surface px-[8px] tablet:hidden"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex w-[70%] items-center justify-start gap-[2px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx_m/* default */.Z)("group items-center gap-[8px] p-[4px]", "flex w-full cursor-pointer rounded-[4px]"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: function(e) {
                                        e.stopPropagation();
                                        handleAudioPlay();
                                    },
                                    className: (0,clsx_m/* default */.Z)(playAudioButton ? "bg-color-chat-alpha" : "bg-blue-300", "shrink-0 rounded-full p-[7px]"),
                                    children: playAudioButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (0,cdn/* assetUrl */.p)("/general/pause-chat.png"),
                                        alt: "play icon",
                                        className: "h-[15px] w-[15px]"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (0,cdn/* assetUrl */.p)("/general/play.png"),
                                        alt: "play icon",
                                        className: "h-[15px] w-[15px]"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex w-full flex-col items-start",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "w-full truncate text-[13px] font-500 text-blue-600",
                                            children: selected.name
                                        }),
                                        selected.tags && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex w-full items-center truncate",
                                            children: selected.tags.map(function(l, index) {
                                                var ref;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-[13px] font-400 text-blue-600",
                                                            children: l
                                                        }),
                                                        index + 1 !== ((ref = selected.tags) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mx-[4px] h-[4px] w-[4px] rounded-full bg-blue-300"
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("audio", {
                                    className: "hidden",
                                    ref: audioRef,
                                    controls: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                            src: selected.preview_url,
                                            type: "audio/mpeg"
                                        }),
                                        "Your browser does not support the audio element."
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center gap-[2px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                            source: "/general/arrow",
                            format: "svg",
                            className: "h-[12px] w-[12px] rotate-90 transition-all group-focus-within:-rotate-90"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_dropdown/* DropDownWithState */.Ar, {
                isOpen: dropdown,
                setIsOpen: setDropdown,
                className: "group z-[68] hidden tablet:block",
                triggerClassName: "w-full",
                trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("flex h-[56px] w-full items-center justify-between", "gap-[8px] rounded-[6px] bg-color-surface px-[8px]"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex w-[70%] items-center justify-start gap-[2px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)("group items-center gap-[8px] p-[4px]", "flex w-full cursor-pointer rounded-[4px]"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        onClick: function(e) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handleAudioPlay();
                                        },
                                        className: (0,clsx_m/* default */.Z)(playAudioButton ? "bg-color-chat-alpha" : "bg-blue-300", "shrink-0 rounded-full p-[7px]"),
                                        children: playAudioButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: (0,cdn/* assetUrl */.p)("/general/pause-chat.png"),
                                            alt: "play icon",
                                            className: "h-[15px] w-[15px]"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: (0,cdn/* assetUrl */.p)("/general/play.png"),
                                            alt: "play icon",
                                            className: "h-[15px] w-[15px]"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex w-full flex-col items-start",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "w-full truncate text-start text-[13px] font-500 text-blue-600",
                                                children: selected.name
                                            }),
                                            selected.tags && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex w-full items-center truncate",
                                                children: selected.tags.map(function(l, index) {
                                                    var ref;
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-[13px] font-400 text-blue-600",
                                                                children: l
                                                            }),
                                                            index + 1 !== ((ref = selected.tags) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "mx-[4px] h-[4px] w-[4px] rounded-full bg-blue-300"
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("audio", {
                                        className: "hidden",
                                        ref: audioRef,
                                        controls: true,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                src: selected.preview_url,
                                                type: "audio/mpeg"
                                            }),
                                            "Your browser does not support the audio element."
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center gap-[2px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                source: "/general/arrow",
                                format: "svg",
                                className: (0,clsx_m/* default */.Z)("h-[20px] w-[20px] transition-all", dropdown ? "-rotate-90" : "rotate-90")
                            })
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)("no-scrollbar absolute left-0 top-[62px] z-30 flex bg-color-cell", "h-[250px] flex-col rounded-[6px] border border-color-separator p-[6px]", "w-full gap-[2px] overflow-y-scroll [box-shadow:0px_0px_10px_rgba(0,0,0,0.13)]"),
                    children: selector.info.data.filter(function(elem) {
                        return elem.gender === selectedGender || !selectedGender;
                    }).map(function(s) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Voiceover, {
                            voice: s,
                            isSelected: s.id === selected.id,
                            setSelectedAudio: setSelectedAudio,
                            selector: selector,
                            selectedAudio: selectedAudio,
                            onClick: function() {
                                return setDropdown(false);
                            }
                        }, s.id);
                    })
                })
            }, selector.info.type)
        ]
    });
}
function Voiceover(props) {
    var handleAudioPlay = function handleAudioPlay() {
        if (!audioRef.current) {
            return;
        }
        if (audioRef.current.paused) {
            audioRef.current.play().catch(function() {
                return console.error("Cannot play");
            });
        } else {
            audioRef.current.pause();
        }
        if (selectedAudio !== audioRef.current) {
            selectedAudio === null || selectedAudio === void 0 ? void 0 : selectedAudio.pause();
        }
        setSelectedAudio && setSelectedAudio(audioRef.current);
    };
    var selectedAudio = props.selectedAudio, setSelectedAudio = props.setSelectedAudio, isSelected = props.isSelected, selector = props.selector, voice = props.voice, onClick = props.onClick;
    var id = voice.id, name = voice.name, tags = voice.tags, preview_url = voice.preview_url, gender = voice.gender;
    var audioRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), playAudioButton = ref[0], setPlayAudioButton = ref[1];
    (0,react.useEffect)(function() {
        var frameId;
        function renderNextFrame() {
            var audio = audioRef.current;
            if (!audio) {
                return;
            }
            if (selectedAudio === null) {
                audio.pause();
            }
            if (audio.currentTime === audio.duration) {
                audio.currentTime = 0;
                audio.pause();
                setPlayAudioButton(false);
            }
            if (audio.paused) {
                setPlayAudioButton(false);
            } else {
                setPlayAudioButton(true);
            }
            frameId = requestAnimationFrame(function() {
                renderNextFrame();
            });
        }
        renderNextFrame();
        return function() {
            if (frameId !== null) {
                cancelAnimationFrame(frameId);
            }
        };
    }, [
        selectedAudio
    ]);
    if (preview_url === null || selector.type !== "voices" || id === null || tags === null) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        onClick: function() {
            selector.action(id, name, tags, preview_url, gender);
            setSelectedAudio(null);
            onClick && onClick();
        },
        className: (0,clsx_m/* default */.Z)(isSelected && "bg-blue-100", "group items-center gap-[8px] p-[4px] hover:bg-blue-100", "flex w-full cursor-pointer rounded-[4px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: function(e) {
                    e.stopPropagation();
                    handleAudioPlay();
                },
                className: (0,clsx_m/* default */.Z)(playAudioButton ? "bg-color-chat-alpha" : "bg-blue-300", "shrink-0 rounded-full p-[7px]"),
                children: playAudioButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: (0,cdn/* assetUrl */.p)("/general/pause-chat.png"),
                    alt: "play icon",
                    className: "h-[15px] w-[15px]"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: (0,cdn/* assetUrl */.p)("/general/play.png"),
                    alt: "play icon",
                    className: "h-[15px] w-[15px]"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-[70%] flex-col items-start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-[13px] font-500 text-blue-600",
                        children: name
                    }),
                    tags && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex w-full items-center truncate",
                        children: tags.map(function(l, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[13px] font-400 text-blue-600",
                                        children: l
                                    }),
                                    index + 1 !== (tags === null || tags === void 0 ? void 0 : tags.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mx-[4px] h-[4px] w-[4px] rounded-full bg-blue-300"
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("audio", {
                className: "hidden",
                ref: audioRef,
                controls: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        src: preview_url,
                        type: "audio/mpeg"
                    }),
                    "Your browser does not support the audio element."
                ]
            })
        ]
    }, id);
}
var MAX_ALLOWED_DISTANCE = 0.0001;
function getNextVisibleChild(container) {
    var parentBounds = container.getBoundingClientRect();
    var parentX = parentBounds.x;
    var parentWidth = parentBounds.width;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = container.childNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var child = _step.value;
            if ((0,_instanceof/* default */.Z)(child, HTMLElement)) {
                var ref = child.getBoundingClientRect(), x = ref.x, width = ref.width;
                if (x + width - MAX_ALLOWED_DISTANCE > parentX + parentWidth) {
                    return child;
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
function getPrevVisibleChild(container) {
    var parentBounds = container.getBoundingClientRect();
    var parentX = parentBounds.x;
    var last = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = container.childNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var child = _step.value;
            if ((0,_instanceof/* default */.Z)(child, HTMLButtonElement)) {
                var x = child.getBoundingClientRect().x;
                if (x + MAX_ALLOWED_DISTANCE > parentX) {
                    return last;
                }
                last = child;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
function NoActorImage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "29",
        height: "28",
        viewBox: "0 0 29 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.3384 14.884C8.67526 13.6042 7.60352 11.5938 7.60352 9.33301C7.60352 5.46701 10.7375 2.33301 14.6035 2.33301C17.4903 2.33301 19.9689 4.08045 21.0393 6.57525C21.2266 7.01174 21.1319 7.50938 20.8489 7.89083L19.6683 9.48206C19.5514 9.63966 19.2702 9.52925 19.2702 9.33301C19.2702 6.75568 17.1808 4.66634 14.6035 4.66634C12.0262 4.66634 9.93685 6.75568 9.93685 9.33301C9.93685 11.8833 11.9826 13.9559 14.5227 13.999C14.5766 13.9986 14.6305 13.9986 14.6843 13.999C14.9618 13.9943 15.2333 13.9654 15.4969 13.9143C15.8064 13.8543 16.1199 14.2648 15.932 14.518L14.8441 15.9844C14.6813 16.2038 14.4221 16.3377 14.1489 16.3342C13.9592 16.3366 13.9115 16.345 13.8251 16.3603C13.7758 16.369 13.7139 16.3799 13.606 16.3932C12.2952 16.5545 11.043 17.0313 9.95684 17.7828C8.87071 18.5343 7.98304 19.538 7.36997 20.7079C6.7569 21.8777 6.4367 23.1788 6.43685 24.4996C6.43692 25.1439 5.91464 25.6663 5.27031 25.6664C4.62598 25.6664 4.10359 25.1442 4.10352 24.4998C4.10333 22.8017 4.515 21.1289 5.30324 19.6248C6.09148 18.1207 7.23276 16.8302 8.62922 15.864C9.15672 15.499 9.71468 15.1844 10.2957 14.9231C10.3096 14.9097 10.3238 14.8967 10.3384 14.884ZM20.4782 17.7863C20.1741 18.1961 20.2329 18.7651 20.5671 19.1508C20.9783 19.6254 21.3349 20.1476 21.6286 20.7079C22.2416 21.8777 22.5618 23.1788 22.5617 24.4996C22.5616 25.1439 23.0839 25.6663 23.7282 25.6664C24.3726 25.6664 24.8949 25.1442 24.895 24.4998C24.8952 22.8017 24.4835 21.1289 23.6953 19.6248C23.268 18.8095 22.7371 18.057 22.1179 17.3848C21.7212 16.9541 21.041 17.0277 20.6921 17.498L20.4782 17.7863ZM26.5026 7.28722C26.9054 6.78429 26.8242 6.05007 26.3213 5.6473C25.8183 5.24453 25.0841 5.32574 24.6813 5.82867L11.3698 23.7704C10.9671 24.2734 11.0483 25.0076 11.5512 25.4103C12.0541 25.8131 12.7884 25.7319 13.1911 25.229L26.5026 7.28722Z",
            fill: "var(--icon-color)"
        })
    });
}

;// CONCATENATED MODULE: ./sections/dashboard/popups.tsx





















function Popups(props) {
    var setterNecessaryState = function setterNecessaryState(config) {
        var type = config.type;
        switch(type){
            case "actors":
                setInputsRequest(function(o) {
                    var id = config.id, image = config.image, gender = config.gender, name = config.name;
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, o), {
                        actors: {
                            id: id,
                            name: name,
                            image: id === null ? null : image !== null && image !== void 0 ? image : null,
                            gender: gender !== null && gender !== void 0 ? gender : null
                        }
                    });
                });
                var _gender;
                setSelectedGender((_gender = config.gender) !== null && _gender !== void 0 ? _gender : null);
                var firstVoice = props.data.voices.find(function(a) {
                    return a.gender === config.gender;
                });
                setInputsRequest(function(o) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, o), {
                        voices: firstVoice ? {
                            id: firstVoice.id,
                            name: firstVoice.name,
                            gender: firstVoice.gender,
                            preview_url: firstVoice.preview_url,
                            tags: firstVoice.tags
                        } : inputsRequest.voices
                    });
                });
                break;
            case "voices":
                setInputsRequest(function(o) {
                    var tags = config.tags, id = config.id, name = config.name, gender = config.gender, preview_url = config.preview_url;
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, o), {
                        voices: {
                            id: id,
                            name: name,
                            gender: gender,
                            tags: tags,
                            preview_url: preview_url
                        }
                    });
                });
                break;
            case "music":
                setInputsRequest(function(o) {
                    var id = config.id, name = config.name;
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, o), {
                        music: {
                            id: id,
                            name: name
                        }
                    });
                });
                break;
            case "aspects":
                setInputsRequest(function(o) {
                    var id = config.id, name = config.name;
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, o), {
                        aspects: {
                            id: id,
                            name: name
                        }
                    });
                });
                break;
            case "captions":
                setInputsRequest(function(o) {
                    var id = config.id, thumb = config.thumb;
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, o), {
                        captions: {
                            id: id,
                            thumb_url: thumb
                        }
                    });
                });
                break;
        }
    };
    var ref, ref1;
    var initialSelected = props.initialSelected, close = props.close, setInputs = props.setInputs, setSubscriptionPopupOpen = props.setSubscriptionPopupOpen;
    var ref2 = (0,react.useState)(initialSelected), selected = ref2[0], setSelected = ref2[1];
    var ref3 = (0,react.useState)({
        txt_url_to_video: {
            type: "url",
            content: ""
        },
        txt_idea_to_video: {
            type: "idea",
            content: ""
        },
        txt_medias_to_video: {
            type: "medias",
            resources: []
        },
        txt_script_to_video: {
            type: "script",
            content: ""
        }
    }), message = ref3[0], setMessage = ref3[1];
    var popupsHeaderRef = (0,react.useRef)(null);
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref4 = (0,react.useState)(null), selectedGender = ref4[0], setSelectedGender = ref4[1];
    var wallet = (0,coins/* useCoins */.YO)();
    var ref5 = (0,react.useState)(true), firstTime = ref5[0], setFirstTime = ref5[1];
    var ref6 = (0,react.useState)(false), isStylePopupOpen = ref6[0], setStylePopupOpen = ref6[1];
    var ref7, ref8;
    var tokensSummery = ((ref7 = wallet === null || wallet === void 0 ? void 0 : wallet.permanentTokens) !== null && ref7 !== void 0 ? ref7 : 0) + ((ref8 = wallet === null || wallet === void 0 ? void 0 : wallet.temporaryTokens) !== null && ref8 !== void 0 ? ref8 : 0);
    var ref9 = (0,react.useState)({
        aspects: {
            id: props.data.aspects[0].id,
            name: props.data.aspects[0].name
        },
        actors: {
            id: null,
            name: "No Actor",
            image: null,
            gender: null
        },
        music: {
            id: null,
            name: "None"
        },
        voices: {
            id: props.data.voices[0].id,
            name: props.data.voices[0].name,
            gender: props.data.voices[0].gender,
            tags: props.data.voices[0].tags,
            preview_url: props.data.voices[0].preview_url
        },
        captions: {
            id: props.data.captions[0].id,
            thumb_url: props.data.captions[0].thumb_url
        }
    }), inputsRequest = ref9[0], setInputsRequest = ref9[1];
    var data = extractInputsResponse(props.data);
    (0,react.useEffect)(function() {
        if (firstTime) {
            setFirstTime(false);
            if (selected === "txt_medias_to_video" && popupsHeaderRef.current) {
                popupsHeaderRef.current.scrollLeft = 400;
            }
        }
    }, [
        firstTime,
        popupsHeaderRef,
        selected
    ]);
    var sections = [
        "txt_url_to_video",
        "txt_medias_to_video",
        "txt_script_to_video",
        "txt_idea_to_video", 
    ];
    var buttons = sections.map(function(section) {
        return {
            name: section,
            action: function() {
                return setSelected(section);
            },
            isSelected: selected === section
        };
    });
    var selectors = [
        {
            type: "actors",
            info: data[0],
            name: "txt_select_actor",
            icon: "/general/actor",
            action: function(id, name, image, gender) {
                return setterNecessaryState({
                    id: id,
                    name: name,
                    type: "actors",
                    image: image,
                    gender: gender
                });
            }
        },
        {
            type: "voices",
            info: data[1],
            name: "lbl_voiceover",
            icon: "/general/voiceover",
            action: function(id, name, tags, preview_url, gender) {
                return setterNecessaryState({
                    id: id,
                    name: name,
                    type: "voices",
                    tags: tags,
                    preview_url: preview_url,
                    gender: gender
                });
            }
        },
        {
            type: "music",
            info: data[2],
            name: "txt_bg_music",
            icon: "/general/music",
            action: function(id, name) {
                return setterNecessaryState({
                    id: id,
                    name: name,
                    type: "music"
                });
            }
        },
        {
            type: "aspect",
            info: data[3],
            name: "lbl_ratio",
            icon: "/general/ratio",
            action: function(id, name) {
                return setterNecessaryState({
                    id: id,
                    name: name,
                    type: "aspects"
                });
            }
        },
        {
            type: "captions",
            info: data[4],
            name: "txt_captions_style",
            icon: "/general/ratio",
            action: function(id, thumb) {
                return setterNecessaryState({
                    id: id,
                    thumb: thumb,
                    type: "captions"
                });
            }
        }, 
    ];
    (0,dist/* useShortCut */.Xg)({
        shortCut: "Escape",
        handler: function() {
            if (isStylePopupOpen) return;
            close();
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "dashboard-popups",
        onClick: function(e) {
            var target = e.currentTarget;
            if ((0,_instanceof/* default */.Z)(target, HTMLElement)) {
                if (target.id === "dashboard-popups" && !isStylePopupOpen) {
                    close();
                }
            }
        },
        className: (0,clsx_m/* default */.Z)("fixed z-[102] h-[100svh] w-screen items-center backdrop-blur-lg", "left-0 top-0 flex justify-center bg-color-popup"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: function(e) {
                    return e.stopPropagation();
                },
                className: (0,clsx_m/* default */.Z)("flex flex-col rounded-[10px] tablet:w-[680px]", "relative w-[351px] border border-color-separator", "h-[428px] bg-color-surface tablet:h-[404px] desktop:w-[690px]", isStylePopupOpen && "opacity-0"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        ref: popupsHeaderRef,
                        className: (0,clsx_m/* default */.Z)("relative flex items-center bg-color-popup-cell tablet:px-[12px]", "no-scrollbar w-full justify-between overflow-x-scroll rounded-t-[10px] tablet:justify-start", "h-[52px]"),
                        children: [
                            buttons.map(function(b) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupButton, (0,_object_spread/* default */.Z)({}, b), b.name);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    width: ((ref = popupsHeaderRef.current) === null || ref === void 0 ? void 0 : ref.scrollWidth) ? ((ref1 = popupsHeaderRef.current) === null || ref1 === void 0 ? void 0 : ref1.scrollWidth) + "px" : "100%"
                                },
                                className: "absolute bottom-0 left-0 h-[1px] w-full bg-color-separator"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("flex px-[12px]", "flex-col justify-center gap-[11px]", "w-full flex-1"),
                        children: data && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupContent, {
                            message: message[selected],
                            setMessage: setMessage,
                            startAction: function() {
                                return setStylePopupOpen(true);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("w-full px-[12px] py-[20px]", "rounded-b-[10px] tablet:flex tablet:justify-center"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                            primary: true,
                            className: "w-full tablet:w-[340px]",
                            text: t("lbl_next"),
                            disabled: canStartSession(message[selected]),
                            onClick: function() {
                                setStylePopupOpen(true);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: close,
                        className: (0,clsx_m/* default */.Z)("hidden items-center justify-center tablet:flex", "absolute rounded-full border bg-color-popup-cell", "right-[-40px] top-0 aspect-1 w-[32px] border-color-separator"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                            format: "svg",
                            source: "/general/close"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StylesPopup, {
                isOpen: isStylePopupOpen,
                setIsOpen: setStylePopupOpen,
                selectors: selectors,
                selectedGender: selectedGender,
                inputsRequest: inputsRequest,
                submitData: function() {
                    close();
                    if (tokensSummery <= 0) {
                        setSubscriptionPopupOpen(true);
                        return;
                    }
                    setInputs({
                        aspect_id: inputsRequest.aspects.id,
                        voice_id: inputsRequest.voices.id,
                        actor_id: inputsRequest.actors.id,
                        music_id: inputsRequest.music.id,
                        caption_id: inputsRequest.captions.id,
                        message: message[selected]
                    });
                }
            })
        ]
    });
}
function PopupButton(props) {
    var name = props.name, action = props.action, isSelected = props.isSelected;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        onClick: action,
        className: (0,clsx_m/* default */.Z)(isSelected ? "text-primary-600" : "text-blue-700", "relative h-full flex-1 whitespace-nowrap px-[15px] text-[14px] font-600 leading-[20px] tablet:flex-none tablet:text-[16px]"),
        children: [
            t(name),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("absolute bottom-[0px] left-0 h-[1px] w-full bg-primary-500", "transition-opacity duration-300", !isSelected && "opacity-0")
            })
        ]
    });
}
function PopupContent(props) {
    var removeUploadedFile = function removeUploadedFile(index) {
        if (message.type !== "medias") {
            return;
        }
        var cleared = message.resources.filter(function(_, i) {
            return i !== index;
        });
        setMessage(function(o) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, o), {
                txt_medias_to_video: {
                    type: "medias",
                    resources: cleared
                }
            });
        });
    };
    var replaceGettedMedia = function replaceGettedMedia(newMedia) {
        setMessage(function(o) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, o), {
                txt_medias_to_video: {
                    type: "medias",
                    resources: o.txt_medias_to_video.resources.map(function(res) {
                        if (newMedia.index === res.index) {
                            return newMedia;
                        }
                        return res;
                    })
                }
            });
        });
    };
    var message = props.message, setMessage = props.setMessage, startAction = props.startAction;
    var t = (0,esm/* useTranslation */.$G)().t;
    var uploadedsRef = (0,react.useRef)(null);
    var maxCount = 10;
    var ref = (0,react.useState)(0), leftDistanse = ref[0], setLeftDistance = ref[1];
    var scrollImages = function(scrollOffset) {
        if (uploadedsRef.current) {
            var ref;
            uploadedsRef.current.scrollLeft += scrollOffset;
            setLeftDistance(((ref = uploadedsRef.current) === null || ref === void 0 ? void 0 : ref.scrollLeft) + scrollOffset);
        }
    };
    function onDrop(files) {
        return _onDrop.apply(this, arguments);
    }
    function _onDrop() {
        _onDrop = (0,_async_to_generator/* default */.Z)(function(files) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (message.type !== "medias") {
                    return [
                        2
                    ];
                }
                files.splice(0, maxCount - message.resources.length).forEach(function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(file) {
                        var isImage, extension, tempId, imageElem, url, ref, ref1, video, url1, ref2, ref3;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    isImage = file.type.includes("image");
                                    extension = file.type.split("/").at(-1);
                                    tempId = Math.random();
                                    if (!isImage) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        (0,utils_video/* getLoadedImage */.um)(file)
                                    ];
                                case 1:
                                    imageElem = _state.sent();
                                    setMessage(function(o) {
                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, o), {
                                            txt_medias_to_video: {
                                                type: "medias",
                                                resources: (0,_to_consumable_array/* default */.Z)(o.txt_medias_to_video.resources).concat([
                                                    {
                                                        media_type: "image",
                                                        resource_url: URL.createObjectURL(file),
                                                        aspect: imageElem.width / imageElem.height,
                                                        loading: true,
                                                        index: tempId
                                                    }, 
                                                ])
                                            }
                                        });
                                    });
                                    return [
                                        4,
                                        axios/* default.post */.Z.post("/api/wizard-upload", {
                                            extension: extension
                                        }).then(function(r) {
                                            return r.data;
                                        }).catch(function() {
                                            return console.error("upload faile case");
                                        })
                                    ];
                                case 2:
                                    url = _state.sent();
                                    return [
                                        4,
                                        axios/* default.put */.Z.put((ref = url === null || url === void 0 ? void 0 : url.upload) !== null && ref !== void 0 ? ref : "", file)
                                    ];
                                case 3:
                                    _state.sent();
                                    replaceGettedMedia({
                                        media_type: "image",
                                        resource_url: (ref1 = url === null || url === void 0 ? void 0 : url.download) !== null && ref1 !== void 0 ? ref1 : URL.createObjectURL(file),
                                        aspect: imageElem.width / imageElem.height,
                                        failed: (url === null || url === void 0 ? void 0 : url.download) === undefined ? true : undefined,
                                        index: tempId
                                    });
                                    return [
                                        3,
                                        8
                                    ];
                                case 4:
                                    return [
                                        4,
                                        (0,utils_video/* getLoadedVideo */.GF)(file)
                                    ];
                                case 5:
                                    video = _state.sent();
                                    setMessage(function(o) {
                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, o), {
                                            txt_medias_to_video: {
                                                type: "medias",
                                                resources: (0,_to_consumable_array/* default */.Z)(o.txt_medias_to_video.resources).concat([
                                                    {
                                                        media_type: "video",
                                                        resource_url: URL.createObjectURL(file),
                                                        aspect: video.videoWidth / video.videoHeight,
                                                        thumb_url: null,
                                                        loading: true,
                                                        index: tempId
                                                    }, 
                                                ])
                                            }
                                        });
                                    });
                                    return [
                                        4,
                                        axios/* default.post */.Z.post("/api/wizard-upload", {
                                            extension: extension
                                        }).then(function(r) {
                                            return r.data;
                                        }).catch(function() {
                                            return console.error("upload faile case");
                                        })
                                    ];
                                case 6:
                                    url1 = _state.sent();
                                    return [
                                        4,
                                        axios/* default.put */.Z.put((ref2 = url1 === null || url1 === void 0 ? void 0 : url1.upload) !== null && ref2 !== void 0 ? ref2 : "", file)
                                    ];
                                case 7:
                                    _state.sent();
                                    replaceGettedMedia({
                                        media_type: "video",
                                        resource_url: (ref3 = url1 === null || url1 === void 0 ? void 0 : url1.download) !== null && ref3 !== void 0 ? ref3 : URL.createObjectURL(file),
                                        aspect: video.videoWidth / video.videoHeight,
                                        thumb_url: null,
                                        failed: (url1 === null || url1 === void 0 ? void 0 : url1.download) === undefined ? true : undefined,
                                        index: tempId
                                    });
                                    _state.label = 8;
                                case 8:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(file) {
                        return _ref.apply(this, arguments);
                    };
                }());
                return [
                    2
                ];
            });
        });
        return _onDrop.apply(this, arguments);
    }
    var dropzoneState = (0,dist_es/* useDropzone */.uI)({
        accept: (0,simple_drop_area/* getFormatsFromMimeTypes */.lz)((0,_to_consumable_array/* default */.Z)(simple_drop_area/* mimeTypes.images */.aN.images).concat((0,_to_consumable_array/* default */.Z)(simple_drop_area/* mimeTypes.videos */.aN.videos))),
        onDrop: onDrop,
        maxFiles: maxCount,
        noClick: false
    });
    switch(message.type){
        case "medias":
            var haveFiles = message.resources.length !== 0;
            var formats = [
                "image/jpeg",
                "image/png",
                "video/mp4",
                "image/webp", 
            ];
            var backgroundImage = (0,clsx_m/* default */.Z)("url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25'", "xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25'", "fill='none' rx='8' ry='8' stroke='%23B699FA' stroke-width='5'", "stroke-dasharray='6%2c 14' stroke-dashoffset='14' stroke-linecap='round'/%3e%3c/svg%3e\")");
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex flex-col gap-[12px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (0,clsx_m/* default */.Z)(haveFiles && "hidden", "text-[16px] font-400 text-blue-600"),
                        children: t("txt_generate_video_medias")
                    }),
                    haveFiles ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        ref: uploadedsRef,
                        className: (0,clsx_m/* default */.Z)("no-scrollbar flex w-full animate-scale gap-[12px] scroll-smooth", "relative overflow-x-scroll border border-color-separator p-[16px]", "rounded-[9px] bg-color-surface-cell"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_drop_area/* DropAreaForModel */.Oh, {
                                state: dropzoneState,
                                openExplorer: dropzoneState.open,
                                formats: formats,
                                border: true,
                                className: (0,clsx_m/* default */.Z)(message.resources.length >= maxCount && "hidden", "h-[128px] min-w-[128px] max-w-[128px] rounded-[6px]"),
                                noText: true,
                                backgroundImage: backgroundImage
                            }),
                            message.resources.map(function(resource, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)("group relative h-[128px] min-w-[128px] rounded-[6px] bg-blue-100", "flex max-w-[128px] items-center justify-center"),
                                    children: [
                                        resource.media_type === "image" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: resource.resource_url,
                                                    alt: "user uploaded file",
                                                    className: "h-auto max-h-full overflow-hidden rounded-[6px] object-cover",
                                                    style: {
                                                        aspectRatio: resource.aspect
                                                    }
                                                }),
                                                resource.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (0,clsx_m/* default */.Z)("absolute left-0 top-0 h-full w-full", "flex items-center justify-center rounded-[6px] bg-color-popup"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "animate-spin",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: (0,cdn/* assetUrl */.p)("/general/loading-dark.webp"),
                                                            alt: "loading state",
                                                            className: "h-[18px] w-[18px]"
                                                        })
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                                    src: resource.resource_url + "#t=0.001",
                                                    className: "h-auto max-h-full overflow-hidden rounded-[6px] object-cover",
                                                    style: {
                                                        aspectRatio: resource.aspect
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: (0,clsx_m/* default */.Z)("absolute bottom-[8px] left-[8px]", "h-[24px] w-[24px]"),
                                                    alt: "play icon",
                                                    src: (0,cdn/* assetUrl */.p)("/general/play-white.png")
                                                }),
                                                resource.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (0,clsx_m/* default */.Z)("absolute left-0 top-0 h-full w-full", "flex items-center justify-center rounded-[6px] bg-color-popup"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "animate-spin",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                                            format: "webp",
                                                            source: "/general/loading",
                                                            className: "h-[18px] w-[18px]"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        resource.failed && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)("absolute left-0 top-0 h-full w-full", "flex items-center justify-center rounded-[6px] bg-color-popup"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: (0,cdn/* assetUrl */.p)("/general/warning-white.png"),
                                                alt: "warning white",
                                                className: "h-[24px] w-[24px]"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: function() {
                                                return removeUploadedFile(index);
                                            },
                                            className: (0,clsx_m/* default */.Z)("absolute right-[8px] top-[8px] h-[28px] w-[28px]", "rounded-full bg-color-cell hover:bg-primary-100", "cursor-pointer items-center justify-center border", "hidden border-color-separator group-hover:flex"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                                source: "/general/minus-gray",
                                                format: "svg",
                                                alt: "minus icon"
                                            })
                                        })
                                    ]
                                }, resource.resource_url);
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_drop_area/* DropAreaForModel */.Oh, {
                        state: dropzoneState,
                        openExplorer: dropzoneState.open,
                        border: true,
                        formats: formats,
                        className: (0,clsx_m/* default */.Z)("h-[182px] w-full rounded-[8px] desktop:h-[200px]"),
                        backgroundImage: backgroundImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (0,clsx_m/* default */.Z)(leftDistanse >= 610 || !haveFiles || message.resources.length < 5 ? "desktop:hidden" : "desktop:flex", "absolute hidden rounded-full bg-color-cell", "right-5 top-[55px] p-[4px] outline-none", "hover:bg-blue-100 disabled:bg-color-background"),
                        onClick: function() {
                            return scrollImages(200);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                            source: "/general/arrow",
                            format: "svg",
                            className: "h-[20px] w-[20px]"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (0,clsx_m/* default */.Z)(leftDistanse <= 45 || !haveFiles || message.resources.length < 5 ? "desktop:hidden" : "desktop:flex", "absolute hidden rounded-full bg-color-cell", "left-5 top-[55px] p-[4px] outline-none", "hover:bg-blue-100 disabled:bg-color-background"),
                        onClick: function() {
                            return scrollImages(-200);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                            source: "/general/arrow",
                            format: "svg",
                            className: "h-[20px] w-[20px] rotate-180"
                        })
                    })
                ]
            });
        case "script":
        case "idea":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-[16px] font-400 text-blue-600",
                        children: message.type === "idea" ? t("txt_generate_with_imagination") : t("txt_generate_with_script")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "rounded-[10px] bg-gradient-to-r from-[#5DA2F6] to-[#B15DF6] p-[2px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)("relative flex items-center gap-[4px] bg-color-cell", "h-[245px] rounded-[8px] px-[11px] py-[14px] tablet:h-[203px]"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_textarea/* Textarea */.g, {
                                placeholder: message.type === "idea" ? t("txt_write_your_idea") : t("txt_write_your_script"),
                                value: message.content,
                                setValue: function(v) {
                                    return setMessage(function(o) {
                                        if (message.type === "idea") {
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, o), {
                                                txt_idea_to_video: {
                                                    type: message.type,
                                                    content: v
                                                }
                                            });
                                        }
                                        if (message.type === "script") {
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, o), {
                                                txt_script_to_video: {
                                                    type: message.type,
                                                    content: v
                                                }
                                            });
                                        }
                                        return o;
                                    });
                                },
                                maxCount: 3000,
                                onKeyDown: function(e) {
                                    if (message.content === "") return;
                                    if (e.key === "Enter") {
                                        startAction();
                                    }
                                }
                            })
                        })
                    })
                ]
            });
        case "url":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-[16px] font-400 text-blue-600",
                        children: t("txt_generate_video_ads")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "rounded-[10px] bg-gradient-to-r from-[#5DA2F6] to-[#B15DF6] p-[2px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx_m/* default */.Z)("flex items-center gap-[4px] bg-color-cell", "rounded-[8px] px-[11px] py-[14px]"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                    source: "/general/url-icon",
                                    format: "svg",
                                    className: "h-[16px] w-[16px]"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "url",
                                    placeholder: t("txt_amazon_link"),
                                    value: message.content,
                                    className: (0,clsx_m/* default */.Z)("flex-1 text-[16px] placeholder:text-color-placeholder", "bg-color-cell text-blue-800 outline-none"),
                                    onChange: function(e) {
                                        if (e.target) {
                                            setMessage(function(o) {
                                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, o), {
                                                    txt_url_to_video: {
                                                        type: "url",
                                                        content: e.target.value
                                                    }
                                                });
                                            });
                                        }
                                    },
                                    onKeyDown: function(e) {
                                        if (e.key === "Enter") {
                                            var trimmedContent = message.content.trim();
                                            if (trimmedContent.length === 0) {
                                                return;
                                            }
                                            try {
                                                new URL(trimmedContent);
                                                startAction();
                                            } catch (e1) {
                                                e.preventDefault();
                                            }
                                        }
                                    }
                                })
                            ]
                        })
                    })
                ]
            });
    }
}
function extractInputsResponse(input) {
    return [
        {
            type: "actors",
            data: [
                {
                    id: null,
                    name: "No Actor",
                    thumbnail: null,
                    animated_thumbnail: null,
                    preview_url: null,
                    tags: null,
                    gender: null
                }, 
            ].concat((0,_to_consumable_array/* default */.Z)(input.actors.map(function(a) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, a), {
                    preview_url: null,
                    tags: null
                });
            })))
        },
        {
            type: "voices",
            data: input.voices.map(function(a) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, a), {
                    thumbnail: null,
                    animated_thumbnail: null
                });
            })
        },
        {
            type: "music",
            data: [
                {
                    id: null,
                    name: "None",
                    thumbnail: null,
                    animated_thumbnail: null,
                    preview_url: null,
                    tags: null,
                    gender: null
                }, 
            ].concat((0,_to_consumable_array/* default */.Z)(input.music.map(function(a) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, a), {
                    thumbnail: null,
                    animated_thumbnail: null,
                    preview_url: null,
                    tags: null,
                    gender: null
                });
            })))
        },
        {
            type: "aspects",
            data: input.aspects.map(function(a) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, a), {
                    thumbnail: null,
                    animated_thumbnail: null,
                    preview_url: null,
                    tags: null,
                    gender: null
                });
            })
        },
        {
            type: "captions",
            data: input.captions.map(function(a) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, a), {
                    name: "",
                    thumbnail: a.thumb_url,
                    animated_thumbnail: null,
                    preview_url: null,
                    tags: null,
                    gender: null
                });
            })
        }, 
    ];
}
function canStartSession(message) {
    switch(message.type){
        case "medias":
            return message.resources.length === 0 || message.resources.filter(function(e) {
                return e.failed || e.loading;
            }).length !== 0;
        case "url":
            try {
                new URL(message.content);
                return message.content.trim().length === 0;
            } catch (e) {
                return true;
            }
        case "idea":
        case "script":
            return message.content.trim().length === 0;
    }
}

;// CONCATENATED MODULE: ./sections/dashboard/reference-face-popup.tsx







function ReferenceFacePopup() {
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "reference-face-popup",
        className: (0,clsx_m/* default */.Z)("fixed left-0 top-0 z-[101] h-screen w-screen bg-color-popup", "items-center justify-center"),
        style: {
            display: "none"
        },
        onClick: function(e) {
            var target = e.target;
            if ((0,_instanceof/* default */.Z)(target, HTMLElement)) {
                if (target.id === "reference-face-popup") {
                    closeReferenceFacePopup();
                }
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)("flex flex-col gap-[10px] rounded-[10px] p-[24px]", "relative items-center bg-color-popup-cell desktop:w-[575px]"),
            style: {
                boxShadow: "0px 0px 30px 0px rgba(0, 0, 0, 0.13)"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-[18px] font-500 leading-normal text-blue-700",
                    children: t("txt_face_replace_guide_title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("flex w-full gap-[12px] rounded-[10px] desktop:flex-row", "flex-col-reverse bg-color-surface p-[8px]"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center gap-[12px]",
                            children: goodPhotos.map(function(photo) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative h-[86px] w-[86px] rounded-lg",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: (0,cdn/* assetUrl */.p)(photo),
                                            alt: "good photos",
                                            className: "pointer-events-none h-full w-full select-none rounded-lg"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute left-1 top-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckboxIcon */.PD, {})
                                        })
                                    ]
                                }, photo);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-1 flex-col justify-start gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[16px] font-600 leading-normal text-blue-800",
                                    children: t("txt_good_photos")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[14px] font-400 leading-[18px] text-blue-600",
                                    children: t("txt_make_sure_visible")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("flex w-full gap-[12px] rounded-[10px] desktop:flex-row", "flex-col-reverse bg-color-surface p-[8px]"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center gap-[12px]",
                            children: badPhotos.map(function(photo) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative h-[86px] w-[86px] rounded-lg",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: (0,cdn/* assetUrl */.p)(photo),
                                            alt: "bad photos",
                                            className: "pointer-events-none h-full w-full select-none rounded-lg"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute left-1 top-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {})
                                        })
                                    ]
                                }, photo);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-1 flex-col justify-start gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[16px] font-600 leading-normal text-blue-800",
                                    children: t("txt_bad_photos")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[14px] font-400 leading-[18px] text-blue-600",
                                    children: t("txt_group_pics")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: closeReferenceFacePopup,
                    className: (0,clsx_m/* default */.Z)("absolute -right-10 top-0 hidden h-8 w-8 items-center", "justify-center rounded-full desktop:flex", "bg-color-cell transition-colors hover:bg-blue-100"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                        format: "svg",
                        source: "/general/close"
                    })
                })
            ]
        })
    });
}
function closeReferenceFacePopup() {
    var popup = document.getElementById("reference-face-popup");
    if (popup) {
        popup.style.display = "none";
    }
}
var goodPhotos = [
    "/ai-tools/text-to-image/good-photo-1.webp",
    "/ai-tools/text-to-image/good-photo-2.webp",
    "/ai-tools/text-to-image/good-photo-3.webp", 
];
var badPhotos = [
    "/ai-tools/text-to-image/bad-photo-1.webp",
    "/ai-tools/text-to-image/bad-photo-2.webp",
    "/ai-tools/text-to-image/bad-photo-3.webp", 
];

// EXTERNAL MODULE: ./utils/millions.ts
var millions = __webpack_require__(323);
// EXTERNAL MODULE: ./sections/dashboard/icons.tsx
var dashboard_icons = __webpack_require__(1685);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(253);
// EXTERNAL MODULE: ./utils/infinite.ts
var infinite = __webpack_require__(275);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./sections/wizard/session-item.tsx










function SessionItem(props) {
    var id = props.id, active = props.active, setActive = props.setActive, name = props.name, changeName = props.changeName, setChangeName = props.setChangeName, selectedSessionId = props.selectedSessionId, selectSession = props.selectSession, status = props.status, setDeleteSessionPopup = props.setDeleteSessionPopup, remakeSession = props.remakeSession, onClick = props.onClick;
    var t = (0,esm/* useTranslation */.$G)().t;
    var selected = selectedSessionId === id;
    var tryChangeName = changeName !== null && changeName.id === id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (selected || changeName !== null) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            selectSession(id)
                        ];
                    case 1:
                        _state.sent();
                        onClick();
                        return [
                            2
                        ];
                }
            });
        }),
        className: (0,clsx_m/* default */.Z)(selected ? "bg-blue-100" : "bg-[unset]", tryChangeName ? "cursor-default border-2 border-blue-400" : "group cursor-pointer hover:bg-blue-100", "flex w-full justify-between rounded-[6px]", "relative animate-opacityOnce items-center pr-[10px]", active ? "z-20" : "z-10"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "session-container-".concat(id),
                className: (0,clsx_m/* default */.Z)(tryChangeName ? "p-[8px]" : "p-[10px]", "flex items-center gap-[8px]", "max-h-[46px] min-h-[46px]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,cdn/* assetUrl */.p)("/general/chat-icon.svg"),
                        alt: "chat icon",
                        className: "h-[20px] w-[20px]"
                    }),
                    tryChangeName ? /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        value: changeName.name,
                        onClick: function(e) {
                            return e.stopPropagation();
                        },
                        autoFocus: true,
                        onChange: function(e) {
                            var value = e.currentTarget.value;
                            if (value.length <= 100) {
                                setChangeName((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, changeName), {
                                    name: e.currentTarget.value
                                }));
                            }
                        },
                        className: (0,clsx_m/* default */.Z)("border-none bg-[unset] outline-none", "text-[14px] font-500")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (0,clsx_m/* default */.Z)(selected ? "desktop:max-w-[110px]" : "desktop:max-w-[130px]", "desktop:block group-hover:desktop:max-w-[110px]", "text-[14px] font-500 text-blue-700 max-w-[150px] truncate", "tablet:max-w-[110px]"),
                        children: name
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-[6px]",
                children: [
                    status !== "idle" && status !== "deleted" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)(tryChangeName && "hidden", selected ? "flex group-hover:flex" : "desktop:group-hover:hidden", "flex h-3 w-3 items-center justify-center tablet:h-[24px] tablet:w-[24px]"),
                        children: getStatusIcon(status)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_dropdown/* DropDown */.vb, {
                        closeOnClick: true,
                        closeInSelect: true,
                        trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)("h-[21px] shrink-0"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: function() {
                                    return setActive(id);
                                },
                                className: (0,clsx_m/* default */.Z)(tryChangeName && "desktop:hidden", !selected ? "group-hover:flex desktop:hidden" : "flex", "flex h-6 w-6 shrink-0 rotate-90 items-center justify-center"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,cdn/* assetUrl */.p)("/general/more-gray.svg"),
                                    alt: "more icon",
                                    className: "h-[18px] w-[18px] shrink-0"
                                })
                            })
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx_m/* default */.Z)("z-50 flex flex-col gap-[4px] p-[10px]", "absolute rounded-[10px] bg-color-popup-cell", "right-[0px] top-[50px] tablet:top-[40px]", "w-[160px] border border-color-separator"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    onClick: function() {
                                        setActive(null);
                                        setChangeName({
                                            id: id,
                                            name: name
                                        });
                                    },
                                    className: (0,clsx_m/* default */.Z)("rounded-[8px] p-[12px] hover:bg-blue-100", "flex h-[44px] w-full items-center gap-[6px]"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: (0,cdn/* assetUrl */.p)("/general/edit.svg"),
                                            alt: "edit icon",
                                            className: "h-[20px] w-[20px]"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-[14px] font-500 text-blue-800",
                                            children: t("txt_rename")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    onClick: function() {
                                        setActive(null);
                                        remakeSession(id);
                                    },
                                    className: (0,clsx_m/* default */.Z)(status === "completed" ? "flex" : "hidden", "rounded-[8px] p-[12px] hover:bg-blue-100", "h-[44px] w-full items-center gap-[6px]"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: (0,cdn/* assetUrl */.p)("/general/remake.png"),
                                            alt: "remake icon",
                                            className: "h-[20px] w-[20px]"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-[14px] font-500 text-blue-800",
                                            children: t("txt_remake_video")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    onClick: function() {
                                        setActive(null);
                                        setDeleteSessionPopup(id);
                                    },
                                    className: (0,clsx_m/* default */.Z)("rounded-[8px] p-[12px] hover:bg-blue-100", "flex h-[44px] w-full items-center gap-[6px]"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: (0,cdn/* assetUrl */.p)("/general/trash-red.png"),
                                            alt: "edit icon",
                                            className: "h-[20px] w-[20px]"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-[14px] font-500 text-color-error",
                                            children: t("lbl_delete")
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
function getStatusIcon(status) {
    switch(status){
        case "deleted":
        case "idle":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "analyzing":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: (0,cdn/* assetUrl */.p)("/general/analyzing.webp"),
                alt: "analyzing icon",
                width: 24,
                height: 24
            });
        case "visualizing":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: (0,cdn/* assetUrl */.p)("/general/visualizing.webp"),
                alt: "visualizing icon",
                width: 24,
                height: 24
            });
        case "generating":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                source: "/general/generating",
                format: "webp",
                className: "h-[24px] w-[24px]"
            });
        case "completed":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-6 w-6 [--icon-color:var(--color-blue-400)]",
                children: CompletedIcon()
            });
        case "error":
        case "retryable_error":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-[6px] w-[6px] rounded-full bg-color-error"
            });
        case "waiting":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-[6px] w-[6px] rounded-full bg-color-success"
            });
        case "client-loading":
        case "loading":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("flex gap-[2px] tablet:gap-1", "items-center"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("h-[4px] w-[4px] animate-loading rounded-full bg-blue-400 [animation-delay:0.1s] tablet:h-[6px] tablet:w-[6px]")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("h-[4px] w-[4px] animate-loading rounded-full bg-blue-400 [animation-delay:0.2s] tablet:h-[6px] tablet:w-[6px]")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("h-[4px] w-[4px] animate-loading rounded-full bg-blue-400 [animation-delay:0.3s] tablet:h-[6px] tablet:w-[6px]")
                    })
                ]
            });
    }
}
var CompletedIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M20.3996 6L7.71389 18L3.59961 13.2",
            stroke: "var(--icon-color)",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

;// CONCATENATED MODULE: ./sections/dashboard/sessions-sidebar.tsx














function SessionsSidebar(props) {
    var pushSessionUrl = function pushSessionUrl() {
        var query = (0,_object_spread/* default */.Z)({}, router.query);
        var params = Object.entries(query).map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            if (key !== "initial_message" && key !== "session_id") {
                return "".concat(key, "=").concat(value);
            }
        }).join("&");
        router.push("/chat?".concat(params));
    };
    var setChangeName = props.setChangeName, selectSession = props.selectSession, loadMoreSessions = props.loadMoreSessions, setDeleteSessionPopup = props.setDeleteSessionPopup, setSubscriptionPopupOpen = props.setSubscriptionPopupOpen, clearChatScreen = props.clearChatScreen, remakeSession = props.remakeSession, duplicateSession = props.duplicateSession, changeName = props.changeName, sessionsGroup = props.sessionsGroup, selectedSessionId = props.selectedSessionId, sessions = props.sessions, textAreaRef = props.textAreaRef, onClick = props.onClick;
    var t = (0,esm/* useTranslation */.$G)().t;
    var lastRowRef = (0,react.useRef)(null);
    var scrollableParent = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var userInfo = (0,client_auth/* default */.ZP)().userInfo;
    var ref = (0,react.useState)(null), activeSessionId = ref[0], setActiveSessionId = ref[1];
    var initialData = (0,react.useRef)({
        pages: [
            Object.values(sessions).map(function(s) {
                return s === null || s === void 0 ? void 0 : s.id;
            })
        ],
        pageParams: [
            Object.values(sessions).length
        ]
    });
    var STALE_SECONDS = 60;
    var query = (0,es.useInfiniteQuery)({
        queryKey: [
            "sessions-group"
        ],
        queryFn: function(param) {
            var pageParam = param.pageParam;
            return loadMoreSessions(pageParam !== null && pageParam !== void 0 ? pageParam : 0);
        },
        getNextPageParam: function(last, all) {
            var offset = all.reduce(function(acc, curr) {
                return acc + curr.length;
            }, 0);
            if (last.length === 0 && initialData.current.pageParams[0] !== 0) {
                return undefined;
            }
            return offset;
        },
        staleTime: STALE_SECONDS * 1000,
        initialData: initialData.current
    });
    (0,infinite/* default */.Z)(query, lastRowRef, 100, true, scrollableParent.current);
    var wallet = (0,coins/* useCoins */.YO)();
    var ref1, ref2;
    var tokensSummery = ((ref1 = wallet === null || wallet === void 0 ? void 0 : wallet.permanentTokens) !== null && ref1 !== void 0 ? ref1 : 0) + ((ref2 = wallet === null || wallet === void 0 ? void 0 : wallet.temporaryTokens) !== null && ref2 !== void 0 ? ref2 : 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("gap-[10px]", "h-full w-full pb-[50px]", "flex flex-col duration-300"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    disabled: wallet === null,
                    onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                        var ref;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            pushSessionUrl();
                            if (tokensSummery <= 0) {
                                setSubscriptionPopupOpen(true);
                            } else {
                                ;
                                (ref = textAreaRef.current) === null || ref === void 0 ? void 0 : ref.focus();
                                clearChatScreen();
                            }
                            return [
                                2
                            ];
                        });
                    }),
                    className: (0,clsx_m/* default */.Z)(wallet && tokensSummery <= 0 ? "border border-green-400 text-green-600 hover:bg-green-50" : " border border-primary-500 text-primary-500 hover:bg-primary-100", "flex select-none transition-colors disabled:opacity-70", "max-h-[44px] min-h-[44px] w-full rounded-[6px] disabled:pointer-events-none", "items-center justify-center gap-[8px] p-[16px] desktop:flex desktop:p-0"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)("h-4 w-4", wallet && tokensSummery <= 0 ? "[--icon-color:var(--color-green-600)]" : "[--icon-color:var(--color-primary-500)]"),
                            children: PlusIcon()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (0,clsx_m/* default */.Z)("block text-[16px] font-600"),
                            children: t("txt_new_video")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: scrollableParent,
                className: (0,clsx_m/* default */.Z)(userInfo.isAnonymous ? "hidden" : "flex", "scrollbar flex-1 flex-col", "gap-[5px] overflow-y-scroll pr-[6px]"),
                children: [
                    sessionsGroup.map(function(group) {
                        var isEmptyGroup = group.sessions.filter(function(s) {
                            var ref;
                            return ((ref = sessions[s.id]) === null || ref === void 0 ? void 0 : ref.status) !== "deleted";
                        }).map(function(s) {
                            return s;
                        }).length === 0;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx_m/* default */.Z)(isEmptyGroup && "hidden", "flex flex-col gap-[8px] tablet:gap-0"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)("mb-[6px] mt-[12px] block"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (0,clsx_m/* default */.Z)("text-[17px] text-blue-600 tablet:text-blue-800", "ml-[8px] font-500 tablet:text-[14px]"),
                                        children: group.started
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-col gap-[9px] tablet:gap-1",
                                    children: group.sessions.filter(function(s) {
                                        var ref;
                                        return ((ref = sessions[s.id]) === null || ref === void 0 ? void 0 : ref.status) !== "deleted";
                                    }).map(function(session) {
                                        var ref;
                                        var ref1;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SessionItem, {
                                            id: session.id,
                                            active: session.id === activeSessionId,
                                            setActive: setActiveSessionId,
                                            remakeSession: remakeSession,
                                            duplicateSession: duplicateSession,
                                            name: session.name,
                                            changeName: changeName,
                                            setChangeName: setChangeName,
                                            selectedSessionId: selectedSessionId,
                                            selectSession: selectSession,
                                            status: (ref1 = (ref = sessions[session.id]) === null || ref === void 0 ? void 0 : ref.status) !== null && ref1 !== void 0 ? ref1 : "idle",
                                            setDeleteSessionPopup: setDeleteSessionPopup,
                                            onClick: onClick
                                        }, session.id);
                                    })
                                })
                            ]
                        }, group.started);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: lastRowRef
                    })
                ]
            })
        ]
    });
}
var PlusIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.1665 7.99984H13.8332M8.49984 2.6665L8.49984 13.3332",
            stroke: "var(--icon-color)",
            strokeWidth: "2",
            strokeLinecap: "round"
        })
    });
};

;// CONCATENATED MODULE: ./sections/dashboard/side-bar.tsx













function SideBar(props) {
    var ref;
    var page = props.activePage, isClosed = props.isClosed, activeChild = props.activeChild, selectedTool = props.selectedTool, changeActiveChild = props.changeActiveChild, closeSidebar = props.closeSidebar, setSubscriptionPopupOpen = props.setSubscriptionPopupOpen, changeSelectedPage = props.changeSelectedPage, selectCreatorTool = props.selectCreatorTool;
    var ref1 = (0,react.useState)(page !== "home"), renderChilds = ref1[0], setRenderChilds = ref1[1];
    var ref2 = (0,react.useState)(false), showSessions = ref2[0], setShowSessions = ref2[1];
    var items = (0,react.useMemo)(function() {
        return [
            {
                name: "home",
                href: "/home",
                title: "lbl_home",
                icon: (0,dashboard_icons/* homeIcon */.WR)("22", "22"),
                childs: null
            },
            {
                name: "videoGpt",
                href: "/video-gpt",
                title: "txt_video_gpt",
                icon: (0,dashboard_icons/* videoGptIcon */.zl)("22", "22"),
                childs: [
                    {
                        name: "lbl_projects",
                        href: "/chat",
                        icon: (0,dashboard_icons/* projectsIcon */.Xm)("22", "22"),
                        action: function() {
                            return changeSelectedPage("chat");
                        }
                    }, 
                ]
            },
            {
                name: "discover",
                href: "/discover",
                title: "lbl_discover",
                icon: (0,dashboard_icons/* discoverIcon */.nE)("22", "22"),
                childs: null
            }, 
        ];
    }, [
        changeSelectedPage
    ]);
    var initialIndex = items.findIndex(function(a) {
        return a.name === page;
    });
    var ref3 = (0,react.useState)(initialIndex !== -1 ? initialIndex : 0), index = ref3[0], setIndex = ref3[1];
    (0,react.useEffect)(function() {
        var ref;
        if (((ref = props.sessionsGroup) === null || ref === void 0 ? void 0 : ref.selectedSessionId) !== null) {
            setIndex(1);
            setRenderChilds(true);
        }
        var newIndex = items.findIndex(function(a) {
            return a.name === page;
        });
        if (page !== "chat") {
            setIndex(newIndex !== -1 ? newIndex : 0);
            setRenderChilds(newIndex !== -1 && items[newIndex].childs ? true : false);
        } else {
            setIndex(1);
            setShowSessions(true);
            setRenderChilds(true);
        }
    }, [
        items,
        page,
        (ref = props.sessionsGroup) === null || ref === void 0 ? void 0 : ref.selectedSessionId
    ]);
    var item = items[index];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "dashboard-sidebar-bg",
                onClick: function(e) {
                    if ((0,_instanceof/* default */.Z)(e.currentTarget, HTMLElement)) {
                        if (e.currentTarget.id === "dashboard-sidebar-bg") {
                            closeSidebar();
                        }
                    }
                },
                className: (0,clsx_m/* default */.Z)(isClosed ? " pointer-events-none opacity-0" : "opacity-100", "fixed left-0 top-0 z-[99] h-full w-full bg-color-popup transition-opacity desktop:hidden")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("fixed left-0 top-0 z-[100] h-[100svh] w-[80%] overflow-hidden bg-color-sidebar-bg transition-all tablet:w-[240px]", isClosed ? "-translate-x-full tablet:translate-x-[-240px]" : "translate-x-0"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)("flex h-full shrink-0 flex-row pb-[70px] pt-[100px] transition-all", renderChilds && "-translate-x-full tablet:-translate-x-[240px]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)("h-full w-full shrink-0 flex-col px-[12px] tablet:flex", "ease-in-out tablet:gap-[44px]", "group items-start bg-color-sidebar-bg"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex h-full w-full flex-col justify-between",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,clsx_m/* default */.Z)("flex w-full flex-col gap-2 tablet:items-center"),
                                        children: items.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SideBarItem, {
                                                item: item,
                                                isClosed: isClosed,
                                                isSelected: page === item.name,
                                                changeSelectedPage: function() {
                                                    changeSelectedPage(item.name);
                                                    if (item.childs !== null) {
                                                        setRenderChilds(true);
                                                        setIndex(index);
                                                    }
                                                    if (item.name === "discover") {
                                                        changeActiveChild("lbl_ad_examples");
                                                    }
                                                    if (true) {
                                                        if (window.innerWidth < 1224) {
                                                            closeSidebar();
                                                        }
                                                    }
                                                }
                                            }, index);
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)("flex h-full w-full flex-col", "no-scrollbar shrink-0 overflow-y-auto ease-in-out", "items-start bg-color-sidebar-bg", isClosed && "hidden", item.name !== "videoGpt" && "px-3"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,clsx_m/* default */.Z)("w-full", item.name === "videoGpt" && "px-3"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            onClick: function() {
                                                changeSelectedPage("home");
                                                setRenderChilds(false);
                                                setShowSessions(false);
                                                setIndex(0);
                                            },
                                            className: (0,clsx_m/* default */.Z)("mb-3 flex h-[40px] w-full shrink-0 flex-row items-center", "justify-start gap-2 rounded-[4px] px-2 hover:bg-blue-100"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "rotate-90 [--icon-color:var(--color-blue-600)]",
                                                    children: ArrowIcon()
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-[14px] font-400 tracking-[0.3px] text-blue-600",
                                                    children: "Back to Home"
                                                })
                                            ]
                                        })
                                    }),
                                    item.childs && item.name !== "videoGpt" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex w-full flex-col gap-1",
                                        children: item.childs.map(function(child, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SideBarItemChild, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, child), {
                                                activeChild: activeChild,
                                                changeActiveChild: changeActiveChild
                                            }), index);
                                        })
                                    }),
                                    item.childs && item.name === "videoGpt" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,clsx_m/* default */.Z)("flex max-h-[calc(100%-55px)] w-full flex-row transition-all duration-200", showSessions ? "-translate-x-full" : "translate-x-0"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex w-full shrink-0 flex-col gap-1 px-3",
                                                children: item.childs.map(function(child, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectsMenu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, child), {
                                                        activeChild: activeChild,
                                                        changeActiveChild: changeActiveChild,
                                                        setShowSessions: setShowSessions
                                                    }), index);
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex max-h-full w-full shrink-0 px-3",
                                                children: props.sessionsGroup !== null && props.activePage === "chat" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SessionsSidebar, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.sessionsGroup), {
                                                    setSubscriptionPopupOpen: setSubscriptionPopupOpen,
                                                    onClick: function() {
                                                        if (true) {
                                                            if (window.innerWidth < 1224) {
                                                                closeSidebar();
                                                            }
                                                        }
                                                    }
                                                }))
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)("fixed left-3 top-3 flex w-full items-center px-1 desktop:top-[6px]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function() {
                                    return closeSidebar();
                                },
                                className: "[--icon-color:var(--color-blue-800)] desktop:hidden",
                                children: CloseIcon()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/home",
                                className: "max-w-[90px] desktop:h-[35px] desktop:w-[101px] desktop:max-w-none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                    source: "/comps/logo",
                                    format: "svg",
                                    alt: "Zoomerang main logo"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("fixed bottom-3 left-0 w-full", isClosed ? "px-2" : "px-3"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TokensAndStorage, {
                            setSubscriptionPopupOpen: setSubscriptionPopupOpen
                        })
                    })
                ]
            })
        ]
    });
}
function SideBarItemChild(props) {
    var name = props.name, icon = props.icon, href = props.href, action = props.action, content = props.content, activeChild = props.activeChild, changeActiveChild = props.changeActiveChild;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(true), isOpen = ref[0], setIsOpen = ref[1];
    var ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            href ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                href: href,
                onClick: function(e) {
                    if (action) {
                        e.preventDefault();
                        action();
                    }
                },
                className: (0,clsx_m/* default */.Z)("flex h-11 w-full shrink-0 flex-row items-center gap-2 rounded-[4px] px-2 hover:bg-blue-100", activeChild === name ? "bg-blue-100 text-blue-900" : "text-blue-600", !content && "my-[2px]"),
                children: [
                    icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("flex items-center justify-center", "transition-all", activeChild === name ? "[--icon-color:var(--color-blue-900)]" : "[--icon-color:var(--color-blue-600)]"),
                        children: icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (0,clsx_m/* default */.Z)("text-[14px] font-500 tracking-[0.3px]"),
                        children: t(name)
                    })
                ]
            }, name) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                onClick: function() {
                    return setIsOpen(function(o) {
                        return !o;
                    });
                },
                className: (0,clsx_m/* default */.Z)("flex h-8 w-full shrink-0 flex-row items-center gap-2 rounded-[4px] px-2", "hover:bg-blue-100"),
                children: [
                    content && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("transition-all", isOpen ? "[--icon-color:var(--color-blue-500)]" : "-rotate-90 [--icon-color:var(--color-blue-700)]"),
                        children: ArrowIcon()
                    }),
                    icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "[--icon-color:var(--color-blue-800)]",
                        children: icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (0,clsx_m/* default */.Z)(" tracking-[0.3px] transition-all", isOpen ? "text-[14px] font-500 text-blue-500" : "text-[14px] font-500 text-blue-700"),
                        children: t(name)
                    })
                ]
            }),
            content && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    height: isOpen ? "".concat(((ref1 = content === null || content === void 0 ? void 0 : content.length) !== null && ref1 !== void 0 ? ref1 : 0) * 44 + (((ref2 = content === null || content === void 0 ? void 0 : content.length) !== null && ref2 !== void 0 ? ref2 : 1) - 1) * 8, "px") : "0px"
                },
                className: "flex w-full shrink-0 flex-col gap-[8px] overflow-hidden transition-all",
                children: content === null || content === void 0 ? void 0 : content.map(function(a) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: a.href,
                        onClick: function(e) {
                            changeActiveChild(a.name);
                            if (a.action) {
                                e.preventDefault();
                                a.action();
                            }
                        },
                        className: (0,clsx_m/* default */.Z)("flex h-11 w-full shrink-0 flex-row items-center gap-2", "rounded-[4px] px-2 text-blue-600 hover:bg-blue-100", activeChild === a.name ? "bg-blue-100 text-blue-900" : "text-blue-600"),
                        children: [
                            a.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)("flex items-center justify-center", "transition-all [--icon-color:var(--color-blue-600)]", activeChild === a.name ? "[--icon-color:var(--color-blue-900)]" : "[--icon-color:var(--color-blue-600)]"),
                                children: a.icon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (0,clsx_m/* default */.Z)("text-[14px] font-500 tracking-[0.3px]"),
                                children: t(a.name)
                            })
                        ]
                    }, a.name);
                })
            })
        ]
    });
}
function ProjectsMenu(props) {
    var name = props.name, icon = props.icon, href = props.href, action = props.action, setShowSessions = props.setShowSessions;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        href: href,
        onClick: function(e) {
            if (action) {
                e.preventDefault();
                action();
                setShowSessions(true);
            }
        },
        className: (0,clsx_m/* default */.Z)("hover:bg-blue-100", "relative w-full gap-[8px]", "flex h-11 items-center justify-between rounded-[4px] px-[8px] transition-all"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row items-center gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("[--icon-color:var(--color-blue-600)]", "flex items-center justify-center"),
                        children: icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (0,clsx_m/* default */.Z)("text-blue-600", "text-[14px] font-500 tracking-[0.4px]"),
                        children: t(name)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "-rotate-90 [--icon-color:var(--color-blue-600)]",
                children: ArrowIcon()
            })
        ]
    }, name);
}
function SideBarItem(props) {
    var item = props.item, changeSelectedPage = props.changeSelectedPage, isSelected = props.isSelected;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: item.href,
            onClick: function(e) {
                e.preventDefault();
                changeSelectedPage();
            },
            className: (0,clsx_m/* default */.Z)(isSelected ? "bg-blue-100" : "hover:bg-blue-100", "relative w-full gap-[8px]", "flex h-11 items-center justify-between rounded-[4px] px-[8px] transition-all"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)(isSelected ? "[--icon-color:var(--color-blue-900)]" : "[--icon-color:var(--color-blue-600)]", "flex items-center justify-center"),
                            children: item.icon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (0,clsx_m/* default */.Z)(isSelected ? "text-blue-900" : "text-blue-600", "text-[14px] font-500 tracking-[0.4px]"),
                            children: t(item.title)
                        })
                    ]
                }),
                (item.childs || item.href === "/chat") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "-rotate-90 [--icon-color:var(--color-blue-600)]",
                    children: ArrowIcon()
                })
            ]
        })
    });
}
function TokensAndStorage(props) {
    var setSubscriptionPopupOpen = props.setSubscriptionPopupOpen;
    var t = (0,esm/* useTranslation */.$G)().t;
    var wallet = (0,coins/* useCoins */.YO)();
    var smallTokensTooltip = (wallet === null || wallet === void 0 ? void 0 : wallet.renewInfo) === null || (wallet === null || wallet === void 0 ? void 0 : wallet.renewInfo.cancelled) === true;
    var ref, ref1;
    var tokensSummery = ((ref = wallet === null || wallet === void 0 ? void 0 : wallet.permanentTokens) !== null && ref !== void 0 ? ref : 0) + ((ref1 = wallet === null || wallet === void 0 ? void 0 : wallet.temporaryTokens) !== null && ref1 !== void 0 ? ref1 : 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)("desktop:rounded-[4px]", "w-full self-center rounded-[4px] bg-blue-100"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            onClick: function() {
                return setSubscriptionPopupOpen(true);
            },
            className: (0,clsx_m/* default */.Z)("desktop:justify-between desktop:px-[8px] desktop:py-[12px]", "flex w-full items-center justify-between px-2 py-3"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-[2px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (0,clsx_m/* default */.Z)("tracking-[0.6px] desktop:block", "text-[15px] font-400 text-blue-800"),
                            children: t("lbl_tokens")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative z-10",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,cdn/* assetUrl */.p)("/general/info.svg"),
                                    alt: "info icon",
                                    className: (0,clsx_m/* default */.Z)("peer h-[16px] w-[16px] cursor-pointer")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)(smallTokensTooltip ? "-top-[70px]" : "-top-[80px]", "absolute left-1/4 -translate-x-1/4", "z-20 hidden peer-hover:flex"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,clsx_m/* default */.Z)("relative rounded-[8px] bg-color-tooltip px-[12px]", "py-[8px]"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (0,clsx_m/* default */.Z)(smallTokensTooltip ? "line-clamp-2 min-w-[180px]" : "line-clamp-3 min-w-[190px]", "tracking-[0.24px] text-blue-100", "text-[12px] font-400 leading-normal"),
                                                children: (wallet === null || wallet === void 0 ? void 0 : wallet.renewInfo) ? t("fs_tokens_renew", {
                                                    tokens: tokensSummery,
                                                    renew: wallet.renewInfo.tokens
                                                }) : tokensSummery > 0 ? t("fs_tokens_available", {
                                                    tokens: tokensSummery
                                                }) : t("txt_dont_have_tokens")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (0,clsx_m/* default */.Z)("h-[10px] w-[10px] bg-color-tooltip", "absolute left-1/4 rotate-45 rounded-[2px]", "bottom-[-5px] -translate-x-1/4")
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,cdn/* assetUrl */.p)("/general/token.svg"),
                            alt: "token icon",
                            className: "h-[16px] w-[16px]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (0,clsx_m/* default */.Z)("text-[15px] font-500 text-blue-700 desktop:text-[15px]"),
                            children: wallet ? (0,millions/* default */.Z)(tokensSummery) : "-"
                        })
                    ]
                })
            ]
        })
    });
}
var CloseIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.53493 6.6498C8.01423 6.1291 7.17001 6.1291 6.64931 6.6498C6.12861 7.1705 6.12861 8.01472 6.64931 8.53542L14.114 16.0001L6.64931 23.4648C6.12861 23.9855 6.12861 24.8297 6.64931 25.3504C7.17001 25.8711 8.01423 25.8711 8.53493 25.3504L15.9996 17.8857L23.4643 25.3504C23.985 25.8711 24.8292 25.8711 25.3499 25.3504C25.8706 24.8297 25.8706 23.9855 25.3499 23.4648L17.8852 16.0001L25.3499 8.53542C25.8706 8.01472 25.8706 7.1705 25.3499 6.6498C24.8292 6.1291 23.985 6.1291 23.4643 6.6498L15.9996 14.1145L8.53493 6.6498Z",
            fill: "var(--icon-color)"
        })
    });
};
var ArrowIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5.38086 7.69043L10 12.3096L14.6191 7.69043",
            stroke: "var(--icon-color)",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

// EXTERNAL MODULE: ./sections/gallery/ad-examples-popup.tsx
var ad_examples_popup = __webpack_require__(6685);
// EXTERNAL MODULE: ./sections/gallery/gallery-popup.tsx + 2 modules
var gallery_popup = __webpack_require__(7276);
// EXTERNAL MODULE: ./sections/history/history-popup.tsx
var history_popup = __webpack_require__(1027);
// EXTERNAL MODULE: ./comps/message.tsx
var message = __webpack_require__(9034);
// EXTERNAL MODULE: ./comps/player.tsx + 1 modules
var player = __webpack_require__(1993);
// EXTERNAL MODULE: ./node_modules/qrcode.react/lib/esm/index.js
var lib_esm = __webpack_require__(4059);
// EXTERNAL MODULE: ./sections/history/generations.tsx
var generations = __webpack_require__(5170);
// EXTERNAL MODULE: ./node_modules/video-provider/dist/esm/index.js
var dist_esm = __webpack_require__(1501);
;// CONCATENATED MODULE: ./sections/wizard/completed-message-popup.tsx





















function CompletedMessagePopup(props) {
    var initial = props.initial, setCompletedMessage = props.setCompletedMessage;
    var videoUrl = initial.videoUrl, videoWidth = initial.videoWidth, videoHeight = initial.videoHeight, previewImage = initial.previewImage;
    var videoRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), qrPopup = ref[0], setQrPopup = ref[1];
    (0,dist/* useShortCut */.Xg)({
        shortCut: "Escape",
        handler: function() {
            setCompletedMessage(null);
            setQrPopup(false);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "completed-message-popup",
        onClick: function(e) {
            var target = e.target;
            if ((0,_instanceof/* default */.Z)(target, HTMLElement)) {
                if (target.id === "completed-message-popup") {
                    setCompletedMessage(null);
                }
                if (!target.className.includes("chat-qr") && qrPopup) {
                    setQrPopup(false);
                }
            }
        },
        className: (0,clsx_m/* default */.Z)("absolute inset-0 z-[110] h-screen w-full bg-color-popup", "no-scrollbar tablet:fixed tablet:overflow-y-scroll tablet:py-[100px]", "tablet:flex tablet:items-center tablet:justify-center"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)("no-scrollbar relative z-[101] flex h-full w-full flex-col", "tablet:w-[669px] tablet:rounded-[12px] desktop:flex-row", "tablet:rounded-[12px] desktop:w-auto"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    onClick: function() {
                        return setCompletedMessage(null);
                    },
                    className: (0,clsx_m/* default */.Z)("absolute rounded-full bg-color-popup p-[7px]", "left-[20px] top-[20px] z-[111] tablet:right-[-40px]", "tablet:left-auto tablet:top-0 tablet:bg-color-popup-cell", "tablet:border tablet:border-color-separator"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,cdn/* assetUrl */.p)("/general/close-dark.svg"),
                            alt: "close icon",
                            className: "h-[18px] w-[18px] desktop:hidden"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                            source: "/general/close",
                            format: "svg",
                            alt: "close icon",
                            className: "hidden h-[18px] w-[18px] desktop:block"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("relative flex max-h-[calc(100svh-88px)] w-full shrink-0 overflow-hidden bg-color-dashboard-bg", "tablet:h-[667px] tablet:max-h-none tablet:items-center tablet:justify-center tablet:rounded-t-[10px] tablet:bg-[transparent]", "desktop:h-[680px] desktop:w-[680px] desktop:flex-1 desktop:rounded-l-[10px] desktop:rounded-tr-none"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)("absolute inset-0 h-full w-full overflow-hidden bg-color-black filter tablet:h-auto", "hidden overflow-hidden tablet:block desktop:rounded-r-none"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: previewImage,
                                alt: "preview image",
                                className: "h-full w-full scale-110 object-cover opacity-30 blur-lg"
                            })
                        }),
                        videoUrl && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                aspectRatio: videoWidth / videoHeight
                            },
                            className: "relative z-10 mx-auto h-full bg-color-cell tablet:mx-0 tablet:h-auto tablet:max-h-[600px] tablet:w-auto tablet:max-w-[500px] tablet:rounded-t-[10px] desktop:max-h-[600px] desktop:max-w-[525px] desktop:rounded-[10px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                    style: {
                                        aspectRatio: videoWidth / videoHeight
                                    },
                                    src: videoUrl,
                                    poster: previewImage,
                                    ref: videoRef,
                                    playsInline: true,
                                    autoPlay: true,
                                    loop: true,
                                    className: "relative z-10 tablet:max-h-[600px] tablet:w-auto tablet:max-w-[500px] tablet:rounded-t-[10px] desktop:max-h-[600px] desktop:max-w-[525px] desktop:rounded-[10px]"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_esm/* VideoProvider */.G, {
                                    remember: [],
                                    element: videoRef,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute bottom-0 left-0 z-50 w-full text-color-white",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(player/* Timeline */.TY, {
                                                radius: "0px 0px 10px 10px"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(player/* PlayWithProvider */.uX, {})
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CompletedContentSection, {
                    initial: initial,
                    qrPopup: qrPopup,
                    setQrPopup: setQrPopup
                })
            ]
        })
    });
}
function CompletedContentSection(props) {
    var _initial = props.initial, title = _initial.title, videoDesc = _initial.videoDesc, shareUrl = _initial.shareUrl, videoUrl = _initial.videoUrl, previewImage = _initial.previewImage, resultId = _initial.resultId;
    var setQrPopup = props.setQrPopup, qrPopup = props.qrPopup;
    var ref = (0,react.useState)(false), showMore = ref[0], setShowMore = ref[1];
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref1 = (0,react.useState)(false), downloadApi = ref1[0], setDownloadApi = ref1[1];
    (0,react.useEffect)(function() {
        if (downloadApi) return;
        var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isIOS || isSafari) {
            setDownloadApi(true);
            return;
        }
    }, [
        downloadApi
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("flex flex-1 flex-col bg-color-popup-cell tablet:flex-none tablet:flex-col-reverse tablet:bg-[unset] desktop:w-[318px] desktop:bg-color-popup-cell", "desktop:h-[680px] desktop:rounded-r-[12px]", "pb-[38px] tablet:pb-0 desktop:relative desktop:justify-between"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("flex w-full items-center gap-[12px] py-[20px]", "bg-color-background tablet:flex-col tablet:bg-color-popup-cell", "tablet:mb-[100px] tablet:rounded-b-[12px] desktop:rounded-bl-none", "px-[16px] desktop:mb-0 desktop:rounded-br-[12px]", "fixed bottom-0 left-0 z-50 tablet:relative"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function() {
                            return setQrPopup(true);
                        },
                        className: (0,clsx_m/* default */.Z)("w-full items-center bg-color-chat-alpha desktop:flex", "hidden h-[48px] justify-center rounded-[4px]"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-[4px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                    source: "/general/edit",
                                    className: "h-[18px] w-[18px]",
                                    format: "png?aaa",
                                    alt: "edit icon"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-[15px] font-600 text-blue-700",
                                    children: t("lbl_edit")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: shareUrl,
                        className: (0,clsx_m/* default */.Z)("flex w-full items-center bg-color-chat-alpha", "h-[48px] justify-center rounded-[4px] desktop:hidden"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-[4px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                    source: "/general/edit",
                                    className: "h-[18px] w-[18px]",
                                    format: "png?aaa",
                                    alt: "edit icon"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-[15px] font-600 text-blue-800",
                                    children: t("lbl_edit")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: videoUrl === "" ? "/api/download-music?link=".concat(encodeURIComponent(previewImage)) : downloadApi ? "/api/download-video?link=".concat(encodeURIComponent(videoUrl), "&name=").concat(encodeURIComponent(props.initial.title)) : videoUrl,
                        onClick: function() {
                            return axios/* default.post */.Z.post("/api/wizard-save-result-event", {
                                result_id: resultId
                            });
                        },
                        datatype: "mp4",
                        download: props.initial.title + ".mp4",
                        target: "_blank",
                        rel: "noreferrer noopener",
                        className: (0,clsx_m/* default */.Z)("flex w-full items-center bg-color-chat", "h-[48px] justify-center rounded-[4px]"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-[4px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,cdn/* assetUrl */.p)("/general/download-white.png"),
                                    className: "h-[18px] w-[18px]",
                                    alt: "edit icon"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-[15px] font-600 text-color-white",
                                    children: t("lbl_download")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("flex flex-col gap-[10px] bg-color-popup-cell pb-[50px]", " pt-[10px] tablet:pb-0 desktop:rounded-tr-[12px]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "px-[16px] text-[18px] font-500 text-blue-800",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (0,clsx_m/* default */.Z)(showMore && "max-h-[100px] overflow-y-scroll", "no-scrollbar px-[16px] text-[16px] font-400 text-blue-800", "tablet:max-h-[200px] desktop:max-h-[300px]"),
                        children: [
                            showMore ? videoDesc : videoDesc.substring(0, 150),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                onClick: function() {
                                    return setShowMore(function(old) {
                                        return !old;
                                    });
                                },
                                className: (0,clsx_m/* default */.Z)(videoDesc.length <= 150 && "hidden", showMore && "ml-[10px]", "cursor-pointer text-[16px] font-600 text-blue-800"),
                                children: showMore ? "less" : "...more"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShareSection, {
                        shareUrl: shareUrl
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)(qrPopup ? "desktop:flex" : "desktop:hidden", "absolute hidden h-full w-full pb-[150px]", "items-end justify-center rounded-r-[12px]"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("h-[300px] w-[220px] bg-blue-cell shadow-xl", "flex flex-col items-center rounded-[10px]", "chat-qr justify-center gap-[22px] border", "border-color-separator"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "chat-qr rounded-[8px] bg-color-white p-[14px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_esm/* default */.ZP, {
                                className: "chat-qr",
                                size: 135,
                                bgColor: "#fff",
                                fgColor: "#575a6b",
                                value: shareUrl,
                                renderAs: "canvas"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "chat-qr flex flex-col items-center gap-[13px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "chat-qr text-[18px] font-600 text-blue-700",
                                    children: t("txt_chat_qr_title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "chat-qr w-[197px] text-center text-[14px] font-400 text-blue-700",
                                    children: t("txt_chat_qr_desc")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function SocialShareSection(props) {
    var shareUrl = props.shareUrl, isSingle = props.isSingle;
    var t = (0,esm/* useTranslation */.$G)().t;
    var notify = (0,react.useContext)(notification/* NotificationContext */.u).notify;
    function handleCopy(text) {
        return _handleCopy.apply(this, arguments);
    }
    function _handleCopy() {
        _handleCopy = (0,_async_to_generator/* default */.Z)(function(text) {
            var e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            navigator.clipboard.writeText(text)
                        ];
                    case 1:
                        _state.sent();
                        notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* SuccessMessage */.kk, {
                            children: t("common:txt_successfully_copied")
                        }));
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        console.error(e);
                        notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* ErrorMessage */.Bc, {
                            children: t("common:txt_couldnt_copy")
                        }));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleCopy.apply(this, arguments);
    }
    var _icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)(isSingle && "bg-color-cell tablet:rounded-[8px]", isSingle && "tablet:border-none", "border-y  border-y-color-separator", "flex flex-col gap-[12px] py-[16px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,clsx_m/* default */.Z)(isSingle && "tablet:hidden", "px-[16px] text-[18px] font-500 text-blue-700"),
                children: t("txt_share_to")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)(isSingle && "tablet:overflow-x-hidden tablet:pl-[30px] tablet:pr-[16px]", "flex w-full overflow-x-scroll px-[16px]", "no-scrollbar -mb-[30px] gap-[8px] pb-[30px]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                                var target;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            target = e.currentTarget;
                                            target.disabled = true;
                                            setTimeout(function() {
                                                target.disabled = false;
                                            }, 3000);
                                            return [
                                                4,
                                                handleCopy(shareUrl)
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(e) {
                                return _ref.apply(this, arguments);
                            };
                        }(),
                        className: (0,clsx_m/* default */.Z)("flex items-center justify-center", "transition-colors hover:bg-blue-300", "h-[44px] w-[44px] shrink-0 rounded-full bg-color-surface"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,cdn/* assetUrl */.p)("/ai-tools/history/copy-primary.svg"),
                            alt: "copy icon",
                            className: "h-[20px] w-[20px]"
                        })
                    }),
                    generations/* socials.map */.UY.map(function(props) {
                        return /*#__PURE__*/ (0,react.createElement)(ad_examples_popup/* SocialButton */.Z0, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                            slug: shareUrl,
                            key: (_icon = props.icon) !== null && _icon !== void 0 ? _icon : props.light
                        }));
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
// EXTERNAL MODULE: ./utils/scroll-context.tsx + 1 modules
var scroll_context = __webpack_require__(2715);
// EXTERNAL MODULE: ./node_modules/react-responsive-masonry/es/index.js + 2 modules
var react_responsive_masonry_es = __webpack_require__(2337);
// EXTERNAL MODULE: ./comps/skeleton.tsx
var skeleton = __webpack_require__(4165);
;// CONCATENATED MODULE: ./hooks/localstorage-getter.ts


function useLocalstorageGetter(key, initialValue) {
    var getStoredValue = function getStoredValue() {
        try {
            var item = localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            console.error(error);
            return initialValue;
        }
    };
    var ref = (0,react.useState)(getStoredValue()), storedValue = ref[0], setStoredValue = ref[1];
    (0,react.useEffect)(function() {
        try {
            var valueToStore = (0,_instanceof/* default */.Z)(storedValue, Function) ? storedValue(storedValue) : storedValue;
            localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {
            console.error(error);
        }
    }, [
        key,
        storedValue
    ]);
    return [
        storedValue,
        setStoredValue
    ];
}

;// CONCATENATED MODULE: ./sections/wizard/edit-segments-comps.tsx







function EditSegmentsHeader(props) {
    var selected = props.selected, setSelected = props.setSelected, closePopup = props.closePopup, hasWebsite = props.hasWebsite;
    var t = (0,esm/* useTranslation */.$G)().t;
    var header = hasWebsite ? [
        {
            name: "lbl_media",
            value: "lbl_upload"
        },
        {
            name: "txt_stock_media",
            value: "txt_stock_media"
        },
        {
            name: "lbl_website",
            value: "txt_website_images"
        }, 
    ] : [
        {
            name: "lbl_media",
            value: "lbl_upload"
        },
        {
            name: "txt_stock_media",
            value: "txt_stock_media"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("flex h-[50px] w-full items-center justify-between px-[12px]", "min-h-[50px] border-b border-color-separator"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex h-full",
                children: header.map(function(elem) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function() {
                            return setSelected(elem.value);
                        },
                        className: (0,clsx_m/* default */.Z)(selected === elem.value ? "border-primary-600" : "border-color-separator", "flex h-full items-center justify-center border-b px-[16px]"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (0,clsx_m/* default */.Z)(selected === elem.value ? "text-primary-600" : "text-blue-800", "text-[16px] font-500 leading-[20px]"),
                            children: t(elem.name)
                        })
                    }, elem.value);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: closePopup,
                className: (0,clsx_m/* default */.Z)("items-center justify-center desktop:hidden"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                    format: "svg",
                    source: "/general/close",
                    className: "h-[24px] w-[24px]"
                })
            })
        ]
    });
}
function Footer(props) {
    var maxUploadCount = props.maxUploadCount, currentUploadCount = props.currentUploadCount, selectedMedias = props.selectedMedias, selectedItem = props.selectedItem, setSelectedItem = props.setSelectedItem, sendSelectedMedias = props.sendSelectedMedias, removeSelected = props.removeSelected, closePopup = props.closePopup;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("flex h-[203px] w-full flex-col py-[10px] tablet:flex-row", "tablet:h-[129px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("no-scrollbar mt-[-150px] flex w-full gap-[10px] overflow-x-scroll px-[16px] pt-[150px]"),
                children: selectedMedias.map(function(media, i) {
                    var index = i + 1;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "group relative flex flex-col items-center gap-[4px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function() {
                                    return setSelectedItem(index);
                                },
                                className: (0,clsx_m/* default */.Z)(selectedItem === index ? "border-primary-600" : "border-color-separator", "h-[78px] min-w-[78px] rounded-[10px] border-[1.5px] p-[5px]", "relative flex max-w-[78px] items-center justify-center"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditSegmentsMediaItem, (0,_object_spread/* default */.Z)({}, media))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,clsx_m/* default */.Z)(selectedItem === index ? "text-primary-600" : "text-blue-400", "text-[13px] font-600"),
                                children: index
                            }),
                            media.media_type !== "empty" && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function() {
                                    return removeSelected(index);
                                },
                                className: (0,clsx_m/* default */.Z)("absolute right-[10px] top-[10px] h-[24px] w-[24px]", "rounded-full bg-color-cell hover:bg-primary-100", "cursor-pointer items-center justify-center", "hidden group-hover:flex"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                    source: "/general/minus-gray",
                                    format: "svg",
                                    alt: "minus icon"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)(i === 0 ? "left-[-10px]" : "left-1/2 -translate-x-1/2 ", "absolute group-hover:opacity-100", "bottom-[120px] flex max-w-[400px] transition-opacity", "z-40 min-w-max opacity-0 duration-300"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,clsx_m/* default */.Z)(i === 0 ? "left-[45px]" : "left-1/2 -translate-x-1/2", "h-[12px] w-[12px] rotate-45 rounded-[3px] bg-color-tooltip", "absolute -bottom-[5px]")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,clsx_m/* default */.Z)("max-w-[250px] bg-color-tooltip p-[8px] text-blue-100", "w-full rounded-[8px] text-[13px] font-500 leading-[14px]"),
                                        children: media.hint
                                    })
                                ]
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("flex items-center justify-center px-[16px] pb-[16px] pt-[9px]", "tablet:w-[314px]"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                    onClick: function() {
                        closePopup();
                        sendSelectedMedias({
                            name: "media_source",
                            medias: selectedMedias
                        });
                    },
                    disabled: selectedMedias.find(function(m) {
                        return m.media_type === "empty" || m.loading;
                    }) ? true : false,
                    primary: true,
                    text: "".concat(t("lbl_send"), " (").concat(currentUploadCount, "/").concat(maxUploadCount, ")"),
                    className: "w-full max-w-[343px] tablet:max-w-[282px]"
                })
            })
        ]
    });
}
function EditSegmentsMediaItem(props) {
    var media_type = props.media_type;
    switch(media_type){
        case "empty":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "aspect-1 h-full max-h-full rounded-[5px] bg-blue-200"
            });
        case "image":
            var _resource_thumb_url;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (_resource_thumb_url = props.resource_thumb_url) !== null && _resource_thumb_url !== void 0 ? _resource_thumb_url : props.resource_url,
                        alt: "user uploaded file",
                        className: "h-full max-h-full w-full overflow-hidden rounded-[6px] object-cover",
                        style: {
                            aspectRatio: props.aspect
                        }
                    }),
                    props.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("absolute left-0 top-0 h-full w-full", "flex items-center justify-center rounded-[6px] bg-color-popup"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "animate-spin",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,cdn/* assetUrl */.p)("/general/loading-dark.webp?aa"),
                                alt: "loading",
                                className: "h-[18px] w-[18px]"
                            })
                        })
                    })
                ]
            });
        case "video":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    props.thumb_url === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        src: props.resource_url + "#t=0.001",
                        className: "h-full max-h-full w-full overflow-hidden rounded-[6px] object-cover",
                        style: {
                            aspectRatio: props.aspect
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: props.thumb_url,
                        alt: "thumbnail",
                        className: "h-full max-h-full w-full overflow-hidden rounded-[6px] object-cover",
                        style: {
                            aspectRatio: props.aspect
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (0,clsx_m/* default */.Z)("absolute bottom-[8px] left-[8px]", "h-[24px] w-[24px]"),
                        alt: "play white",
                        src: (0,cdn/* assetUrl */.p)("/general/play-white.png")
                    }),
                    props.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("absolute left-0 top-0 h-full w-full", "flex items-center justify-center rounded-[6px] bg-color-popup"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "animate-spin",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                format: "webp",
                                source: "/general/loading",
                                className: "h-[18px] w-[18px]"
                            })
                        })
                    })
                ]
            });
    }
}

// EXTERNAL MODULE: ./pages/tools/index.tsx
var tools = __webpack_require__(9274);
;// CONCATENATED MODULE: ./sections/wizard/edit-segments-content.tsx











function EditSegmentsContent(props) {
    var selected = props.selected, websiteUrl = props.websiteUrl, selectedOrientation = props.selectedOrientation, stockMediaType = props.stockMediaType, relatedSearch = props.relatedSearch, mediaTypeFilter = props.mediaTypeFilter, dropzoneState = props.dropzoneState, hasUploadedFiles = props.hasUploadedFiles, storedSearches = props.storedSearches, addNewSearch = props.addNewSearch, setStockLoading = props.setStockLoading, setMediaTypeFilter = props.setMediaTypeFilter, chooseStockMediaType = props.chooseStockMediaType, searchStock = props.searchStock, selectOrientation = props.selectOrientation;
    var ref = (0,react.useState)(""), inputValue = ref[0], setInputValue = ref[1];
    var ref1 = (0,react.useState)(false), inputFocus = ref1[0], setInputFocus = ref1[1];
    var t = (0,esm/* useTranslation */.$G)().t;
    (0,react.useEffect)(function() {
        var handleClickOutside = function(e) {
            var target = e.target;
            if ((0,_instanceof/* default */.Z)(target, HTMLElement)) {
                if (target.className.includes("stock-input") || target.className.includes("searches-container")) {
                    setInputFocus(true);
                } else {
                    setInputFocus(false);
                }
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    (0,dist/* useShortCut */.Xg)({
        shortCut: "Enter",
        handler: function() {
            setStockLoading();
            setInputFocus(false);
            searchStock(inputValue);
            if (inputValue !== "") {
                addNewSearch(inputValue);
            }
        }
    });
    switch(selected){
        case "lbl_upload":
            var formats = [
                "image/jpeg",
                "image/png",
                "video/mp4",
                "image/webp", 
            ];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex h-[76px] items-center px-[16px] tablet:h-[80px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)(hasUploadedFiles ? "flex" : "hidden", "w-full gap-[11px] tablet:justify-between"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_drop_area/* DropAreaForModel */.Oh, {
                            state: dropzoneState,
                            openExplorer: dropzoneState.open,
                            className: "tablet:max-w-[214px]",
                            formats: formats,
                            noText: true,
                            button: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_dropdown/* DropDown */.vb, {
                            className: "relative z-10",
                            closeOnClick: true,
                            closeInSelect: true,
                            trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownTrigger, {
                                small: false,
                                selected: mediaTypeFilter
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)("absolute z-20 flex w-[145px] flex-col gap-[2px] p-[10px]", "rounded-[8px] border border-color-separator bg-color-surface", "right-0 top-[50px]"),
                                children: [
                                    {
                                        name: "all",
                                        icon: (0,dashboard_icons/* allIcon */.X9)()
                                    },
                                    {
                                        name: "image",
                                        icon: (0,dashboard_icons/* imageIcon */.yy)()
                                    },
                                    {
                                        name: "video",
                                        icon: (0,dashboard_icons/* videoIcon */.H1)()
                                    }, 
                                ].map(function(e) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        onClick: function() {
                                            return setMediaTypeFilter(e.name);
                                        },
                                        className: (0,clsx_m/* default */.Z)(mediaTypeFilter === e.name ? "bg-blue-200" : "hover:bg-blue-100", "flex w-full items-center gap-[6px] rounded-[4px]", "px-[8px] py-[12px] [--icon-color:var(--color-blue-800)]"),
                                        children: [
                                            e.icon,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-[15px] font-500 leading-[18px] text-blue-800",
                                                children: t("lbl_".concat(e.name))
                                            })
                                        ]
                                    }, e.name);
                                })
                            })
                        })
                    ]
                })
            });
        case "txt_stock_media":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("flex h-[160px] px-[16px] py-[12px] tablet:h-[114px] tablet:pt-[16px]", "desktop:h-[118px]"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("flex w-full flex-col gap-[16px] tablet:flex-row", "tablet:justify-between"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative flex flex-col gap-[10px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)(inputFocus ? "border-blue-150" : "border-color-surface-cell", "relative flex w-full gap-[4px] bg-color-surface-cell pl-[14px]", "h-[44px] rounded-[6px] border pr-[34px] tablet:max-w-[437px]", "tablet:w-[440px] desktop:w-[520px] desktop:pl-[34px] desktop:pr-[14px]", "stock-input"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            placeholder: t("lbl_search"),
                                            value: inputValue,
                                            onChange: function(e) {
                                                var inputValue = e.currentTarget.value;
                                                if (inputValue.length <= 1000) {
                                                    setInputValue(inputValue);
                                                }
                                            },
                                            className: (0,clsx_m/* default */.Z)("text-[17px] font-400 placeholder:text-color-placeholder", "w-full bg-color-surface-cell outline-none", "stock-input")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: function() {
                                                searchStock(inputValue);
                                                setStockLoading();
                                                if (inputValue !== "") {
                                                    addNewSearch(inputValue);
                                                }
                                            },
                                            className: (0,clsx_m/* default */.Z)("absolute right-[14px] top-1/2 -translate-y-1/2 cursor-default", "[--icon-color:var(--color-placeholder)] desktop:left-[14px] desktop:right-auto", "stock-input"),
                                            children: (0,dashboard_icons/* searchIcon */.RL)()
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    onClick: function() {
                                        setInputValue(relatedSearch);
                                        searchStock(relatedSearch);
                                        setStockLoading();
                                    },
                                    className: (0,clsx_m/* default */.Z)("flex items-center gap-[6px] rounded-[6px] bg-blue-150 p-[12px]", "min-w-max max-w-min"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                            source: "/general/search-icon",
                                            format: "png",
                                            alt: "search icon",
                                            className: "h-[12px] w-[12px]"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "truncate text-[13px] font-400 leading-[12px] text-blue-800",
                                            children: relatedSearch
                                        })
                                    ]
                                }),
                                storedSearches && storedSearches.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)(inputFocus ? "flex" : "hidden", "absolute left-0 top-[54px] flex-col rounded-[8px]", "gap-[2px] border border-color-separator py-[12px]", "no-scrollbar max-h-[254px] w-full overflow-y-scroll", "searches-container z-40 bg-color-popup-cell"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (0,clsx_m/* default */.Z)("ml-[16px] text-[15px] font-500 leading-[20px] text-blue-500", "searches-container"),
                                            children: t("txt_search_history")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "searches-container flex flex-col",
                                            children: storedSearches.map(function(s, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    onClick: function() {
                                                        setInputValue(s);
                                                        searchStock(s);
                                                        setInputFocus(false);
                                                        setStockLoading();
                                                    },
                                                    className: (0,clsx_m/* default */.Z)("h-[40px] w-full px-[16px] hover:bg-blue-100", "searches-container flex items-center"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (0,clsx_m/* default */.Z)("text-[15px] font-400 leading-[20px] text-blue-800", "searches-container"),
                                                        children: s
                                                    })
                                                }, index);
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterSection, {
                            stockMediaType: stockMediaType,
                            selectedOrientation: selectedOrientation,
                            selectOrientation: selectOrientation,
                            chooseStockMediaType: chooseStockMediaType
                        })
                    ]
                })
            });
        case "txt_website_images":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex h-[72px] items-center px-[16px] tablet:h-[100px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)("rounded-[10px] bg-gradient-to-r from-[#5DA2F6] to-[#B15DF6] p-[2px]", "tablet:mx-[12px] desktop:w-[661px] desktop:self-center"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)("flex items-center gap-[6px] bg-color-cell", "h-[44px] w-full overflow-hidden rounded-[8px] pl-[14px]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_image/* CustomThemedResource */.aK, {
                                source: "/general/url-icon",
                                format: "svg",
                                className: "h-[16px] w-[16px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,clsx_m/* default */.Z)("line-clamp-1 shrink-0 text-[17px] font-400 text-blue-800"),
                                children: websiteUrl
                            })
                        ]
                    })
                })
            });
    }
}
function DropDownTrigger(props) {
    var t = (0,esm/* useTranslation */.$G)().t;
    var _selected;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)(props.small ? "h-[34px]" : "h-[44px]", "flex items-center justify-center desktop:mt-[8px]", "w-full gap-[2px] rounded-[6px] bg-blue-200 desktop:h-[36px]", "pl-[10px] pr-[6px] desktop:bg-[unset] desktop:hover:bg-blue-200"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,clsx_m/* default */.Z)("text-[16px] font-500 text-blue-800"),
                children: t("lbl_".concat((_selected = props.selected) !== null && _selected !== void 0 ? _selected : "all"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("flex rotate-90 items-center justify-center", "transition-all [--icon-color:var(--color-blue-800)]"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tools.Arrow, {})
            })
        ]
    });
}
function FilterSection(props) {
    var stockMediaType = props.stockMediaType, selectOrientation = props.selectOrientation, selectedOrientation = props.selectedOrientation, chooseStockMediaType = props.chooseStockMediaType;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-2 gap-[12px] tablet:flex",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_dropdown/* DropDown */.vb, {
                className: "relative z-10",
                triggerClassName: "w-full",
                closeOnClick: true,
                closeInSelect: true,
                trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownTrigger, {
                    selected: selectedOrientation,
                    small: true
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)("absolute z-20 flex flex-col gap-[2px] p-[10px]", "rounded-[8px] border border-color-separator bg-color-surface", "right-0 top-[50px] w-full tablet:w-[150px]"),
                    children: [
                        {
                            name: null,
                            icon: (0,dashboard_icons/* allIcon */.X9)()
                        },
                        {
                            name: "landscape",
                            icon: (0,dashboard_icons/* landscapeIcon */.cv)()
                        },
                        {
                            name: "portrait",
                            icon: (0,dashboard_icons/* portraitIcon */.sN)()
                        }, 
                    ].map(function(e) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            onClick: function() {
                                return selectOrientation(e.name);
                            },
                            className: (0,clsx_m/* default */.Z)(selectedOrientation === e.name ? "bg-blue-200" : "hover:bg-blue-100", "flex w-full items-center gap-[6px] rounded-[4px]", "px-[8px] py-[12px] [--icon-color:var(--color-blue-800)]"),
                            children: [
                                e.icon,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-[15px] font-500 leading-[18px] text-blue-800",
                                    children: e.name === null ? t("lbl_all") : t("lbl_".concat(e.name))
                                })
                            ]
                        }, e.name);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_dropdown/* DropDown */.vb, {
                className: "relative z-10",
                triggerClassName: "w-full",
                closeOnClick: true,
                closeInSelect: true,
                trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownTrigger, {
                    selected: stockMediaType,
                    small: true
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)("absolute z-20 flex w-full flex-col gap-[2px] p-[10px]", "rounded-[8px] border border-color-separator bg-color-surface", "right-0 top-[50px] tablet:w-[150px]"),
                    children: [
                        {
                            name: "image",
                            icon: (0,dashboard_icons/* imageIcon */.yy)()
                        },
                        {
                            name: "video",
                            icon: (0,dashboard_icons/* videoIcon */.H1)()
                        }, 
                    ].map(function(e) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            onClick: function() {
                                return chooseStockMediaType(e.name);
                            },
                            className: (0,clsx_m/* default */.Z)(stockMediaType === e.name ? "bg-blue-200" : "hover:bg-blue-100", "flex w-full items-center gap-[6px] rounded-[4px]", "px-[8px] py-[12px] [--icon-color:var(--color-blue-800)]"),
                            children: [
                                e.icon,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-[15px] font-500 leading-[18px] text-blue-800",
                                    children: t("lbl_".concat(e.name))
                                })
                            ]
                        }, e.name);
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./sections/wizard/edit-segments-popup.tsx
























function EditSegmentsPopup(props) {
    var addNewSearch = function addNewSearch(search) {
        setStoreSearches(function(o) {
            return [
                search
            ].concat((0,_to_consumable_array/* default */.Z)(o.slice(0, 9)));
        });
    };
    var searchStock = function searchStock(query) {
        setStockRequest(function(o) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, o), {
                query: query === "" ? data.stock.queries[(selectedItem !== null && selectedItem !== void 0 ? selectedItem : 1) - 1] : query
            });
        });
    };
    var selectOrientation = function selectOrientation(v) {
        if (v === stockRequest.orientation) {
            return;
        }
        setStockLoading("loading");
        setStockRequest(function(o) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, o), {
                orientation: v
            });
        });
    };
    var chooseStockMediaType = function chooseStockMediaType(type) {
        if (type === stockRequest.media_type) {
            return;
        }
        setStockLoading("loading");
        setStockRequest(function(o) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, o), {
                media_type: type
            });
        });
    };
    var replaceChoosenMedia = function replaceChoosenMedia(media) {
        setSelectedMedias(function(old) {
            return old.map(function(item, index) {
                if (item.index === selectedItem) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, media), {
                        hint: data.segments[index].media.description,
                        index: item.index
                    });
                }
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                    hint: data.segments[index].media.description
                });
            });
        });
        setSelectedItem(function(o) {
            if (o && o + 1 > data.segments.length) {
                return null;
            } else {
                return (o !== null && o !== void 0 ? o : 1) + 1;
            }
        });
    };
    var removeSelected = function removeSelected(index) {
        setSelectedMedias(function(o) {
            return o.map(function(item) {
                if (item.index === index) {
                    var _hint;
                    return {
                        media_type: "empty",
                        hint: (_hint = item.hint) !== null && _hint !== void 0 ? _hint : "",
                        index: index
                    };
                }
                return item;
            });
        });
        setSelectedItem(index);
    };
    var findAndSyncLoadingFromSelectedMedias = function findAndSyncLoadingFromSelectedMedias(oldUrl, newUrl) {
        setSelectedMedias(function(medias) {
            return medias.map(function(m) {
                if (m.media_type === "empty" || m.resource_url !== oldUrl) {
                    return m;
                } else {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, m), {
                        resource_url: newUrl,
                        loading: false
                    });
                }
            });
        });
    };
    var ref;
    var data = props.data, sendSelectedMedias = props.sendSelectedMedias, closePopup = props.closePopup, initialSelected = props.initialSelected;
    var ref1 = (0,react.useState)(initialSelected), selected = ref1[0], setSelected = ref1[1];
    var ref2 = (0,react.useState)(initializeMedias(data.segments)), selectedMedias = ref2[0], setSelectedMedias = ref2[1];
    var ref3 = (0,react.useState)(1), selectedItem = ref3[0], setSelectedItem = ref3[1];
    var ref4 = (0,react.useState)({
        query: data.stock.queries[0],
        limit: 10,
        offset: 0,
        orientation: null,
        media_type: "image"
    }), stockRequest = ref4[0], setStockRequest = ref4[1];
    var lastRowRef = (0,react.useRef)(null);
    var scrollableParentRef = (0,react.useRef)(null);
    var ref5 = (0,react.useState)("loading"), stockLoading = ref5[0], setStockLoading = ref5[1];
    var ref6 = (0,react.useState)([]), uploadedMedias = ref6[0], setUploadedMedias = ref6[1];
    var ref7 = (0,react.useState)("all"), mediaTypeFilter = ref7[0], setMediaTypeFilter = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)(useLocalstorageGetter("edit-segments-search-history", []), 2), storedSearches = ref8[0], setStoreSearches = ref8[1];
    var stockQuery = (0,es.useInfiniteQuery)({
        queryKey: [
            "stock-content",
            stockRequest.media_type,
            stockRequest.orientation,
            stockRequest.query, 
        ],
        queryFn: function(param) {
            var pageParam = param.pageParam;
            return getStockContent(pageParam !== null && pageParam !== void 0 ? pageParam : 0);
        },
        getNextPageParam: function(last, all) {
            if (last.length !== 10) {
                return undefined;
            }
            return all.reduce(function(acc, curr) {
                return acc + curr.length;
            }, 0);
        },
        enabled: selected === "txt_stock_media" && stockRequest.query !== ""
    });
    (0,infinite/* default */.Z)(stockQuery, lastRowRef, 100, selected === "txt_stock_media" && stockRequest.query !== "", scrollableParentRef.current);
    var ref9;
    var stockContent = (0,scroll_context/* flattenAndFilterArrays */.nf)((ref9 = (ref = stockQuery.data) === null || ref === void 0 ? void 0 : ref.pages) !== null && ref9 !== void 0 ? ref9 : [], function(x) {
        return x;
    }, function(x) {
        return x.resource_url;
    });
    function getStockContent(offset) {
        return _getStockContent.apply(this, arguments);
    }
    function _getStockContent() {
        _getStockContent = (0,_async_to_generator/* default */.Z)(function(offset) {
            var result;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/wizard-search-stock", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, stockRequest), {
                                offset: offset
                            })).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        setStockLoading(result.medias.length === 0 ? "no_result" : "result");
                        return [
                            2,
                            result.medias
                        ];
                }
            });
        });
        return _getStockContent.apply(this, arguments);
    }
    var dropzoneState = (0,dist_es/* useDropzone */.uI)({
        accept: (0,simple_drop_area/* getFormatsFromMimeTypes */.lz)((0,_to_consumable_array/* default */.Z)(simple_drop_area/* mimeTypes.images */.aN.images).concat((0,_to_consumable_array/* default */.Z)(simple_drop_area/* mimeTypes.videos */.aN.videos))),
        onDrop: onDrop,
        maxFiles: 10,
        noClick: false
    });
    function onDrop(files) {
        return _onDrop.apply(this, arguments);
    }
    function _onDrop() {
        _onDrop = (0,_async_to_generator/* default */.Z)(function(files) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                files.forEach(function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(file) {
                        var isImage, extension, index, imageElem, initialUrl, url, ref, ref1, resource_url, video, initialUrl1, url1, ref2, ref3, resource_url1;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    isImage = file.type.includes("image");
                                    extension = file.type.split("/").at(-1);
                                    index = Math.random();
                                    if (!isImage) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        (0,utils_video/* getLoadedImage */.um)(file)
                                    ];
                                case 1:
                                    imageElem = _state.sent();
                                    initialUrl = URL.createObjectURL(file);
                                    setUploadedMedias(function(o) {
                                        return [
                                            {
                                                media_type: "image",
                                                resource_url: initialUrl,
                                                aspect: imageElem.width / imageElem.height,
                                                loading: true,
                                                index: index
                                            }, 
                                        ].concat((0,_to_consumable_array/* default */.Z)(o));
                                    });
                                    return [
                                        4,
                                        axios/* default.post */.Z.post("/api/wizard-upload", {
                                            extension: extension
                                        }).then(function(r) {
                                            return r.data;
                                        }).catch(function() {
                                            return console.error("upload faile case");
                                        })
                                    ];
                                case 2:
                                    url = _state.sent();
                                    return [
                                        4,
                                        axios/* default.put */.Z.put((ref = url === null || url === void 0 ? void 0 : url.upload) !== null && ref !== void 0 ? ref : "", file)
                                    ];
                                case 3:
                                    _state.sent();
                                    resource_url = (ref1 = url === null || url === void 0 ? void 0 : url.download) !== null && ref1 !== void 0 ? ref1 : initialUrl;
                                    setUploadedMedias(function(o) {
                                        return o.map(function(elem) {
                                            if (elem.index === index) {
                                                return {
                                                    media_type: "image",
                                                    resource_url: resource_url,
                                                    aspect: imageElem.width / imageElem.height,
                                                    failed: (url === null || url === void 0 ? void 0 : url.download) === undefined ? true : undefined,
                                                    index: index
                                                };
                                            }
                                            return elem;
                                        });
                                    });
                                    findAndSyncLoadingFromSelectedMedias(initialUrl, resource_url);
                                    return [
                                        3,
                                        8
                                    ];
                                case 4:
                                    return [
                                        4,
                                        (0,utils_video/* getLoadedVideo */.GF)(file)
                                    ];
                                case 5:
                                    video = _state.sent();
                                    initialUrl1 = URL.createObjectURL(file);
                                    setUploadedMedias(function(o) {
                                        return [
                                            {
                                                media_type: "video",
                                                resource_url: initialUrl1,
                                                aspect: video.videoWidth / video.videoHeight,
                                                thumb_url: null,
                                                loading: true,
                                                index: index
                                            }, 
                                        ].concat((0,_to_consumable_array/* default */.Z)(o));
                                    });
                                    return [
                                        4,
                                        axios/* default.post */.Z.post("/api/wizard-upload", {
                                            extension: extension
                                        }).then(function(r) {
                                            return r.data;
                                        }).catch(function() {
                                            return console.error("upload faile case");
                                        })
                                    ];
                                case 6:
                                    url1 = _state.sent();
                                    return [
                                        4,
                                        axios/* default.put */.Z.put((ref2 = url1 === null || url1 === void 0 ? void 0 : url1.upload) !== null && ref2 !== void 0 ? ref2 : "", file)
                                    ];
                                case 7:
                                    _state.sent();
                                    resource_url1 = (ref3 = url1 === null || url1 === void 0 ? void 0 : url1.download) !== null && ref3 !== void 0 ? ref3 : initialUrl1;
                                    setUploadedMedias(function(o) {
                                        return o.map(function(elem) {
                                            if (elem.index === index) {
                                                return {
                                                    media_type: "video",
                                                    resource_url: resource_url1,
                                                    aspect: video.videoWidth / video.videoHeight,
                                                    thumb_url: null,
                                                    failed: (url1 === null || url1 === void 0 ? void 0 : url1.download) === undefined ? true : undefined,
                                                    index: index
                                                };
                                            }
                                            return elem;
                                        });
                                    });
                                    findAndSyncLoadingFromSelectedMedias(initialUrl1, resource_url1);
                                    _state.label = 8;
                                case 8:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(file) {
                        return _ref.apply(this, arguments);
                    };
                }());
                return [
                    2
                ];
            });
        });
        return _onDrop.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* PopupContainer */.kZ, {
        open: true,
        close: closePopup,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)("flex h-[100svh] w-screen flex-col bg-color-popup-cell", "desktop:h-[700px] desktop:w-[1140px] desktop:rounded-[10px]"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EditSegmentsHeader, {
                    selected: selected,
                    setSelected: setSelected,
                    closePopup: closePopup,
                    hasWebsite: data.website.status === "loaded"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("flex h-[calc(100%-253px)] flex-col bg-color-surface", "tablet:h-[calc(100%-179px)]"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EditSegmentsContent, {
                            selected: selected,
                            websiteUrl: data.website.status === "loaded" ? data.website.url : "",
                            hasUploadedFiles: uploadedMedias.length !== 0,
                            selectedOrientation: stockRequest.orientation,
                            stockMediaType: stockRequest.media_type,
                            relatedSearch: data.stock.queries[(selectedItem !== null && selectedItem !== void 0 ? selectedItem : 1) - 1],
                            mediaTypeFilter: mediaTypeFilter,
                            dropzoneState: dropzoneState,
                            storedSearches: storedSearches,
                            addNewSearch: addNewSearch,
                            setMediaTypeFilter: setMediaTypeFilter,
                            setStockLoading: function() {
                                return setStockLoading("loading");
                            },
                            chooseStockMediaType: chooseStockMediaType,
                            selectOrientation: selectOrientation,
                            searchStock: searchStock
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            ref: scrollableParentRef,
                            className: (0,clsx_m/* default */.Z)(selected === "lbl_upload" && "h-[calc(100%-76px)] tablet:h-[calc(100%-80px)]", selected === "txt_stock_media" && "h-[calc(100%-160px)] tablet:h-[calc(100%-114px)]", selected === "txt_website_images" && "h-[calc(100%-72px)] tablet:h-[calc(100%-100px)]", "no-scrollbar overflow-y-scroll px-[16px]", "flex flex-col gap-[20px] bg-color-surface"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderMedias, {
                                    selected: selected,
                                    website: data.website,
                                    stockContent: stockContent,
                                    stockLoading: stockLoading,
                                    uploadedMedias: uploadedMedias,
                                    mediaTypeFilter: mediaTypeFilter,
                                    dropzoneState: dropzoneState,
                                    replaceChoosenMedia: replaceChoosenMedia
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    ref: lastRowRef
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                    selectedMedias: selectedMedias,
                    maxUploadCount: data.segments.length,
                    currentUploadCount: selectedMedias.filter(function(e) {
                        return e.media_type !== "empty";
                    }).length,
                    selectedItem: selectedItem,
                    setSelectedItem: setSelectedItem,
                    sendSelectedMedias: sendSelectedMedias,
                    removeSelected: removeSelected,
                    closePopup: closePopup
                })
            ]
        })
    });
}
function initializeMedias(segments) {
    return segments.map(function(segment, index) {
        if (segment.media.selection) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, segment.media.selection), {
                index: index + 1,
                hint: segment.media.description
            });
        }
        return {
            media_type: "empty",
            index: index + 1,
            hint: segment.media.description
        };
    });
}
function RenderMedias(props) {
    var selected = props.selected, stockContent = props.stockContent, stockLoading = props.stockLoading, website = props.website, uploadedMedias = props.uploadedMedias, mediaTypeFilter = props.mediaTypeFilter, dropzoneState = props.dropzoneState, replaceChoosenMedia = props.replaceChoosenMedia;
    var t = (0,esm/* useTranslation */.$G)().t;
    switch(selected){
        case "lbl_upload":
            var formats = [
                "image/jpeg",
                "image/png",
                "video/mp4",
                "image/webp", 
            ];
            var backgroundImage = (0,clsx_m/* default */.Z)("url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25'", "xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25'", "fill='none' rx='8' ry='8' stroke='%23B699FA' stroke-width='5'", "stroke-dasharray='6%2c 14' stroke-dashoffset='14' stroke-linecap='round'/%3e%3c/svg%3e\")");
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: uploadedMedias.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex h-full w-full items-center justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_drop_area/* DropAreaForModel */.Oh, {
                        state: dropzoneState,
                        openExplorer: dropzoneState.open,
                        border: true,
                        formats: formats,
                        className: (0,clsx_m/* default */.Z)("h-[168px] w-full rounded-[8px]", "max-w-[318px] tablet:max-w-[474px]"),
                        backgroundImage: backgroundImage
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react_responsive_masonry_es/* ResponsiveMasonry */.G, {
                    columnsCountBreakPoints: {
                        1: 2,
                        500: 3,
                        700: 4,
                        1200: 5
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_responsive_masonry_es/* default */.Z, {
                        gutter: "13px",
                        children: uploadedMedias.filter(function(m) {
                            return m.media_type === mediaTypeFilter || mediaTypeFilter === "all";
                        }).map(function(m) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function() {
                                    return replaceChoosenMedia(m);
                                },
                                className: "group relative flex max-h-[375px] w-full items-center justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditSegmentsMediaItem, (0,_object_spread/* default */.Z)({}, m))
                            }, m.index);
                        })
                    })
                })
            });
        case "txt_website_images":
            if (website.status === "not_loaded") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_responsive_masonry_es/* ResponsiveMasonry */.G, {
                columnsCountBreakPoints: {
                    1: 2,
                    500: 3,
                    700: 4,
                    1200: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_responsive_masonry_es/* default */.Z, {
                    gutter: "13px",
                    children: website.medias.map(function(m) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: function() {
                                return replaceChoosenMedia(m);
                            },
                            className: "group relative flex max-h-[375px] w-full items-center justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditSegmentsMediaItem, (0,_object_spread/* default */.Z)({}, m))
                        }, m.resource_url);
                    })
                })
            });
        case "txt_stock_media":
            switch(stockLoading){
                case "loading":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_responsive_masonry_es/* ResponsiveMasonry */.G, {
                        columnsCountBreakPoints: {
                            1: 2,
                            500: 3,
                            700: 4,
                            1200: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_responsive_masonry_es/* default */.Z, {
                            gutter: "13px",
                            children: [
                                260,
                                210,
                                170,
                                200,
                                230,
                                160,
                                240,
                                260,
                                150,
                                170, 
                            ].map(function(n, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* SizedSkeleton */.xB, {
                                    className: "rounded-[6px]",
                                    style: {
                                        height: n
                                    }
                                }, index);
                            })
                        })
                    });
                case "no_result":
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {},
                        className: (0,clsx_m/* default */.Z)("flex h-full flex-col items-center justify-center", "gap-[8px] [--icon-color:var(--color-blue-300)]"),
                        children: [
                            (0,dashboard_icons/* emptyResult */.H_)(),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[16px] font-500 text-blue-500",
                                children: t("txt_no_result")
                            })
                        ]
                    });
                case "result":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_responsive_masonry_es/* ResponsiveMasonry */.G, {
                        columnsCountBreakPoints: {
                            1: 2,
                            500: 3,
                            700: 4,
                            1200: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_responsive_masonry_es/* default */.Z, {
                            gutter: "13px",
                            children: stockContent.map(function(m) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: function() {
                                        return replaceChoosenMedia(m);
                                    },
                                    className: "group relative flex max-h-[375px] w-full items-center justify-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditSegmentsMediaItem, (0,_object_spread/* default */.Z)({}, m))
                                }, m.resource_url);
                            })
                        })
                    });
            }
    }
}

// EXTERNAL MODULE: ./sections/wizard/feedback-message.tsx
var feedback_message = __webpack_require__(8255);
;// CONCATENATED MODULE: ./pages/[feature].tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n\n	width: var(--w-screen);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

































var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2639bad2-0"
})(_templateObject());
var UserPage = function(props) {
    var user = props.user, userGallery = props.userGallery, activeTab = props.activeTab;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(null), link = ref[0], setLink = ref[1];
    (0,react.useEffect)(function() {
        var uid = user.uid;
        function handler() {
            return _handler.apply(this, arguments);
        }
        function _handler() {
            _handler = (0,_async_to_generator/* default */.Z)(function() {
                var deepLink;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,branch/* createAppLink */.AF)(uid)
                            ];
                        case 1:
                            deepLink = _state.sent();
                            setLink(deepLink);
                            return [
                                2
                            ];
                    }
                });
            });
            return _handler.apply(this, arguments);
        }
        handler();
    }, [
        user.uid
    ]);
    var picture = user.picture;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        className: "min-h-screen justify-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(meta/* default */.Z, {
                title: t("fs_user_profile", user),
                description: t("fs_user_description", user)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full flex-1 flex-col bg-color-cell",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.ZP, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(advanced_profile/* default */.ZP, {
                        user: user,
                        gallery: userGallery,
                        activeTab: activeTab
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("fixed bottom-0 left-0 z-[999] w-screen rounded-t-[12px] bg-color-cell desktop:hidden", "transition-all", "[box-shadow:0px_0px_40px_rgba(0,0,0,0.4)]", link ? "translate-y-0" : "translate-y-[calc(100%+40px)]"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative flex flex-col items-center justify-center gap-2 p-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: picture || (0,cdn/* assetUrl */.p)("/general/avatar.svg"),
                                        alt: "profile pic",
                                        className: "h-[70px] w-[70px] rounded-full border-2 border-color-cell"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "pt-5 text-[18px] font-700",
                                    children: "See full profile in the app"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                                    text: "Open App",
                                    full: true,
                                    primary: true,
                                    href: link || "/"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "text-[15px] font-600 text-primary-700",
                                    onClick: function(e) {
                                        e.preventDefault();
                                        setLink(null);
                                    },
                                    children: "Not Now"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* WrappedFooter */.M, {})
        ]
    });
};
var DashboardPages = function(props) {
    var ref;
    (0,branch/* default */.ZP)({
        users: true,
        templates: true
    });
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref1 = (0,react.useState)(false), subscriptionPopupOpen = ref1[0], setSubscriptionPopupOpen = ref1[1];
    var userInfo = (0,client_auth/* default */.ZP)().userInfo;
    var dashboard = (0,controllers_dashboard/* useDashboardController */.Mg)(props);
    var editors = (0,controllers_editors/* useEditorsController */.Qf)({
        tool: dashboard.home.selectedTool
    });
    var device = (0,breakpoints/* useDeviceSize */.BV)();
    var ref2 = (0,react.useState)(true), isClosedSidebar = ref2[0], setCloseSidebar = ref2[1];
    var ref3 = (0,react.useState)(null), historyPopupState = ref3[0], setHistoryPopupState = ref3[1];
    var ref4 = (0,react.useState)(null), galleryPopupState = ref4[0], setGalleryPopupState = ref4[1];
    var ref5 = (0,react.useState)(null), adExamplesPopupState = ref5[0], setAdExamplesPopupState = ref5[1];
    var ref6 = (0,react.useState)(null), popupsProps = ref6[0], setPopupsProps = ref6[1];
    var textAreaRef = (0,react.useRef)(null);
    var ref7 = (0,react.useState)(null), changeName = ref7[0], setChangeName = ref7[1];
    var ref8 = (0,react.useState)(null), deleteSessionPopup = ref8[0], setDeleteSessionPopup = ref8[1];
    var ref9 = (0,react.useState)(null), completedMessage = ref9[0], setCompletedMessage = ref9[1];
    var ref10 = (0,react.useState)(null), indexedPayload = ref10[0], setIndexedPayload = ref10[1];
    var ref11 = (0,react.useState)(null), openUploadStockPopup = ref11[0], setOpenUploadStockPopup = ref11[1];
    var _selectedTool;
    var data = (0,controllers_editors/* getStorage */.cF)((_selectedTool = dashboard.home.selectedTool) !== null && _selectedTool !== void 0 ? _selectedTool : "deform");
    var indexed = (0,utils_indexed/* useIndexedDB */.i)("ai_art", data.tool, data.storage);
    var ref12 = (0,react.useState)(true), isFirstTime = ref12[0], setIsFirstTime = ref12[1];
    var selectCreatorTool = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(tool, content, changePage) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!changePage) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            dashboard.changeSelectedPage("home")
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        setIsFirstTime(false);
                        dashboard.selectAiStudioTool(tool);
                        editors.changeSelectedTool(content);
                        editors.loadToolFilters(content, true);
                        return [
                            2
                        ];
                }
            });
        });
        return function(tool, content, changePage) {
            return _ref.apply(this, arguments);
        };
    }(), [
        dashboard,
        editors
    ]);
    var selectedTool = (0,react.useRef)(dashboard.home.selectedTool);
    (0,react.useEffect)(function() {
        if (dashboard.activePage === "home" && selectedTool.current !== null && !editors.hasNotSelectedTool && isFirstTime) {
            if (indexed.status !== "ready") {
                return;
            }
            setIsFirstTime(false);
            indexed.getData(controllers_editors/* DEFORUM_STORAGE_KEY */.LF).then(function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        if (!data) {
                            return [
                                2
                            ];
                        }
                        selectCreatorTool(data.tool, data);
                        indexed.clearData(controllers_editors/* DEFORUM_STORAGE_KEY */.LF);
                        return [
                            2
                        ];
                    });
                });
                return function(data) {
                    return _ref.apply(this, arguments);
                };
            }());
            switch(selectedTool.current){
                case "deform":
                    dashboard.changeActiveChild("txt_deform_ai");
                    editors.loadToolFilters({
                        tool: "deform",
                        id: "last",
                        promptType: "custom",
                        inputs: [],
                        location: "local"
                    }, true);
                    break;
                case "ai_restyle":
                    dashboard.changeActiveChild("txt_restyle_ai");
                    selectCreatorTool("ai_restyle", {
                        tool: "ai_restyle",
                        id: controllers_editors/* DEFORUM_STORAGE_KEY */.LF,
                        promptType: "custom",
                        input: "",
                        location: "local"
                    });
                    break;
                case "text_to_image":
                    dashboard.changeActiveChild("txt_text_to_image");
                    selectCreatorTool("text_to_image", {
                        tool: "text_to_image",
                        id: controllers_editors/* DEFORUM_STORAGE_KEY */.LF,
                        promptType: null,
                        text: "",
                        location: "local"
                    });
                    break;
                case "ai_photo":
                    dashboard.changeActiveChild("txt_photo_ai");
                    selectCreatorTool("ai_photo", {
                        tool: "ai_photo",
                        id: controllers_editors/* DEFORUM_STORAGE_KEY */.LF,
                        promptType: "custom",
                        input: "",
                        location: "local"
                    });
                    break;
            }
        }
    }, [
        dashboard,
        editors,
        indexed,
        isFirstTime,
        selectCreatorTool, 
    ]);
    (0,react.useEffect)(function() {
        if (historyPopupState !== null || adExamplesPopupState !== null || galleryPopupState !== null) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    }, [
        adExamplesPopupState,
        galleryPopupState,
        historyPopupState, 
    ]);
    (0,dist/* useShortCut */.Xg)({
        shortCut: "BracketLeft",
        handler: function() {
            return setCloseSidebar(true);
        }
    });
    (0,dist/* useShortCut */.Xg)({
        shortCut: "BracketRight",
        handler: function() {
            return setCloseSidebar(false);
        }
    });
    (0,react.useEffect)(function() {
        if (popupsProps === null) {
            document.body.style.overflow = "visible";
        } else {
            document.body.style.overflow = "hidden";
        }
    }, [
        popupsProps
    ]);
    (0,react.useEffect)(function() {
        if (device !== breakpoints/* Device.Desktop */.AS.Desktop) {
            setCloseSidebar(true);
        } else {
            setCloseSidebar(false);
        }
    }, [
        device
    ]);
    (0,react.useEffect)(function() {
        if (userInfo.isAnonymous) {
            (0,login_redirect/* redirectToLogin */.r)();
        }
    }, [
        userInfo.isAnonymous
    ]);
    function addToStorage() {
        return _addToStorage.apply(this, arguments);
    }
    function _addToStorage() {
        _addToStorage = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (indexed.status !== "ready" || indexedPayload === null) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            indexed.setData(indexedPayload)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _addToStorage.apply(this, arguments);
    }
    var _selectedSession;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(meta/* default */.Z, {
                title: t("txt_home_title"),
                description: t("txt_home_description")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardHeader, {
                activePage: dashboard.activePage,
                setCloseSidebar: setCloseSidebar,
                isClosed: isClosedSidebar,
                changeSelectedPage: dashboard.changeSelectedPage,
                setSubscriptionPopupOpen: setSubscriptionPopupOpen,
                lastQuery: dashboard.lastQuery
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SideBar, {
                changeActiveChild: dashboard.changeActiveChild,
                activeChild: dashboard.activeChild,
                changeSelectedPage: dashboard.changeSelectedPage,
                activePage: dashboard.activePage,
                closeSidebar: function() {
                    return setCloseSidebar(function(o) {
                        return !o;
                    });
                },
                isClosed: isClosedSidebar,
                setSubscriptionPopupOpen: setSubscriptionPopupOpen,
                sessionsGroup: {
                    setChangeName: setChangeName,
                    selectSession: dashboard.chatController.selectSession,
                    loadMoreSessions: dashboard.chatController.loadMoreSessions,
                    setDeleteSessionPopup: setDeleteSessionPopup,
                    clearChatScreen: dashboard.chatController.clearChatScreen,
                    remakeSession: dashboard.chatController.remakeSession,
                    duplicateSession: dashboard.chatController.duplicateSession,
                    selectedSessionId: dashboard.chat.selectedSession,
                    sessions: dashboard.chat.content,
                    sessionsGroup: dashboard.chat.sessionsGroup,
                    changeName: changeName,
                    textAreaRef: textAreaRef
                },
                selectedTool: dashboard.home.selectedTool,
                selectCreatorTool: selectCreatorTool
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)(isClosedSidebar ? "desktop:w-full" : "desktop:ml-[240px] desktop:w-[calc(100%-240px)]", "flex h-full w-full bg-color-dashboard-bg pt-[58px] tablet:pt-[70px]", "no-scrollbar transition-all duration-[170ms] ease-in-out"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(content/* DashboardContent */.c, {
                    loadMoreHistoryContent: dashboard.loadMoreHistoryContent,
                    changeActiveChild: dashboard.changeActiveChild,
                    renameSession: dashboard.chatController.renameSession,
                    generateVideo: function(m) {
                        return dashboard.chatController.startNewSession({
                            website_url: null,
                            initial_message: m
                        }, null);
                    },
                    changeSelectedPage: dashboard.changeSelectedPage,
                    loadMoreSessions: dashboard.chatController.loadMoreSessions,
                    deleteSession: dashboard.chatController.deleteSession,
                    canTryAgain: dashboard.canTryAgain,
                    setHistoryPopupState: setHistoryPopupState,
                    setGalleryPopupState: setGalleryPopupState,
                    deleteHistoryItem: dashboard.deleteHistoryItem,
                    setPopupsProps: setPopupsProps,
                    selectCreatorTool: selectCreatorTool,
                    changeDiscoverFilter: dashboard.changeDiscoverFilter,
                    startNewSession: function() {
                        return dashboard.chatController.startNewSession({
                            website_url: null,
                            initial_message: null
                        }, null);
                    },
                    changeProjectsDisplay: dashboard.changeProjectsDisplay,
                    historyPopupState: historyPopupState,
                    activePage: dashboard.activePage,
                    duplicateSession: dashboard.chatController.duplicateSession,
                    remakeSession: dashboard.chatController.remakeSession,
                    setStartSessionInputs: function(message) {
                        return dashboard.chatController.startNewSession({
                            website_url: null,
                            initial_message: null
                        }, message);
                    },
                    setSelectedSession: dashboard.chatController.selectSession,
                    setSubscriptionPopupOpen: setSubscriptionPopupOpen,
                    chatController: dashboard.chatController,
                    setChangeName: setChangeName,
                    changeName: changeName,
                    textAreaRef: textAreaRef,
                    setDeleteSessionPopup: setDeleteSessionPopup,
                    deleteSessionPopup: deleteSessionPopup,
                    setCompletedMessage: setCompletedMessage,
                    editors: editors,
                    setAdExamplesPopupState: setAdExamplesPopupState,
                    setIndexedPayload: setIndexedPayload,
                    openUploadStockPopup: setOpenUploadStockPopup,
                    videoGpt: dashboard.videoGpt,
                    chat: dashboard.chat,
                    home: dashboard.home,
                    discover: dashboard.discover
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(subscription_popup/* SubscriptionPopup */.yj, {
                isOpen: subscriptionPopupOpen,
                close: function() {
                    return setSubscriptionPopupOpen(false);
                },
                addToStorage: addToStorage
            }),
            popupsProps !== null && popupsProps.data !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)(Popups, {
                data: popupsProps.data,
                initialSelected: popupsProps.initialSelected,
                close: popupsProps.close,
                setInputs: popupsProps.setInputs,
                setSubscriptionPopupOpen: setSubscriptionPopupOpen
            }),
            historyPopupState !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)(history_popup/* HistoryPopup */.p, (0,_object_spread/* default */.Z)({}, historyPopupState)),
            galleryPopupState !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)(gallery_popup/* GalleryPopup */.wY, (0,_object_spread/* default */.Z)({}, galleryPopupState)),
            adExamplesPopupState !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)(ad_examples_popup/* AdExamplesPopup */.wK, (0,_object_spread/* default */.Z)({}, adExamplesPopupState)),
            completedMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompletedMessagePopup, {
                initial: completedMessage,
                setCompletedMessage: setCompletedMessage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReferenceFacePopup, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(feedback_message/* FeedbackMessagePopup */.$, {
                id: (_selectedSession = dashboard.chat.selectedSession) !== null && _selectedSession !== void 0 ? _selectedSession : -1,
                changeShowRating: dashboard.chatController.changeShowRatingValue
            }),
            openUploadStockPopup !== null && ((ref = dashboard.chatController.lastResponse) === null || ref === void 0 ? void 0 : ref.name) === "edit_segments" && /*#__PURE__*/ (0,jsx_runtime.jsx)(EditSegmentsPopup, {
                initialSelected: openUploadStockPopup,
                closePopup: function() {
                    return setOpenUploadStockPopup(null);
                },
                data: dashboard.chatController.lastResponse,
                sendSelectedMedias: dashboard.chatController.sendMessage
            })
        ]
    });
};
var __N_SSP = true;
function UserFeatureDistributer(props) {
    switch(props.page){
        case "user":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserPage, (0,_object_spread/* default */.Z)({}, props.props));
        case "feature":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(_feature_["default"], (0,_object_spread/* default */.Z)({}, props.props));
        case "dashboard":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardPages, (0,_object_spread/* default */.Z)({}, props.props));
    }
}
var getInputsResponseSchema = lib.z.object({
    aspects: lib.z.object({
        id: lib.z.string(),
        name: lib.z.string()
    }).array(),
    actors: lib.z.object({
        id: lib.z.string(),
        name: lib.z.string(),
        thumbnail: lib.z.string(),
        animated_thumbnail: lib.z.string(),
        gender: lib.z["enum"]([
            "male",
            "female"
        ]).nullable()
    }).array(),
    voices: lib.z.object({
        id: lib.z.string(),
        name: lib.z.string(),
        preview_url: lib.z.string(),
        tags: lib.z.string().array(),
        gender: lib.z["enum"]([
            "male",
            "female"
        ]).nullable()
    }).array(),
    music: lib.z.object({
        id: lib.z.string(),
        name: lib.z.string()
    }).array()
});
var captionsResponseSchema = lib.z.object({
    id: lib.z.string(),
    thumb_url: lib.z.string(),
    thumb_gif_url: lib.z.string().nullable()
}).array();
var sessionsListResponseSchema = lib.z.object({
    sessions: lib.z.object({
        id: lib.z.number(),
        interacted_at: lib.z.string(),
        name: lib.z.string(),
        thumbnail_url: lib.z.string().nullable()
    }).array()
});


/***/ }),

/***/ 2711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ ContentContainer; },
/* harmony export */   "c": function() { return /* binding */ DashboardContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6010);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	0% {\n    transform: translateX(-100%);\n  }\n  20% {\n    transform: translateX(0%);\n  }\n  70% {\n    transform: translateX(100%);\n  }\n    100% {\n    transform: translateX(200%);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: absolute;\n	top: 0;\n	width: 70%;\n	height: 100%;\n	background-color: var(--color-primary-500);\n\n	animation: ",
        " 1s linear infinite;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var runnerAnim = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .keyframes */ .F4)(_templateObject());
var RunnerContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f1760d03-0"
})(_templateObject1(), runnerAnim);
var LoadingRunner = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "pointer-events-none fixed left-0 top-0 z-[999] flex h-screen w-screen items-start justify-start bg-color-popup",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: "relative h-1 w-full overflow-hidden",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RunnerContainer, {})
        })
    });
};
var Home = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 3471).then(__webpack_require__.bind(__webpack_require__, 3471));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3471)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LoadingRunner, {});
    },
    ssr: false
});
var AiStudio = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 4309).then(__webpack_require__.bind(__webpack_require__, 4309));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4309)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LoadingRunner, {});
    },
    ssr: false
});
var Discover = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 9642).then(__webpack_require__.bind(__webpack_require__, 9802));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9802)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LoadingRunner, {});
    },
    ssr: false
});
var VideoGpt = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 4058).then(__webpack_require__.bind(__webpack_require__, 4058));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4058)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LoadingRunner, {});
    },
    ssr: false
});
function DashboardContent(props) {
    var setSubscriptionPopupOpen = props.setSubscriptionPopupOpen, setAdExamplesPopupState = props.setAdExamplesPopupState, loadMoreHistoryContent = props.loadMoreHistoryContent, changeProjectsDisplay = props.changeProjectsDisplay, changeDiscoverFilter = props.changeDiscoverFilter, setHistoryPopupState = props.setHistoryPopupState, setGalleryPopupState = props.setGalleryPopupState, setStartSessionInputs = props.setStartSessionInputs, setDeleteSessionPopup = props.setDeleteSessionPopup, openUploadStockPopup = props.openUploadStockPopup, changeSelectedPage = props.changeSelectedPage, setSelectedSession = props.setSelectedSession, setCompletedMessage = props.setCompletedMessage, selectCreatorTool = props.selectCreatorTool, deleteHistoryItem = props.deleteHistoryItem, changeActiveChild = props.changeActiveChild, setIndexedPayload = props.setIndexedPayload, duplicateSession = props.duplicateSession, loadMoreSessions = props.loadMoreSessions, setPopupsProps = props.setPopupsProps, remakeSession = props.remakeSession, renameSession = props.renameSession, deleteSession = props.deleteSession, generateVideo = props.generateVideo, setChangeName = props.setChangeName, startNewSession = props.startNewSession, canTryAgain = props.canTryAgain, deleteSessionPopup = props.deleteSessionPopup, historyPopupState = props.historyPopupState, textAreaRef = props.textAreaRef, activePage = props.activePage, changeName = props.changeName, editors = props.editors, discover = props.discover, chat = props.chat, home = props.home, videoGpt = props.videoGpt, chatController = props.chatController;
    switch(activePage){
        case "home":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AiStudio, {
                page: home,
                deleteHistoryItem: deleteHistoryItem,
                setHistoryPopupState: setHistoryPopupState,
                loadMoreHistoryContent: loadMoreHistoryContent,
                selectCreatorTool: selectCreatorTool,
                setSubscriptionPopupOpen: setSubscriptionPopupOpen,
                changeSelectedPage: changeSelectedPage,
                changeActiveChild: changeActiveChild,
                historyPopupState: historyPopupState,
                editors: editors,
                setIndexedPayload: setIndexedPayload,
                canTryAgain: canTryAgain
            });
        case "videoGpt":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Home, {
                page: videoGpt,
                changeActiveChild: changeActiveChild,
                setPopupsProps: setPopupsProps,
                generateVideo: generateVideo,
                deleteSession: deleteSession,
                loadMoreSessions: loadMoreSessions,
                changeProjectsDisplay: changeProjectsDisplay,
                renameSession: renameSession,
                duplicateSession: duplicateSession,
                remakeSession: remakeSession,
                setStartSessionInputs: setStartSessionInputs,
                setSelectedSession: setSelectedSession,
                startNewSession: startNewSession,
                setSubscriptionPopupOpen: setSubscriptionPopupOpen
            });
        case "discover":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Discover, {
                page: discover,
                changeDiscoverFilter: changeDiscoverFilter,
                setGalleryPopupState: setGalleryPopupState,
                setAdExamplesPopupState: setAdExamplesPopupState,
                changeActiveChild: changeActiveChild,
                selectCreatorTool: selectCreatorTool,
                startNewSessionWithMessage: generateVideo
            });
        case "chat":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(VideoGpt, {
                chat: chat,
                setSubscriptionPopupOpen: setSubscriptionPopupOpen,
                chatController: chatController,
                setChangeName: setChangeName,
                changeName: changeName,
                textAreaRef: textAreaRef,
                setDeleteSessionPopup: setDeleteSessionPopup,
                openUploadStockPopup: openUploadStockPopup,
                deleteSessionPopup: deleteSessionPopup,
                setCompletedMessage: setCompletedMessage
            });
    }
}
function ContentContainer(props) {
    var children = props.children, padding = props.padding, id = props.id, onClick = props.onClick, parentRef = props.parentRef, withoutHeight = props.withoutHeight;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        ref: parentRef,
        id: id,
        onClick: onClick,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(padding && "p-[12px] desktop:p-[30px]", !withoutHeight && "h-[calc(100svh-58px)] tablet:h-[calc(100vh-70px)]", "no-scrollbar flex flex-col gap-[24px] scroll-smooth", "w-full overflow-x-hidden overflow-y-scroll bg-color-dashboard-bg"),
        style: {
            overflowY: "scroll"
        },
        children: children
    });
}


/***/ }),

/***/ 1685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ar": function() { return /* binding */ restyleAi; },
/* harmony export */   "Ei": function() { return /* binding */ deformAi; },
/* harmony export */   "H1": function() { return /* binding */ videoIcon; },
/* harmony export */   "H_": function() { return /* binding */ emptyResult; },
/* harmony export */   "RL": function() { return /* binding */ searchIcon; },
/* harmony export */   "T5": function() { return /* binding */ photoAi; },
/* harmony export */   "U3": function() { return /* binding */ textToImage; },
/* harmony export */   "WR": function() { return /* binding */ homeIcon; },
/* harmony export */   "X9": function() { return /* binding */ allIcon; },
/* harmony export */   "Xm": function() { return /* binding */ projectsIcon; },
/* harmony export */   "Zi": function() { return /* binding */ mediaToVideo; },
/* harmony export */   "b7": function() { return /* binding */ aiMusicGenerator; },
/* harmony export */   "cJ": function() { return /* binding */ sctiptToVideo; },
/* harmony export */   "cv": function() { return /* binding */ landscapeIcon; },
/* harmony export */   "nE": function() { return /* binding */ discoverIcon; },
/* harmony export */   "s4": function() { return /* binding */ urlToVideo; },
/* harmony export */   "sN": function() { return /* binding */ portraitIcon; },
/* harmony export */   "xg": function() { return /* binding */ ideaToVideo; },
/* harmony export */   "yy": function() { return /* binding */ imageIcon; },
/* harmony export */   "zl": function() { return /* binding */ videoGptIcon; }
/* harmony export */ });
/* unused harmony exports aiStudioIcon, aiPhotoshoot, history, activeJobs, videoTemplates, adExamples */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function homeIcon(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width ? width : "20",
        height: height ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.0379 3.69609C10.4319 3.21629 9.57554 3.21608 8.96932 3.69559L3.96636 7.65288C3.56674 7.96898 3.33366 8.45052 3.33366 8.96006V16C3.33366 16.1468 3.39767 16.3078 3.54595 16.4412C3.69713 16.5773 3.9193 16.6667 4.16699 16.6667H15.8337C16.0814 16.6667 16.3035 16.5773 16.4547 16.4412C16.603 16.3078 16.667 16.1468 16.667 16V8.95931C16.667 8.45006 16.4342 7.96875 16.0349 7.65263L11.0379 3.69609ZM7.93536 2.38842C9.14779 1.4294 10.8605 1.42981 12.0725 2.38942L17.0695 6.34596C17.868 6.9782 18.3337 7.94081 18.3337 8.95931V16C18.3337 16.6489 18.0465 17.2509 17.5696 17.6801C17.0957 18.1066 16.47 18.3333 15.8337 18.3333H4.16699C3.53063 18.3333 2.90495 18.1066 2.43101 17.6801C1.95417 17.2509 1.66699 16.6489 1.66699 16V8.96006C1.66699 7.94099 2.13315 6.97791 2.9324 6.34571L7.93536 2.38842Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.83366 14.1667C5.83366 13.7064 6.20676 13.3333 6.66699 13.3333H13.3337C13.7939 13.3333 14.167 13.7064 14.167 14.1667C14.167 14.6269 13.7939 15 13.3337 15H6.66699C6.20676 15 5.83366 14.6269 5.83366 14.1667Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function projectsIcon(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width ? width : "22",
        height: height ? height : "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.4167 3.57788C17.972 3.57788 18.4221 4.02803 18.4221 4.58333V5.58876H15.9529V3.57788H17.4167ZM15.125 7.24454L15.1179 7.24451L11.8279 7.24451V14.7555H15.125H18.4221V7.24451H15.1321L15.125 7.24454ZM11.8279 16.4112H14.2971V18.4221H11.8279L11.8279 16.4112ZM15.9529 16.4112V18.4221H17.4167C17.972 18.4221 18.4221 17.972 18.4221 17.4167V16.4112H15.9529ZM17.4167 20.0779L15.125 20.0779L11 20.0779L6.87503 20.0779L4.58333 20.0779C3.11359 20.0779 1.92212 18.8864 1.92212 17.4167V15.5833V6.41664V4.58333C1.92212 3.11358 3.11359 1.92212 4.58333 1.92212H6.87503L11 1.92212L15.125 1.92212H17.4167C18.8864 1.92212 20.0779 3.11358 20.0779 4.58333V6.41664V15.5833V17.4167C20.0779 18.8864 18.8864 20.0779 17.4167 20.0779ZM7.7029 18.4221H10.1721L10.1721 16.4112H7.7029L7.7029 18.4221ZM6.04715 16.4112L6.04715 18.4221H4.58333C4.02804 18.4221 3.57788 17.972 3.57788 17.4167V16.4112H6.04715ZM6.87503 14.7555H10.1721V7.24451H6.8821L6.87503 7.24454L6.86796 7.24451H3.57788V14.7555L6.87503 14.7555ZM10.1721 5.58876L7.7029 5.58876V3.57788H10.1721V5.58876ZM6.04715 5.58876V3.57788H4.58333C4.02804 3.57788 3.57788 4.02803 3.57788 4.58333V5.58876H6.04715ZM11.8279 5.58876H14.2971V3.57788H11.8279V5.58876Z",
            fill: "var(--icon-color)"
        })
    });
}
function videoGptIcon(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width ? width : "20",
        height: height ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.9118 11.1837C13.5544 11.7879 13.4473 12.7947 12.5906 13.1975L6.59331 16.5202C4.9869 17.4264 3.05921 16.8223 1.66699 14.7078C2.09537 17.5271 5.41528 19.3395 8.4139 17.7285L13.5544 14.9092C15.9105 13.7009 15.8034 10.4789 13.4473 9.27064L7.55715 6.14929C7.77134 5.34378 8.73518 4.94102 9.59193 5.34378L15.5892 8.6665C17.1956 9.5727 17.7311 11.3851 16.553 13.3989C18.6949 12.1906 19.3375 8.46513 16.0176 6.65273L10.6629 3.73276C8.30681 2.42381 5.52237 3.93414 5.62946 6.45135V13.0968C4.77271 13.3989 3.80887 12.7947 3.80887 11.8885V5.34378C3.80887 3.63207 4.87981 2.02105 7.77134 2.02105C4.9869 0.812786 1.66699 2.82656 1.77409 6.0486V11.8885C1.77409 14.4058 4.66562 15.9161 6.91459 14.6071L12.9118 11.1837ZM10.8771 10.0761L7.55715 8.36444V11.8885L10.8771 10.0761Z",
            fill: "var(--icon-color)"
        })
    });
}
function aiStudioIcon(width, height) {
    return /*#__PURE__*/ _jsxs("svg", {
        width: width ? width : "20",
        height: height ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.0316 12.2054V7.62193C13.0012 6.75998 11.9019 6.75933 11.8712 7.62193V12.2054C11.9016 13.0674 13.001 13.068 13.0316 12.2054ZM9.75261 8.04103C9.55234 7.39094 9.00867 6.97252 8.36883 6.97523C7.72807 6.97782 7.18774 7.40099 6.99223 8.0533C6.98791 8.06777 6.08666 12.0617 6.08666 12.0617C6.00827 12.4093 6.22218 12.7557 6.56443 12.8353C6.907 12.915 7.24776 12.6977 7.32615 12.35L7.49702 11.5924H9.27891L9.4576 12.3553C9.53749 12.7049 9.89068 12.9173 10.2233 12.8341C10.5649 12.7516 10.776 12.4034 10.6947 12.0564C10.6947 12.0564 9.75703 8.0554 9.75261 8.04103ZM7.81364 10.5014L8.22955 8.31926C8.26121 8.21064 8.31617 8.15102 8.38556 8.15068C8.45513 8.15068 8.50925 8.20788 8.54154 8.31643L8.97399 10.5014H7.81364Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.4106 3.88778L13.2453 3.54658C13.1914 3.53035 13.134 3.52998 13.0798 3.54551C13.0257 3.56104 12.9771 3.59184 12.9395 3.63431C12.9139 3.66396 12.8944 3.69848 12.8821 3.73586C12.8698 3.77323 12.8649 3.81272 12.8678 3.85201C12.8707 3.8913 12.8813 3.92962 12.899 3.96472C12.9167 3.99982 12.941 4.03101 12.9707 4.05646L13.8845 4.86477C14.0766 5.0342 14.2119 5.24245 14.2833 5.46746L14.288 5.48569C14.3582 5.71781 14.3618 5.97035 14.2931 6.22028L13.9724 7.38183C13.9576 7.43678 13.9584 7.49486 13.9748 7.54936C13.9912 7.60385 14.0225 7.65251 14.0651 7.68971C14.1244 7.74228 14.2017 7.76919 14.2803 7.76464C14.359 7.7601 14.4327 7.72446 14.4857 7.66539L15.2771 6.76305C15.4397 6.57506 15.6523 6.43847 15.8895 6.36961C16.13 6.30267 16.3841 6.30548 16.623 6.37773L17.7887 6.71826C17.8426 6.73449 17.9 6.73486 17.9541 6.71932C18.0082 6.70379 18.0569 6.67299 18.0944 6.63052C18.12 6.60087 18.1396 6.56636 18.1519 6.52898C18.1642 6.4916 18.1691 6.45212 18.1661 6.41282C18.1632 6.37353 18.1526 6.33522 18.135 6.30011C18.1173 6.26501 18.0929 6.23383 18.0632 6.20837L17.1491 5.40073C16.9521 5.22602 16.8141 5.01188 16.7445 4.78012C16.675 4.54836 16.6715 4.29582 16.7405 4.04523L17.0605 2.88331C17.0754 2.82836 17.0745 2.77027 17.0581 2.71578C17.0417 2.66129 17.0104 2.61263 16.9678 2.57543C16.9085 2.52286 16.8313 2.49595 16.7526 2.5005C16.674 2.50504 16.6002 2.54068 16.5473 2.59974L15.7569 3.50179C15.5908 3.69097 15.3854 3.82286 15.162 3.89109L15.1444 3.89522C14.904 3.9625 14.6497 3.95992 14.4106 3.88778Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.66699 5.69305C1.66699 4.29446 2.78628 3.16068 4.16699 3.16068H10.8268C11.287 3.16068 11.6601 3.53861 11.6601 4.0048C11.6601 4.471 11.287 4.84893 10.8268 4.84893H4.16699C3.70675 4.84893 3.33366 5.22685 3.33366 5.69305V14.1343C3.33366 14.6005 3.70675 14.9784 4.16699 14.9784H15.8337C16.2939 14.9784 16.667 14.6005 16.667 14.1343V8.96402C16.667 8.49782 17.0401 8.11989 17.5003 8.11989C17.9606 8.11989 18.3337 8.49782 18.3337 8.96402V14.1343C18.3337 15.5329 17.2144 16.6667 15.8337 16.6667H4.16699C2.78628 16.6667 1.66699 15.5329 1.66699 14.1343V5.69305Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function discoverIcon(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width ? width : "20",
        height: height ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.113 7.20924C14.2037 6.93702 14.1329 6.63689 13.9299 6.43399C13.7271 6.23109 13.4269 6.16024 13.1547 6.25097L8.33654 7.85704C8.11032 7.93244 7.93281 8.10995 7.8574 8.33617L6.25134 13.1544C6.16061 13.4265 6.23145 13.7267 6.43436 13.9296C6.63726 14.1325 6.93739 14.2034 7.20961 14.1126L12.0278 12.5065C12.254 12.4312 12.4315 12.2537 12.5069 12.0275L14.113 7.20924ZM8.16788 12.1961L9.17502 9.17466L12.1965 8.16751L11.1893 11.189L8.16788 12.1961Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.3837 3.33329H9.61699C8.21341 3.33329 7.25929 3.33455 6.52135 3.39385C5.80239 3.45162 5.43406 3.5564 5.17706 3.68481C4.53135 4.00745 4.00782 4.53099 3.68518 5.1767C3.55676 5.4337 3.45199 5.80203 3.39421 6.52099C3.33491 7.25892 3.33366 8.21305 3.33366 9.61663V10.3833C3.33366 11.7869 3.33491 12.741 3.39421 13.4789C3.45199 14.1979 3.55676 14.5662 3.68518 14.8232C4.00782 15.4689 4.53135 15.9925 5.17706 16.3151C5.43406 16.4435 5.80239 16.5483 6.52135 16.6061C7.25929 16.6654 8.21341 16.6666 9.61699 16.6666H10.3837C11.7872 16.6666 12.7414 16.6654 13.4793 16.6061C14.1983 16.5483 14.5666 16.4435 14.8236 16.3151C15.4693 15.9925 15.9928 15.4689 16.3155 14.8232C16.4439 14.5662 16.5487 14.1979 16.6064 13.4789C16.6657 12.741 16.667 11.7869 16.667 10.3833V9.61663C16.667 8.21305 16.6657 7.25892 16.6064 6.52099C16.5487 5.80203 16.4439 5.4337 16.3155 5.1767C15.9928 4.53099 15.4693 4.00745 14.8236 3.68481C14.5666 3.5564 14.1983 3.45162 13.4793 3.39385C12.7414 3.33455 11.7872 3.33329 10.3837 3.33329ZM2.19427 4.43173C1.66699 5.48698 1.66699 6.86353 1.66699 9.61663V10.3833C1.66699 13.1364 1.66699 14.5129 2.19427 15.5682C2.67824 16.5368 3.46353 17.3221 4.4321 17.806C5.48735 18.3333 6.86389 18.3333 9.61699 18.3333H10.3837C13.1368 18.3333 14.5133 18.3333 15.5686 17.806C16.5371 17.3221 17.3224 16.5368 17.8064 15.5682C18.3337 14.5129 18.3337 13.1364 18.3337 10.3833V9.61663C18.3337 6.86353 18.3337 5.48698 17.8064 4.43173C17.3224 3.46316 16.5371 2.67787 15.5686 2.1939C14.5133 1.66663 13.1368 1.66663 10.3837 1.66663H9.61699C6.86389 1.66663 5.48735 1.66663 4.4321 2.1939C3.46353 2.67787 2.67824 3.46316 2.19427 4.43173Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function urlToVideo(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width ? width : "20",
        height: height ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.4964 12.5797C15.3232 12.0276 14.853 11.6722 14.2996 11.6745C13.7454 11.6767 13.278 12.0361 13.1089 12.5901C13.1052 12.6024 12.3257 15.9945 12.3257 15.9945C12.2579 16.2897 12.4429 16.5839 12.7389 16.6515C13.0352 16.7191 13.3299 16.5346 13.3977 16.2393L13.5455 15.5959H15.0867L15.2413 16.2438C15.3104 16.5407 15.6158 16.7211 15.9035 16.6505C16.199 16.5804 16.3815 16.2846 16.3112 15.99C16.3112 15.99 15.5002 12.5919 15.4964 12.5797ZM13.8172 14.6693L14.1769 12.8159C14.2043 12.7237 14.2519 12.673 14.3119 12.6728C14.3721 12.6728 14.4189 12.7213 14.4468 12.8135L14.8208 14.6693H13.8172ZM18.3331 16.1166V12.2238C18.3068 11.4917 17.356 11.4912 17.3295 12.2238V16.1166C17.3557 16.8486 18.3066 16.8492 18.3331 16.1166Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.37883 4.08982C10.1333 3.30826 11.119 2.82096 12.1247 2.74605C13.1304 2.67115 14.0592 3.01581 14.7145 3.69191C15.3686 4.36683 15.6994 5.3182 15.647 6.33826C15.5947 7.3583 15.1628 8.37996 14.4332 9.18263L14.4228 9.19398L12.5371 11.2071C12.1313 11.6405 11.6504 11.9923 11.1259 12.236C10.6013 12.4798 10.0471 12.6089 9.50152 12.6135C8.95602 12.618 8.43457 12.4979 7.97253 12.2633C7.51064 12.0287 7.11989 11.6856 6.82468 11.26C6.58068 10.9082 6.69847 10.3815 7.08778 10.0835C7.47709 9.78559 7.99049 9.82926 8.23449 10.1811C8.4049 10.4268 8.62724 10.6202 8.88434 10.7508C9.14129 10.8813 9.42789 10.9465 9.72473 10.944C10.0215 10.9416 10.3242 10.8714 10.6129 10.7373C10.9018 10.603 11.1717 10.407 11.4031 10.1598L13.2832 8.15258C13.6983 7.69347 13.9543 7.09726 13.9854 6.49084C14.0166 5.88211 13.8181 5.32632 13.444 4.94033C13.071 4.55553 12.5551 4.37041 12.0105 4.41097C11.4677 4.4514 10.9235 4.71399 10.4955 5.15547L9.41941 6.29845C9.08224 6.65659 8.5559 6.71158 8.24378 6.42128C7.93166 6.13098 7.95197 5.60531 8.28914 5.24717L9.36994 4.09914L9.37883 4.08982Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.3732 7.76405C6.89782 7.52025 7.45204 7.39113 7.99758 7.38657C8.54308 7.38202 9.06454 7.50213 9.52658 7.7368C9.98847 7.9714 10.3792 8.31442 10.6744 8.74006C10.9184 9.09187 10.8006 9.6186 10.4113 9.91654C10.022 10.2145 9.50862 10.1708 9.26461 9.81898C9.09421 9.57328 8.87187 9.37986 8.61477 9.24928C8.35782 9.11877 8.07121 9.05354 7.77438 9.05601C7.47758 9.05849 7.17491 9.12862 6.88619 9.26279C6.59732 9.39703 6.32744 9.5931 6.09604 9.84022L4.21587 11.8475C3.80078 12.3066 3.54481 12.9028 3.5137 13.5092C3.48247 14.118 3.68103 14.6737 4.05513 15.0597C4.42807 15.4445 4.94404 15.6296 5.48861 15.5891C6.03103 15.5487 6.57492 15.2864 7.00283 14.8454L8.072 13.704C8.40826 13.345 8.93466 13.2885 9.24776 13.5777C9.56086 13.867 9.54208 14.3925 9.20583 14.7515L8.13094 15.899L8.12028 15.9102C7.3658 16.6918 6.38015 17.1791 5.37442 17.254C4.36873 17.3289 3.43988 16.9843 2.78461 16.3081C2.13049 15.6332 1.79973 14.6819 1.85206 13.6618C1.90439 12.6418 2.33635 11.6201 3.06586 10.8174L3.07634 10.8061L4.96199 8.79297C5.36782 8.3596 5.84877 8.00776 6.3732 7.76405Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function ideaToVideo(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width ? width : "20",
        height: height ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.0003 1.66663C8.45323 1.66663 6.9695 2.24992 5.87554 3.28819C4.78157 4.32647 4.16699 5.73467 4.16699 7.20301C4.16699 8.14874 4.3848 9.31915 5.66107 10.5305C6.16231 11.0062 6.51516 11.4719 6.65654 11.993C6.66118 12.0101 6.66699 12.044 6.66699 12.1051V12.6027C6.66699 13.9131 7.78628 14.9755 9.16699 14.9755H10.8337C12.2144 14.9755 13.3337 13.9131 13.3337 12.6027V12.1051C13.3337 12.0453 13.3394 12.0084 13.3451 11.9866C13.4779 11.48 13.7598 11.0829 14.3252 10.5441C15.3436 9.66493 15.8337 8.41979 15.8337 7.20301C15.8337 5.73467 15.2191 4.32647 14.1251 3.28819C13.0312 2.24992 11.5474 1.66663 10.0003 1.66663ZM7.05405 4.40671C7.83545 3.66509 8.89526 3.24845 10.0003 3.24845C11.1054 3.24845 12.1652 3.66509 12.9466 4.40671C13.728 5.14833 14.167 6.15419 14.167 7.20301C14.167 8.03567 13.8293 8.83966 13.1929 9.38332C13.182 9.39259 13.1714 9.40213 13.1611 9.41194C12.4904 10.0485 11.9666 10.6932 11.7277 11.6047C11.6804 11.785 11.667 11.9566 11.667 12.1051V12.6027C11.667 13.0395 11.2939 13.3936 10.8337 13.3936H9.16699C8.70675 13.3936 8.33366 13.0395 8.33366 12.6027V12.1051C8.33366 11.9579 8.32064 11.7832 8.27056 11.5986C8.02106 10.6789 7.42895 9.9713 6.83958 9.41194C5.94919 8.56687 5.83366 7.8391 5.83366 7.20301C5.83366 6.15419 6.27265 5.14834 7.05405 4.40671ZM7.61935 16.6442C7.09338 16.6413 6.66499 17.0115 6.66252 17.4709C6.66004 17.9302 7.08443 18.3049 7.6104 18.3077L12.3723 18.3333C12.8982 18.3361 13.3266 17.966 13.3291 17.5066C13.3316 17.0472 12.9072 16.6725 12.3812 16.6697L7.61935 16.6442Z",
            fill: "var(--icon-color)"
        })
    });
}
function aiMusicGenerator(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width ? width : "20",
        height: height ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.04256 2.23358C9.61345 1.84094 10.3548 1.77079 11.0852 2.00618L14.5579 3.10957C15.1278 3.29277 15.6137 3.67793 15.9546 4.12793C16.2955 4.57787 16.5274 5.14014 16.5274 5.71772V6.59574C16.5274 7.33033 16.2254 7.97885 15.655 8.37218C15.0848 8.76541 14.3457 8.83498 13.6169 8.60449L10.1441 7.50106L10.142 7.50038C9.89411 7.42072 9.66216 7.30286 9.45112 7.15808V14.5118C9.45112 14.5212 9.45089 14.5306 9.45045 14.5399C9.43525 16.5244 7.74665 18.1286 5.66586 18.1286C3.57563 18.1286 1.88117 16.5098 1.88117 14.5128C1.88117 12.5159 3.57563 10.8971 5.66586 10.8971C6.62402 10.8971 7.49901 11.2372 8.16575 11.798V4.00553C8.16575 3.97231 8.16851 3.9397 8.17383 3.9079C8.19653 3.21575 8.49789 2.60819 9.04256 2.23358ZM9.45784 4.00267C9.45505 3.59658 9.61487 3.35307 9.79354 3.23019C9.9724 3.10718 10.2673 3.03832 10.6753 3.17005L10.6782 3.17099L14.148 4.27347L14.149 4.27377C14.4192 4.3609 14.6988 4.5647 14.9134 4.84793C15.1283 5.13155 15.242 5.4473 15.242 5.71772V6.59574C15.242 7.00934 15.0805 7.25385 14.9027 7.37646C14.7249 7.49911 14.4307 7.56823 14.0208 7.4387L10.5518 6.33649L10.5509 6.3362C10.2807 6.24907 10.0011 6.04527 9.78648 5.76202C9.57161 5.47841 9.45786 5.16265 9.45786 4.89223L9.45787 4.00671L9.45784 4.00267ZM5.66586 12.1251C4.28552 12.1251 3.16654 13.1941 3.16654 14.5128C3.16654 15.8316 4.28552 16.9006 5.66586 16.9006C7.0462 16.9006 8.16519 15.8316 8.16519 14.5128C8.16519 13.1941 7.0462 12.1251 5.66586 12.1251Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.6256 2.91536L11.1538 1.81225C10.3699 1.5598 9.55379 1.62982 8.91745 2.06748C8.31374 2.48269 7.98781 3.14896 7.96019 3.88918C7.9545 3.92728 7.95157 3.96614 7.95157 4.00553V11.3776C7.30376 10.9458 6.51562 10.6924 5.66591 10.6924C3.45737 10.6924 1.66699 12.4029 1.66699 14.5128C1.66699 16.6228 3.45737 18.3333 5.66591 18.3333C7.86322 18.3333 9.6466 16.6402 9.6647 14.545C9.66516 14.534 9.6654 14.5229 9.6654 14.5118V7.52589C9.79573 7.59204 9.93243 7.64896 10.0741 7.69448L10.0765 7.69527L13.5496 8.79878C14.3312 9.04598 15.1446 8.97661 15.7804 8.53813C16.4165 8.09953 16.7417 7.38351 16.7417 6.59574V5.71772C16.7417 5.08889 16.4901 4.48554 16.1282 4.00793C15.7663 3.53024 15.2455 3.11462 14.6256 2.91536ZM9.16777 2.39968C9.67308 2.05215 10.3399 1.98196 11.0168 2.20011L11.446 3.19922L10.7459 2.97678L10.7439 2.97615C10.2815 2.82693 9.9121 2.8965 9.66843 3.06409C9.42484 3.23162 9.24049 3.54244 9.24367 4.00401L9.2437 4.00734L9.24368 4.89223C9.24368 5.21374 9.37705 5.57058 9.61299 5.88202C9.84865 6.19308 10.1627 6.42701 10.4826 6.53016L10.4843 6.5307L13.2551 7.41108L13.6842 8.41019L10.2117 7.30685L10.21 7.30629C9.98447 7.23376 9.77152 7.12588 9.57612 6.99183C9.51086 6.94706 9.42486 6.94094 9.35338 6.97598C9.28189 7.01102 9.23694 7.08132 9.23694 7.15808V14.5118C9.23694 14.5181 9.23664 14.5244 9.23634 14.5307L9.23628 14.5384C9.22194 16.4105 7.62892 17.924 5.66591 17.924C3.694 17.924 2.09545 16.3968 2.09545 14.5128C2.09545 12.6289 3.694 11.1017 5.66591 11.1017C6.56998 11.1017 7.39511 11.4225 8.02424 11.9516C8.08742 12.0048 8.17732 12.0177 8.25402 11.9845C8.33073 11.9514 8.38003 11.8785 8.38003 11.798V4.00553C8.38003 3.98316 8.38189 3.96135 8.38542 3.9402C8.38686 3.93163 8.38772 3.92299 8.388 3.91432C8.40897 3.27516 8.68548 2.73139 9.16777 2.39968ZM13.0405 6.91152L13.2551 7.41108L13.9536 7.63301C14.4173 7.77953 14.7854 7.70981 15.0282 7.54241C15.2709 7.37506 15.4563 7.06359 15.4563 6.59574V5.71772C15.4563 5.39621 15.3229 5.03937 15.087 4.72793C14.8513 4.41689 14.5374 4.18298 14.2175 4.07983L14.2165 4.07952L11.446 3.19922L11.6606 3.69878L10.6107 3.3652L10.6068 3.36394C10.2533 3.24983 10.0327 3.31789 9.91875 3.3963C9.80501 3.47452 9.66971 3.65073 9.67212 4.00132L9.67216 4.00671L9.67214 4.89224C9.67214 5.11156 9.76629 5.38623 9.96007 5.64202C10.1536 5.89742 10.3988 6.07111 10.6194 6.14224L10.6203 6.14253L13.0405 6.91152ZM3.38082 14.5128C3.38082 13.3071 4.40389 12.3297 5.66591 12.3297C6.92794 12.3297 7.95101 13.3071 7.95101 14.5128C7.95101 15.7185 6.92794 16.696 5.66591 16.696C4.40389 16.696 3.38082 15.7185 3.38082 14.5128ZM5.66591 11.9204C4.16726 11.9204 2.95236 13.0811 2.95236 14.5128C2.95236 15.9446 4.16726 17.1053 5.66591 17.1053C7.16457 17.1053 8.37947 15.9446 8.37947 14.5128C8.37947 13.0811 7.16457 11.9204 5.66591 11.9204Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.2175 4.07983L14.2165 4.07952L11.446 3.19922L11.6606 3.69878L14.0796 4.46741L14.0806 4.46771C14.3011 4.53883 14.5464 4.71253 14.7399 4.96793C14.9337 5.22373 15.0278 5.49839 15.0278 5.71772V6.59574C15.0278 6.95509 14.8903 7.13263 14.7774 7.2105C14.6644 7.2884 14.4442 7.35687 14.0881 7.24438L13.0405 6.91152L13.2551 7.41108L13.9536 7.63301C14.4173 7.77953 14.7854 7.70981 15.0282 7.54241C15.2709 7.37506 15.4563 7.06359 15.4563 6.59574V5.71772C15.4563 5.39621 15.3229 5.03937 15.087 4.72793C14.8513 4.41689 14.5374 4.18298 14.2175 4.07983Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.3337 15.1892V11.0303C18.3056 10.2482 17.2901 10.2476 17.2618 11.0303V15.1892C17.2899 15.9714 18.3054 15.9719 18.3337 15.1892ZM15.3036 11.4106C15.1186 10.8207 14.6164 10.4411 14.0254 10.4435C13.4335 10.4459 12.9344 10.8299 12.7538 11.4217C12.7499 11.4349 11.9174 15.0588 11.9174 15.0588C11.845 15.3743 12.0426 15.6886 12.3587 15.7608C12.6751 15.8331 12.9899 15.6359 13.0623 15.3205L13.2201 14.633H14.866L15.0311 15.3252C15.1049 15.6425 15.4311 15.8352 15.7384 15.7597C16.0539 15.6848 16.2489 15.3689 16.1738 15.0541C16.1738 15.0541 15.3077 11.4237 15.3036 11.4106ZM13.5103 13.643L13.8945 11.663C13.9237 11.5644 13.9745 11.5103 14.0386 11.51C14.1029 11.51 14.1529 11.5619 14.1827 11.6604L14.5821 13.643H13.5103Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function sctiptToVideo(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width ? width : "20",
        height: height ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5.01692 1.66663C3.62686 1.66663 2.5 2.78591 2.5 4.16663V15.8333C2.5 17.214 3.62686 18.3333 5.01692 18.3333H9.69917C10.1625 18.3333 10.5381 17.9602 10.5381 17.5C10.5381 17.0397 10.1625 16.6666 9.69917 16.6666H5.01692C4.55356 16.6666 4.17794 16.2935 4.17794 15.8333V4.16663C4.17794 3.70639 4.55356 3.33329 5.01692 3.33329H13.4066C13.87 3.33329 14.2456 3.70639 14.2456 4.16663V11.875C14.2456 12.3352 14.6212 12.7083 15.0846 12.7083C15.5479 12.7083 15.9236 12.3352 15.9236 11.875V4.16663C15.9236 2.78591 14.7967 1.66663 13.4066 1.66663H5.01692Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7.00076 5.83324C6.54877 5.83324 6.18236 6.20634 6.18236 6.66658C6.18236 7.12681 6.54877 7.49991 7.00076 7.49991H11.9111C12.3631 7.49991 12.7295 7.12681 12.7295 6.66658C12.7295 6.20634 12.3631 5.83324 11.9111 5.83324H7.00076Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.18236 9.99991C6.18236 9.53967 6.54877 9.16658 7.00076 9.16658H11.9111C12.3631 9.16658 12.7295 9.53967 12.7295 9.99991C12.7295 10.4601 12.3631 10.8332 11.9111 10.8332H7.00076C6.54877 10.8332 6.18236 10.4601 6.18236 9.99991Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.25669 13.3332C6.25669 12.873 6.6231 12.4999 7.07508 12.4999H9.53026C9.98225 12.4999 10.3487 12.873 10.3487 13.3332C10.3487 13.7935 9.98225 14.1666 9.53026 14.1666H7.07508C6.6231 14.1666 6.25669 13.7935 6.25669 13.3332Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.5 17.833V14.2879C17.475 13.6212 16.5704 13.6207 16.5452 14.2879V17.833C16.5702 18.4997 17.4748 18.5002 17.5 17.833ZM14.8006 14.6122C14.6358 14.1094 14.1884 13.7857 13.662 13.7878C13.1347 13.7898 12.6901 14.1171 12.5292 14.6217C12.5257 14.6329 11.7841 17.722 11.7841 17.722C11.7196 17.9909 11.8956 18.2587 12.1772 18.3203C12.4591 18.3819 12.7395 18.2139 12.804 17.945L12.9446 17.359H14.4108L14.5578 17.949C14.6236 18.2195 14.9142 18.3837 15.1879 18.3194C15.4689 18.2555 15.6426 17.9862 15.5757 17.7179C15.5757 17.7179 14.8042 14.6233 14.8006 14.6122ZM13.2032 16.515L13.5455 14.8272C13.5715 14.7432 13.6167 14.697 13.6738 14.6968C13.7311 14.6968 13.7756 14.741 13.8022 14.825L14.158 16.515H13.2032Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function textToImage(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width ? width : "20",
        height: height ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.00476 15.7733C7.00476 14.994 6.44046 14.3403 5.69687 14.2583C5.10833 14.1933 4.62023 13.996 4.23527 13.7046L6.47532 12.1242C7.43594 11.4465 8.6694 11.3508 9.71577 11.8727C11.2951 12.6603 13.1628 12.4739 14.5699 11.388L16.8719 9.61154V11.1594C16.8719 12.1631 16.5545 12.9278 16.0638 13.4392C15.5731 13.9506 14.8395 14.2813 13.8763 14.2813H10.9512C10.6631 14.2813 10.3815 14.37 10.1416 14.5363L7.00476 16.7108V15.7733ZM5.65588 10.8627L3.35066 12.489C3.20882 12.1073 3.12879 11.6635 3.12879 11.1594V6.312C3.12879 5.30822 3.44612 4.54358 3.93681 4.03219C4.42751 3.5208 5.1612 3.19008 6.12436 3.19008H13.8763C14.8395 3.19008 15.5731 3.5208 16.0638 4.03219C16.5545 4.54358 16.8719 5.30822 16.8719 6.312V7.7159L13.7 10.1637C12.728 10.9138 11.4378 11.0426 10.3468 10.4985C8.83207 9.74298 7.04648 9.88161 5.65588 10.8627ZM5.54296 15.7733C4.49322 15.6574 3.58256 15.2245 2.90317 14.5164C2.10117 13.6806 1.66699 12.5089 1.66699 11.1594V6.312C1.66699 4.96247 2.10117 3.79078 2.90317 2.95495C3.70517 2.11911 4.82945 1.66663 6.12436 1.66663H13.8763C15.1712 1.66663 16.2955 2.11911 17.0975 2.95495C17.8995 3.79078 18.3337 4.96247 18.3337 6.312V11.1594C18.3337 12.5089 17.8995 13.6806 17.0975 14.5164C16.2955 15.3522 15.1712 15.8047 13.8763 15.8047H10.9512L7.6479 18.0947C6.75248 18.7163 5.54296 18.0528 5.54296 16.9196V15.7733ZM13.2126 6.30126C13.2126 7.13721 12.5624 7.81487 11.7603 7.81487C10.9582 7.81487 10.3079 7.13721 10.3079 6.30126C10.3079 5.46531 10.9582 4.78765 11.7603 4.78765C12.5624 4.78765 13.2126 5.46531 13.2126 6.30126Z",
            fill: "var(--icon-color)"
        })
    });
}
function aiPhotoshoot(width, height) {
    return /*#__PURE__*/ _jsxs("svg", {
        width: width ? width : "20",
        height: height ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.87661 1.97023C9.21826 1.77133 9.60566 1.66663 10 1.66663C10.3944 1.66663 10.7818 1.77134 11.1234 1.97026C11.124 1.97056 11.1245 1.97087 11.125 1.97117L16.375 5.00203C16.7167 5.20135 17.0005 5.48794 17.198 5.83306C17.3954 6.17818 17.4996 6.56969 17.5 6.96831V13.0316C17.4996 13.4302 17.3954 13.8217 17.198 14.1669C17.0005 14.512 16.7167 14.7986 16.375 14.9979L16.3721 14.9996L11.125 18.0287C11.1245 18.029 11.1241 18.0293 11.1237 18.0295C10.7819 18.2285 10.3944 18.3333 10 18.3333C9.60558 18.3333 9.21809 18.2285 8.87639 18.0296C8.87593 18.0293 8.87546 18.029 8.875 18.0287L3.6279 14.9996L3.625 14.9979C3.2833 14.7986 2.99948 14.512 2.80202 14.1669C2.60456 13.8217 2.5004 13.4302 2.5 13.0316V6.96831C2.5004 6.56969 2.60456 6.17818 2.80202 5.83306C2.99948 5.48794 3.2833 5.20135 3.625 5.00204L3.62789 5.00035L8.87661 1.97023ZM10 3.18206C9.86835 3.18206 9.73901 3.21707 9.625 3.28357L9.62211 3.28526L4.375 6.31444C4.37461 6.31467 4.37421 6.3149 4.37382 6.31513C4.26044 6.38154 4.16626 6.47681 4.10067 6.59145C4.03491 6.7064 4.00019 6.83678 4 6.96954V13.0304C4.00019 13.1631 4.03491 13.2935 4.10067 13.4085C4.16626 13.5231 4.26044 13.6184 4.37382 13.6848C4.37421 13.685 4.37461 13.6852 4.375 13.6855L9.625 16.7163C9.73901 16.7828 9.86835 16.8179 10 16.8179C10.1317 16.8179 10.261 16.7828 10.375 16.7163L10.3779 16.7147L15.625 13.6855C15.6254 13.6852 15.6258 13.685 15.6262 13.6848C15.7396 13.6184 15.8337 13.5231 15.8993 13.4085C15.9651 13.2934 15.9999 13.1629 16 13.0301V6.96987C15.9999 6.83699 15.9651 6.70649 15.8993 6.59145C15.8337 6.47681 15.7396 6.38155 15.6262 6.31514C15.6258 6.31491 15.6254 6.31467 15.625 6.31444L10.375 3.28358C10.261 3.21708 10.1317 3.18206 10 3.18206Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.82545 6.18991C3.03185 5.84788 3.4903 5.72996 3.84943 5.92653L10.0007 9.29342L16.152 5.92653C16.5111 5.72996 16.9696 5.84788 17.176 6.18991C17.3824 6.53194 17.2586 6.96856 16.8994 7.16513L10.3744 10.7366C10.143 10.8632 9.8584 10.8632 9.627 10.7366L3.102 7.16513C2.74287 6.96856 2.61906 6.53194 2.82545 6.18991Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10 9.99829C10.4142 9.99829 10.75 10.3092 10.75 10.6927V17.6372C10.75 18.0207 10.4142 18.3316 10 18.3316C9.58579 18.3316 9.25 18.0207 9.25 17.6372V10.6927C9.25 10.3092 9.58579 9.99829 10 9.99829Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function deformAi(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width ? width : "20",
        height: height ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.44184 1.68539C11.1161 1.57278 12.7854 1.96894 14.2311 2.82202C15.6769 3.67511 16.8317 4.94537 17.5445 6.46654C18.2573 7.98772 18.4948 9.68894 18.2261 11.3475C18.1523 11.8024 17.7243 12.1114 17.27 12.0375C16.8157 11.9637 16.5072 11.5351 16.5809 11.0802C16.7959 9.75334 16.6059 8.39237 16.0357 7.17543C15.4654 5.95849 14.5416 4.94228 13.385 4.25981C12.2284 3.57735 10.893 3.26042 9.55353 3.3505C8.21409 3.44059 6.933 3.9335 5.87796 4.76472C4.82292 5.59594 4.04307 6.72673 3.64049 8.0091C3.2379 9.29147 3.23134 10.6657 3.62166 11.9518C4.01198 13.238 4.781 14.3762 5.82805 15.2175C6.87511 16.0588 8.15143 16.5639 9.48996 16.6668C9.94884 16.7021 10.2923 17.1032 10.257 17.5627C10.2218 18.0222 9.82125 18.3661 9.36236 18.3308C7.68921 18.2022 6.09381 17.5707 4.78499 16.5191C3.47616 15.4675 2.51489 14.0448 2.027 12.4371C1.5391 10.8294 1.5473 9.1116 2.05053 7.50864C2.55375 5.90567 3.52856 4.49218 4.84737 3.45316C6.16617 2.41414 7.76753 1.798 9.44184 1.68539ZM8.78286 8.5052C8.76683 8.51447 8.6209 8.61417 8.6209 9.0451V10.9729C8.6209 11.4039 8.76683 11.5036 8.78286 11.5129C8.79857 11.5219 8.95686 11.5988 9.32857 11.3839L10.991 10.4198C11.3629 10.2047 11.3764 10.0283 11.3764 10.009C11.3764 9.98973 11.3629 9.81338 10.991 9.5983L9.329 8.63438C8.95722 8.41942 8.79857 8.4961 8.78286 8.5052ZM8.00498 7.15799C8.6684 6.77405 9.44703 6.90548 10.1066 7.287L10.1074 7.28745L11.7686 8.25092C12.4282 8.63257 12.9307 9.24241 12.9307 10.009C12.9307 10.7756 12.4286 11.3852 11.7691 11.7668L10.1066 12.731C9.44703 13.1126 8.6684 13.244 8.00498 12.8601C7.34187 12.4763 7.06657 11.7354 7.06657 10.9729V9.0451C7.06657 8.28261 7.34187 7.54174 8.00498 7.15799ZM18.3338 13.5451V17.6688C18.306 18.4448 17.3052 18.4442 17.2776 17.6688V13.5451C17.3055 12.7691 18.3062 12.7697 18.3338 13.5451ZM14.0888 12.9634C14.6712 12.961 15.1661 13.3374 15.3484 13.9223C15.3524 13.9352 16.206 17.5348 16.206 17.5348C16.28 17.847 16.0878 18.1602 15.7769 18.2345C15.4741 18.3093 15.1526 18.1183 15.0799 17.8037L14.9172 17.1174H13.2952L13.1397 17.799C13.0683 18.1117 12.7581 18.3072 12.4463 18.2356C12.1347 18.1639 11.94 17.8523 12.0114 17.5396C12.0114 17.5396 12.8318 13.9463 12.8357 13.9333C13.0137 13.3465 13.5055 12.9657 14.0888 12.9634ZM13.9597 14.1724L13.5811 16.1356H14.6374L14.2437 14.1698C14.2143 14.0722 14.1656 14.0207 14.1023 14.0207H14.1017C14.0386 14.021 13.9885 14.0746 13.9597 14.1724Z",
            fill: "var(--icon-color)"
        })
    });
}
function restyleAi(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width ? width : "20",
        height: height ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.66706 16.2082V12.9585C6.64525 12.3474 5.85573 12.347 5.83374 12.9585V16.2082C5.85555 16.8193 6.64506 16.8197 6.66706 16.2082ZM4.31137 13.2557C4.16753 12.7948 3.77709 12.4982 3.31758 12.5001C2.85742 12.5019 2.46937 12.8019 2.32896 13.2644C2.32586 13.2747 1.67862 16.1063 1.67862 16.1063C1.62232 16.3528 1.77594 16.5983 2.02173 16.6548C2.26775 16.7113 2.51247 16.5572 2.56877 16.3107L2.69149 15.7736H3.97117L4.0995 16.3145C4.15687 16.5623 4.41052 16.7129 4.64939 16.6539C4.8947 16.5954 5.0463 16.3485 4.98792 16.1026C4.98792 16.1026 4.31454 13.2659 4.31137 13.2557ZM2.91655 15L3.21524 13.4529C3.23798 13.3759 3.27745 13.3336 3.32728 13.3334C3.37725 13.3334 3.41611 13.3739 3.4393 13.4509L3.74987 15H2.91655Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.663 6.7912C16.5296 6.85314 16.3756 6.9295 16.1846 7.02436L15.0003 7.61234V11.5544L16.1846 12.1424C16.3756 12.2372 16.5296 12.3136 16.663 12.3755C16.6669 12.2293 16.667 12.0584 16.667 11.8463V7.32041C16.667 7.10831 16.6669 6.93742 16.663 6.7912ZM16.4387 5.09633C16.7469 4.99617 17.2106 4.90965 17.6618 5.18655C18.113 5.46345 18.2424 5.91394 18.29 6.23251C18.3339 6.5255 18.3338 6.89389 18.3337 7.26852C18.3337 7.28581 18.3337 7.3031 18.3337 7.32041V11.8463C18.3337 11.8636 18.3337 11.8809 18.3337 11.8982C18.3338 12.2729 18.3339 12.6412 18.29 12.9342C18.2424 13.2528 18.113 13.7033 17.6618 13.9802C17.2106 14.2571 16.7469 14.1706 16.4387 14.0704C16.1552 13.9783 15.8234 13.8135 15.486 13.6459C15.4704 13.6381 15.4548 13.6304 15.4392 13.6226L13.7943 12.806C13.512 12.6658 13.3337 12.3793 13.3337 12.0658V7.10092C13.3337 6.78749 13.512 6.50097 13.7943 6.3608L15.4392 5.54411C15.4548 5.53637 15.4704 5.52863 15.486 5.5209C15.8234 5.35327 16.1552 5.18845 16.4387 5.09633Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.66699 6.66671C1.66699 4.82576 3.15938 3.33337 5.00033 3.33337H11.667C13.5079 3.33337 15.0003 4.82576 15.0003 6.66671V13.3334C15.0003 15.1743 13.5079 16.6667 11.667 16.6667H8.75033C8.29009 16.6667 7.91699 16.2936 7.91699 15.8334C7.91699 15.3731 8.29009 15 8.75033 15H11.667C12.5875 15 13.3337 14.2538 13.3337 13.3334V6.66671C13.3337 5.74623 12.5875 5.00004 11.667 5.00004H5.00033C4.07985 5.00004 3.33366 5.74623 3.33366 6.66671V10.8334C3.33366 11.2936 2.96056 11.6667 2.50033 11.6667C2.04009 11.6667 1.66699 11.2936 1.66699 10.8334V6.66671Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function photoAi(width, height) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width ? width : "20",
        height: height ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.70698 1.66663C5.76037 1.66663 4.18588 2.04566 3.11861 3.09822C2.05133 4.15078 1.66699 5.70355 1.66699 7.62331V12.0406C1.66699 13.9604 2.05133 15.5132 3.11861 16.5657C4.18588 17.6183 5.76037 17.9973 7.70698 17.9973H10.3289C10.3113 17.8247 10.3213 17.6466 10.3626 17.4684L10.6125 16.391H7.70698C5.92101 16.391 4.88269 16.0338 4.27031 15.4299C3.99308 15.1565 3.76712 14.797 3.60283 14.3219C3.63272 14.3067 3.66197 14.2894 3.69042 14.2701L7.30791 11.8166C7.5855 11.6286 8.00732 11.6573 8.24288 11.8592L8.48086 12.0705L8.48778 12.0765C9.3677 12.8401 10.753 12.8401 11.6329 12.0765L14.6854 9.43026C14.9502 9.20052 15.414 9.20055 15.6788 9.43029L16.5973 10.2273V12.0406C16.5973 12.1268 16.5964 12.2112 16.5947 12.2939C16.8847 11.8523 17.3732 11.5827 17.9181 11.5829C18.0232 11.5829 18.1262 11.593 18.2261 11.6124V9.90661C18.2275 9.8791 18.2275 9.85155 18.2261 9.82408V7.62331C18.2261 5.70355 17.8417 4.15078 16.7744 3.09822C15.7072 2.04566 14.1327 1.66663 12.1861 1.66663H7.70698ZM16.5973 8.09964V7.62331C16.5973 5.86198 16.2351 4.83798 15.6227 4.23404C15.0104 3.63011 13.972 3.27292 12.1861 3.27292H7.70698C5.92101 3.27292 4.88269 3.63011 4.27031 4.23404C3.65793 4.83798 3.29575 5.86198 3.29575 7.62331V12.0406C3.29575 12.2287 3.29988 12.4083 3.308 12.58L6.3852 10.4929C7.26591 9.89601 8.51475 9.95538 9.32161 10.6557L9.32844 10.6617L9.56644 10.8729C9.83164 11.1003 10.2935 11.0993 10.5573 10.8703L13.6098 8.22407C14.4389 7.50487 15.7165 7.4634 16.5973 8.09964ZM16.3183 14.3207L16.3068 14.2729L16.3183 14.2376V14.3207ZM7.00288 8.26617C7.85133 8.26617 8.53914 7.58785 8.53914 6.7511C8.53914 5.91436 7.85133 5.23604 7.00288 5.23604C6.15444 5.23604 5.46663 5.91436 5.46663 6.7511C5.46663 7.58785 6.15444 8.26617 7.00288 8.26617ZM18.333 17.7154V13.3372C18.3032 12.5138 17.2246 12.5132 17.1945 13.3372V17.7154C17.2243 18.5388 18.3029 18.5394 18.333 17.7154ZM15.1152 13.7376C14.9187 13.1166 14.3853 12.717 13.7576 12.7195C13.1289 12.722 12.5988 13.1262 12.407 13.7493C12.4027 13.7632 11.5185 17.5783 11.5185 17.5783C11.4416 17.9103 11.6514 18.2412 11.9872 18.3173C12.3233 18.3933 12.6577 18.1858 12.7346 17.8537L12.9022 17.13H14.6505L14.8258 17.8587C14.9042 18.1927 15.2507 18.3955 15.577 18.3161C15.9122 18.2372 16.1193 17.9046 16.0395 17.5732C16.0395 17.5732 15.1196 13.7513 15.1152 13.7376ZM13.2108 16.0876L13.6188 14.0032C13.6499 13.8994 13.7038 13.8425 13.7719 13.8421H13.7725C13.8408 13.8421 13.8933 13.8968 13.9249 14.0005L14.3492 16.0876H13.2108Z",
            fill: "var(--icon-color)"
        })
    });
}
function history(width, height) {
    return /*#__PURE__*/ _jsxs("svg", {
        width: width ? width : "20",
        height: height ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.83333 11.6666C5.83333 11.2064 6.20643 10.8333 6.66667 10.8333H10.8333C11.2936 10.8333 11.6667 11.2064 11.6667 11.6666C11.6667 12.1269 11.2936 12.5 10.8333 12.5H6.66667C6.20643 12.5 5.83333 12.1269 5.83333 11.6666Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.74408 3.57737C3.06951 3.25193 3.59715 3.25193 3.92259 3.57737L4.75592 4.4107C5.08136 4.73614 5.08136 5.26378 4.75592 5.58922C4.43049 5.91465 3.90285 5.91465 3.57741 5.58922L2.74408 4.75588C2.41864 4.43044 2.41864 3.90281 2.74408 3.57737Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.25592 1.9107C7.58136 2.23614 7.58136 2.76378 7.25592 3.08922L4.75592 5.58922C4.43049 5.91465 3.90285 5.91465 3.57741 5.58922C3.25197 5.26378 3.25197 4.73614 3.57741 4.4107L6.07741 1.9107C6.40285 1.58527 6.93049 1.58527 7.25592 1.9107Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.83333 8.33329C5.83333 7.87306 6.20643 7.49996 6.66667 7.49996H13.3333C13.7936 7.49996 14.1667 7.87306 14.1667 8.33329C14.1667 8.79353 13.7936 9.16663 13.3333 9.16663H6.66667C6.20643 9.16663 5.83333 8.79353 5.83333 8.33329Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.33333 2.49996C8.33333 2.03972 8.70643 1.66663 9.16667 1.66663H12.8788C12.8941 1.66663 12.9094 1.66705 12.9247 1.66789C14.2538 1.74127 15.4804 2.03487 16.3368 2.98175C17.1798 3.91378 17.5 5.29957 17.5 7.13508V13.3333C17.5 13.7935 17.1269 14.1666 16.6667 14.1666C16.2064 14.1666 15.8333 13.7935 15.8333 13.3333V7.13508C15.8333 5.42653 15.521 4.56442 15.1007 4.09972C14.6964 3.6527 14.0349 3.40111 12.8553 3.33329H9.16667C8.70643 3.33329 8.33333 2.9602 8.33333 2.49996Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.33333 6.66663C3.79357 6.66663 4.16667 7.03972 4.16667 7.49996V12.8656C4.16667 14.3953 4.37034 15.272 4.82297 15.7952C5.24918 16.288 6.08135 16.6666 7.91667 16.6666H12.4993C12.9595 16.6666 13.3333 17.0397 13.3333 17.5C13.3333 17.9602 12.9602 18.3333 12.5 18.3333H7.91667C5.93253 18.3333 4.47304 17.9383 3.56245 16.8856C2.67827 15.8634 2.5 14.423 2.5 12.8656V7.49996C2.5 7.03972 2.8731 6.66663 3.33333 6.66663Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.6101 14.4434C13.4743 14.5792 13.3333 14.8506 13.3333 15.4166V15.4881L14.6548 14.1666H14.5833C14.0173 14.1666 13.7459 14.3076 13.6101 14.4434ZM12.4316 13.2649C12.9902 12.7062 13.7604 12.5 14.5833 12.5H16.6667C17.0037 12.5 17.3076 12.703 17.4366 13.0144C17.5655 13.3258 17.4943 13.6842 17.2559 13.9225L13.0893 18.0892C12.8509 18.3275 12.4925 18.3988 12.1811 18.2699C11.8697 18.1409 11.6667 17.837 11.6667 17.5V15.4166C11.6667 14.5937 11.873 13.8235 12.4316 13.2649Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function activeJobs(width, height) {
    return /*#__PURE__*/ _jsxs("svg", {
        width: width ? width : "20",
        height: height ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.7237 2.50119C6.7237 2.04027 7.10322 1.66663 7.57138 1.66663H12.6574C13.1256 1.66663 13.5051 2.04027 13.5051 2.50119C13.5051 2.96211 13.1256 3.33575 12.6574 3.33575H7.57138C7.10322 3.33575 6.7237 2.96211 6.7237 2.50119Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.9384 9.73083C13.2697 10.0565 13.2702 10.5849 12.9394 10.9111L10.7143 13.1056C10.3836 13.4318 9.84684 13.4322 9.51551 13.1066C9.18419 12.781 9.18373 12.2525 9.51448 11.9263L11.7396 9.73184C12.0704 9.40564 12.6071 9.40519 12.9384 9.73083Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.333 17.6924V13.5627C18.3049 12.7861 17.2869 12.7855 17.2586 13.5627V17.6924C17.2867 18.469 18.3046 18.4696 18.333 17.6924ZM15.2962 13.9404C15.1108 13.3547 14.6073 12.9777 14.0149 12.9801C13.4216 12.9824 12.9213 13.3637 12.7402 13.9515C12.7362 13.9645 11.9017 17.563 11.9017 17.563C11.8291 17.8762 12.0272 18.1883 12.3441 18.26C12.6613 18.3318 12.9768 18.136 13.0494 17.8228L13.2076 17.1402H14.8576L15.023 17.8275C15.097 18.1425 15.424 18.3339 15.732 18.2589C16.0483 18.1846 16.2438 17.8708 16.1685 17.5583C16.1685 17.5583 15.3003 13.9533 15.2962 13.9404ZM13.4985 16.157L13.8836 14.1908C13.9129 14.093 13.9638 14.0392 14.028 14.0389C14.0925 14.0389 14.1426 14.0905 14.1725 14.1883L14.5729 16.157H13.4985Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.43678 5.21241C9.67123 4.9021 10.9695 4.94044 12.1828 5.32304C13.3962 5.70564 14.4755 6.41701 15.2971 7.37566C16.1188 8.3343 16.6495 9.50144 16.8285 10.7433C16.8943 11.1997 16.5719 11.6221 16.1083 11.6869C15.6448 11.7516 15.2158 11.4342 15.15 10.9779C15.0157 10.0464 14.6177 9.17108 14.0015 8.45209C13.3852 7.73311 12.5757 7.19957 11.6657 6.91263C10.7557 6.62568 9.78202 6.59692 8.85618 6.82965C7.93035 7.06238 7.08983 7.54719 6.43093 8.22851C5.77203 8.90984 5.32141 9.76013 5.13069 10.682C4.93997 11.6038 5.01688 12.5599 5.35259 13.4407C5.6883 14.3214 6.26924 15.0913 7.02885 15.662C7.78846 16.2328 8.69601 16.5813 9.64751 16.6676C10.1137 16.7099 10.4568 17.1163 10.4138 17.5753C10.3708 18.0343 9.95806 18.372 9.49188 18.3297C8.22321 18.2146 7.01315 17.7499 6.00034 16.9889C4.98753 16.2279 4.21294 15.2015 3.76532 14.0271C3.3177 12.8527 3.21517 11.5779 3.46946 10.3488C3.72375 9.11971 4.32458 7.98599 5.20311 7.07755C6.08164 6.16912 7.20233 5.52271 8.43678 5.21241Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function videoTemplates(width, height) {
    return /*#__PURE__*/ _jsx("svg", {
        width: width ? width : "20",
        height: height ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.98538 6.72901C2.77359 6.6082 2.55385 6.4988 2.32707 6.40167C2.2281 6.35927 2.12778 6.31921 2.02619 6.28156C1.80898 6.20106 1.80898 5.67036 2.02619 5.58985C2.12778 5.5522 2.2281 5.51214 2.32708 5.46975C2.55385 5.37261 2.77359 5.26321 2.98538 5.14241C3.01479 5.12563 3.04405 5.10863 3.07316 5.09141C3.94135 4.57791 4.67108 3.87079 5.19867 3.03136C5.21377 3.00734 5.2287 2.98321 5.24346 2.95898C5.36845 2.75382 5.48146 2.541 5.5816 2.32139C5.62873 2.21804 5.673 2.11319 5.71433 2.00693C5.79737 1.79343 6.3071 1.79343 6.39013 2.00693C6.43146 2.11319 6.47574 2.21804 6.52286 2.32139C6.623 2.541 6.73602 2.75382 6.861 2.95898C6.87577 2.98321 6.8907 3.00734 6.90579 3.03136C7.43338 3.87079 8.16312 4.57791 9.0313 5.09141C9.06041 5.10863 9.08967 5.12563 9.11909 5.14241C9.33088 5.26321 9.55061 5.37261 9.77739 5.46975C9.87637 5.51214 9.97669 5.5522 10.0783 5.58985C10.2955 5.67036 10.2955 6.20106 10.0783 6.28156C9.97669 6.31921 9.87637 6.35927 9.77739 6.40167C9.55061 6.4988 9.33088 6.60821 9.11909 6.72901C9.08967 6.74579 9.06041 6.76278 9.0313 6.78C8.16312 7.2935 7.43338 8.00062 6.90579 8.84005C6.8907 8.86407 6.87577 8.8882 6.861 8.91243C6.73602 9.11759 6.623 9.33041 6.52286 9.55002C6.47574 9.65337 6.43146 9.75822 6.39013 9.86449C6.3071 10.078 5.79737 10.078 5.71433 9.86449C5.673 9.75822 5.62873 9.65337 5.5816 9.55002C5.48146 9.33042 5.36844 9.11759 5.24346 8.91243C5.2287 8.8882 5.21377 8.86407 5.19867 8.84005C4.67108 8.00062 3.94135 7.2935 3.07316 6.78C3.04405 6.76278 3.01479 6.74578 2.98538 6.72901ZM4.72577 5.77115C4.62039 5.85477 4.62039 6.01665 4.72577 6.10026C5.15336 6.43955 5.54395 6.82203 5.89036 7.24153C5.97389 7.34268 6.13058 7.34268 6.2141 7.24153C6.56052 6.82202 6.9511 6.43955 7.37869 6.10026C7.48407 6.01665 7.48407 5.85476 7.37869 5.77115C6.9511 5.43186 6.56052 5.04939 6.2141 4.62988C6.13058 4.52873 5.97389 4.52873 5.89036 4.62988C5.54395 5.04939 5.15336 5.43186 4.72577 5.77115ZM12.5822 9.62294C12.2988 9.81204 11.9954 9.97546 11.6754 10.1098C11.4618 10.1995 11.4618 10.7688 11.6754 10.8585C11.9954 10.9928 12.2988 11.1562 12.5822 11.3453C13.1198 11.704 13.5852 12.1552 13.9541 12.6753C14.1525 12.9551 14.323 13.2549 14.4618 13.571C14.5539 13.7808 15.099 13.7808 15.1911 13.571C15.3299 13.2549 15.5004 12.9551 15.6989 12.6753C16.0678 12.1552 16.5331 11.704 17.0707 11.3453C17.3541 11.1562 17.6576 10.9928 17.9775 10.8585C18.1911 10.7688 18.1911 10.1995 17.9775 10.1098C17.6576 9.97546 17.3541 9.81203 17.0707 9.62294C16.5331 9.26422 16.0678 8.8131 15.6989 8.29297C15.5004 8.01315 15.3299 7.71335 15.1911 7.39722C15.099 7.18747 14.5539 7.18747 14.4618 7.39722C14.323 7.71335 14.1525 8.01315 13.9541 8.29297C13.5852 8.8131 13.1198 9.26422 12.5822 9.62294ZM14.1256 10.3256C14.0302 10.4091 14.0302 10.5591 14.1256 10.6426C14.3174 10.8106 14.4995 10.9891 14.6708 11.1773C14.7539 11.2686 14.899 11.2686 14.9821 11.1773C15.1535 10.9891 15.3355 10.8106 15.5273 10.6426C15.6227 10.5591 15.6227 10.4091 15.5273 10.3256C15.3355 10.1576 15.1535 9.97915 14.9821 9.79096C14.899 9.69964 14.7539 9.69964 14.6708 9.79096C14.4995 9.97915 14.3174 10.1576 14.1256 10.3256ZM7.6632 17.061C7.61895 17.003 7.57315 16.9462 7.52587 16.8906C7.34794 16.6815 7.14891 16.4897 6.93184 16.3182C6.885 16.2811 6.83731 16.2451 6.78881 16.21C6.49689 15.9987 6.17563 15.8227 5.83172 15.6885C5.77962 15.6682 5.727 15.6488 5.67388 15.6304C5.54255 15.5849 5.54255 15.2783 5.67388 15.2328C5.727 15.2144 5.77962 15.195 5.83172 15.1747C6.17563 15.0405 6.49689 14.8645 6.78881 14.6532C6.83731 14.6181 6.885 14.5821 6.93184 14.545C7.14891 14.3735 7.34794 14.1817 7.52587 13.9726C7.57315 13.917 7.61895 13.8602 7.6632 13.8022C7.87412 13.5258 8.04987 13.2229 8.18426 12.8993C8.20688 12.8448 8.22833 12.7898 8.24858 12.7342C8.29561 12.605 8.59066 12.605 8.63769 12.7342C8.65794 12.7898 8.67939 12.8448 8.70201 12.8993C8.8364 13.2229 9.01215 13.5258 9.22307 13.8022C9.26732 13.8602 9.31312 13.917 9.36041 13.9726C9.53833 14.1817 9.73736 14.3735 9.95443 14.545C10.0013 14.5821 10.049 14.6181 10.0975 14.6532C10.3894 14.8645 10.7106 15.0405 11.0546 15.1747C11.1067 15.195 11.1593 15.2144 11.2124 15.2328C11.3437 15.2783 11.3437 15.5849 11.2124 15.6304C11.1593 15.6488 11.1067 15.6682 11.0546 15.6885C10.7106 15.8227 10.3894 15.9987 10.0975 16.21C10.049 16.2451 10.0013 16.2811 9.95443 16.3182C9.73736 16.4897 9.53833 16.6815 9.36041 16.8906C9.31312 16.9462 9.26732 17.003 9.22307 17.061C9.01215 17.3374 8.8364 17.6403 8.70201 17.9639C8.67939 18.0184 8.65794 18.0734 8.63769 18.129C8.59066 18.2582 8.29561 18.2582 8.24858 18.129C8.22833 18.0734 8.20688 18.0184 8.18426 17.9639C8.04987 17.6403 7.87412 17.3374 7.6632 17.061Z",
            fill: "var(--icon-color)"
        })
    });
}
function adExamples(width, height) {
    return /*#__PURE__*/ _jsxs("svg", {
        width: width ? width : "20",
        height: height ? height : "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M14.5267 3.80675L13.4206 3.48547C13.3694 3.47019 13.3149 3.46984 13.2636 3.48447C13.2122 3.49909 13.166 3.52809 13.1304 3.56808C13.1061 3.596 13.0875 3.6285 13.0758 3.6637C13.0641 3.69889 13.0595 3.73607 13.0623 3.77307C13.065 3.81007 13.0751 3.84615 13.0919 3.8792C13.1087 3.91225 13.1318 3.94162 13.16 3.96559L14.0274 4.7267C14.2097 4.88623 14.3381 5.08232 14.4059 5.2942L14.4104 5.31136C14.477 5.52993 14.4803 5.76772 14.4152 6.00306L14.1108 7.09679C14.0967 7.14853 14.0975 7.20323 14.113 7.25454C14.1286 7.30585 14.1583 7.35167 14.1988 7.38669C14.255 7.4362 14.3284 7.46154 14.403 7.45725C14.4777 7.45297 14.5477 7.41941 14.5979 7.3638L15.3492 6.51414C15.5035 6.33713 15.7054 6.20852 15.9305 6.14368C16.1587 6.08064 16.3999 6.08329 16.6267 6.15132L17.7332 6.47196C17.7843 6.48725 17.8388 6.48759 17.8902 6.47297C17.9416 6.45834 17.9878 6.42934 18.0234 6.38935C18.0477 6.36144 18.0662 6.32893 18.0779 6.29374C18.0896 6.25854 18.0942 6.22136 18.0915 6.18436C18.0887 6.14737 18.0786 6.11129 18.0619 6.07824C18.0451 6.04518 18.0219 6.01582 17.9937 5.99185L17.126 5.23136C16.9391 5.06685 16.808 4.86522 16.7421 4.64699C16.6761 4.42876 16.6727 4.19097 16.7382 3.955L17.042 2.86093C17.0561 2.80919 17.0553 2.75449 17.0397 2.70318C17.0242 2.65187 16.9944 2.60605 16.954 2.57103C16.8977 2.52152 16.8244 2.49618 16.7497 2.50047C16.6751 2.50475 16.6051 2.53831 16.5548 2.59392L15.8046 3.4433C15.6469 3.62143 15.452 3.74562 15.24 3.80987L15.2232 3.81376C14.995 3.87711 14.7536 3.87468 14.5267 3.80675Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.66699 5.78071C1.66699 4.3933 2.78628 3.26857 4.16699 3.26857H10.8268C11.287 3.26857 11.6601 3.64348 11.6601 4.10595C11.6601 4.56843 11.287 4.94333 10.8268 4.94333H4.16699C3.70675 4.94333 3.33366 5.31824 3.33366 5.78071V14.1545C3.33366 14.617 3.70675 14.9919 4.16699 14.9919H15.8337C16.2939 14.9919 16.667 14.617 16.667 14.1545V9.02555C16.667 8.56308 17.0401 8.18817 17.5003 8.18817C17.9606 8.18817 18.3337 8.56308 18.3337 9.02555V14.1545C18.3337 15.5419 17.2144 16.6667 15.8337 16.6667H4.16699C2.78628 16.6667 1.66699 15.5419 1.66699 14.1545V5.78071Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.0426 12.4391C10.6472 12.4391 10.4154 12.1993 10.4154 11.7814V8.15379C10.4154 7.73588 10.6472 7.49609 11.0426 7.49609H12.413C13.8993 7.49609 14.772 8.36274 14.772 9.93848C14.772 11.5176 13.8959 12.4391 12.413 12.4391H11.0426ZM11.6665 11.4252H12.2494C13.0641 11.4252 13.5005 10.9285 13.5005 9.94191C13.5005 9.01359 13.0403 8.51004 12.2494 8.51004H11.6665V11.4252Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.86729 12.5145C5.47185 12.5145 5.22982 12.2884 5.22982 11.915C5.22982 11.8088 5.26391 11.6547 5.31845 11.5039L6.53204 8.15378C6.71271 7.65023 7.01611 7.42072 7.50359 7.42072C8.01834 7.42072 8.31833 7.63995 8.50582 8.15378L9.72964 11.5039C9.78759 11.6649 9.81145 11.7814 9.81145 11.9116C9.81145 12.2644 9.54896 12.5145 9.18421 12.5145C8.82286 12.5145 8.63536 12.35 8.52628 11.9458L8.35924 11.3977H6.67522L6.50818 11.9253C6.38886 12.3432 6.20137 12.5145 5.86729 12.5145ZM6.92407 10.4489H8.08652L7.51041 8.54429H7.48314L6.92407 10.4489Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function mediaToVideo() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.0492 6.95614C13.0492 7.64649 12.4896 8.20613 11.7992 8.20613C11.1089 8.20613 10.5492 7.64649 10.5492 6.95614C10.5492 6.26579 11.1089 5.70615 11.7992 5.70615C12.4896 5.70615 13.0492 6.26579 13.0492 6.95614ZM17.2228 8.19408L13.6857 10.7118C12.3098 11.6912 10.5834 11.7403 9.19895 10.8395C8.28168 10.2427 7.14375 10.2478 6.2095 10.853L3.25094 12.7696L2.60052 11.452L5.55908 9.53548C6.91151 8.65937 8.55879 8.65192 9.88666 9.51591C10.843 10.1382 12.0356 10.1042 12.986 9.42771L16.5231 6.90995L17.2228 8.19408Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.5 6.66667C2.5 4.36548 4.36548 2.5 6.66667 2.5H13.3333C15.6345 2.5 17.5 4.36548 17.5 6.66667V10C17.5 10.4602 17.1269 10.8333 16.6667 10.8333C16.2064 10.8333 15.8333 10.4602 15.8333 10V6.66667C15.8333 5.28595 14.714 4.16667 13.3333 4.16667H6.66667C5.28595 4.16667 4.16667 5.28595 4.16667 6.66667V12.5C4.16667 13.8807 5.28595 15 6.66667 15H11.1111C11.5713 15 11.9444 15.3731 11.9444 15.8333C11.9444 16.2936 11.5713 16.6667 11.1111 16.6667H6.66667C4.36548 16.6667 2.5 14.8012 2.5 12.5V6.66667Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.2515 14.6167C17.5828 14.4055 17.5828 13.9278 17.2515 13.7166L14.1729 11.7536C13.8109 11.5228 13.3333 11.7788 13.3333 12.2036V16.1297C13.3333 16.5546 13.8109 16.8106 14.1729 16.5798L17.2515 14.6167Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.3333 16.1297C13.3333 16.5546 13.8109 16.8106 14.1729 16.5798L17.2515 14.6167C17.5828 14.4055 17.5828 13.9278 17.2515 13.7166L14.1729 11.7536C13.8109 11.5228 13.3333 11.7788 13.3333 12.2036V16.1297Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function allIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.8327 3.33268C10.8327 2.41221 11.5789 1.66602 12.4993 1.66602H16.666C17.5865 1.66602 18.3327 2.41221 18.3327 3.33268V7.49935C18.3327 8.41982 17.5865 9.16602 16.666 9.16602H12.4993C11.5789 9.16602 10.8327 8.41982 10.8327 7.49935V3.33268ZM16.666 3.33268H12.4993V7.49935H16.666V3.33268ZM3.33268 10.8327C2.41221 10.8327 1.66602 11.5789 1.66602 12.4993V16.666C1.66602 17.5865 2.41221 18.3327 3.33268 18.3327H7.49935C8.41982 18.3327 9.16602 17.5865 9.16602 16.666V12.4993C9.16602 11.5789 8.41982 10.8327 7.49935 10.8327H3.33268ZM3.33268 12.4993H7.49935V16.666H3.33268V12.4993ZM12.4993 10.8327C11.5789 10.8327 10.8327 11.5789 10.8327 12.4993V16.666C10.8327 17.5865 11.5789 18.3327 12.4993 18.3327H16.666C17.5865 18.3327 18.3327 17.5865 18.3327 16.666V12.4993C18.3327 11.5789 17.5865 10.8327 16.666 10.8327H12.4993ZM12.4993 12.4993H16.666V16.666H12.4993V12.4993ZM3.33268 1.66602C2.41221 1.66602 1.66602 2.41221 1.66602 3.33268V7.49935C1.66602 8.41982 2.41221 9.16602 3.33268 9.16602H7.49935C8.41982 9.16602 9.16602 8.41982 9.16602 7.49935V3.33268C9.16602 2.41221 8.41982 1.66602 7.49935 1.66602H3.33268ZM3.33268 3.33268H7.49935V7.49935H3.33268V3.33268Z",
            fill: "var(--icon-color)"
        })
    });
}
function imageIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.9081 11.9216C14.7312 11.7826 14.4099 11.7826 14.233 11.9216L11.457 14.1006C10.5929 14.7792 9.23248 14.7794 8.36851 14.1006L8.36085 14.0946L8.14557 13.9215C7.98981 13.8014 7.69637 13.7818 7.5082 13.8973L3.66805 16.1531L3.1634 15.9059C2.92853 15.754 2.79138 15.5119 2.79499 15.2556C2.7986 14.9993 2.94252 14.7602 3.1816 14.6134L6.47169 12.593C7.33679 12.0622 8.56253 12.1149 9.35505 12.7377L9.36259 12.7437L9.57791 12.9168C9.75539 13.0536 10.0746 13.0527 10.2506 12.9144L13.0263 10.7357C13.8904 10.0569 15.2507 10.0568 16.1148 10.7357L17.2025 11.5902C17.4428 11.779 17.5507 12.0658 17.4858 12.3433L16.8569 13.2726L14.9081 11.9216Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.66602 5.83268C1.66602 3.5315 3.5315 1.66602 5.83268 1.66602H14.166C16.4672 1.66602 18.3327 3.5315 18.3327 5.83268V14.166C18.3327 16.4672 16.4672 18.3327 14.166 18.3327H5.83268C3.5315 18.3327 1.66602 16.4672 1.66602 14.166V5.83268ZM5.83268 3.33268C4.45197 3.33268 3.33268 4.45197 3.33268 5.83268V14.166C3.33268 15.5467 4.45197 16.666 5.83268 16.666H14.166C15.5467 16.666 16.666 15.5467 16.666 14.166V5.83268C16.666 4.45197 15.5467 3.33268 14.166 3.33268H5.83268Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.5 6.66667C7.03976 6.66667 6.66667 7.03976 6.66667 7.5C6.66667 7.96024 7.03976 8.33333 7.5 8.33333C7.96024 8.33333 8.33333 7.96024 8.33333 7.5C8.33333 7.03976 7.96024 6.66667 7.5 6.66667ZM5 7.5C5 6.11929 6.11929 5 7.5 5C8.88071 5 10 6.11929 10 7.5C10 8.88071 8.88071 10 7.5 10C6.11929 10 5 8.88071 5 7.5Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function videoIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.66602 5.83268C1.66602 3.5315 3.5315 1.66602 5.83268 1.66602H14.166C16.4672 1.66602 18.3327 3.5315 18.3327 5.83268V14.166C18.3327 16.4672 16.4672 18.3327 14.166 18.3327H5.83268C3.5315 18.3327 1.66602 16.4672 1.66602 14.166V5.83268ZM5.83268 3.33268C4.45197 3.33268 3.33268 4.45197 3.33268 5.83268V14.166C3.33268 15.5467 4.45197 16.666 5.83268 16.666H14.166C15.5467 16.666 16.666 15.5467 16.666 14.166V5.83268C16.666 4.45197 15.5467 3.33268 14.166 3.33268H5.83268Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.7269 8.40431C8.70922 8.41453 8.54827 8.52436 8.54827 8.9991V11.1229C8.54827 11.5977 8.70922 11.7075 8.7269 11.7177C8.74423 11.7277 8.9188 11.8124 9.32877 11.5757C9.32862 11.5758 9.32893 11.5756 9.32877 11.5757L11.1623 10.5135C11.5724 10.2765 11.5873 10.0823 11.5873 10.061C11.5873 10.0398 11.5724 9.84548 11.1623 9.60853L9.32925 8.54662C9.32913 8.54655 9.32937 8.5467 9.32925 8.54662C8.9192 8.30982 8.74423 8.3943 8.7269 8.40431ZM7.86897 6.92015C8.60066 6.49719 9.45942 6.64198 10.1869 7.06228L10.1877 7.06278L12.0199 8.12419C12.0198 8.12411 12.0201 8.12428 12.0199 8.12419C12.7474 8.54464 13.3016 9.21647 13.3016 10.061C13.3016 10.9055 12.7479 11.577 12.0205 11.9975C12.0203 11.9976 12.0207 11.9974 12.0205 11.9975L10.1869 13.0597C9.45942 13.48 8.60066 13.6248 7.86897 13.2019C7.13762 12.7791 6.83398 11.9629 6.83398 11.1229V8.9991C6.83398 8.1591 7.13762 7.34292 7.86897 6.92015Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function emptyResult() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "65",
        height: "66",
        viewBox: "0 0 65 66",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                opacity: "0.4",
                cx: "32.5",
                cy: "61.9062",
                rx: "32.375",
                ry: "3.46875",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                opacity: "0.4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M1.33543 14.996C1.01466 13.2949 2.15108 11.6526 3.87369 11.3277C5.59629 11.0029 7.25277 12.1186 7.57354 13.8197C7.8943 15.5209 6.75789 17.1632 5.03528 17.488C3.31267 17.8128 1.65619 16.6971 1.33543 14.996Z",
                        fill: "var(--icon-color)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M9.29868 5.83929C8.84961 3.45773 10.4406 1.15846 12.8522 0.703712C15.2639 0.248967 17.583 1.81095 18.032 4.19251C18.4811 6.57406 16.8901 8.87334 14.4785 9.32808C12.0668 9.78283 9.74776 8.22084 9.29868 5.83929Z",
                        fill: "var(--icon-color)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                opacity: "0.5",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M41.6789 47.0832C38.6644 48.9874 35.0926 50.0895 31.2635 50.0895C20.4779 50.0895 11.7344 41.346 11.7344 30.5604C11.7344 19.7747 20.4779 11.0312 31.2635 11.0312C42.0491 11.0312 50.7926 19.7747 50.7926 30.5604C50.7926 34.8691 49.3972 38.8519 47.0337 42.0816L53.6453 48.6987C55.0747 50.1292 55.065 52.4388 53.6235 53.8573C52.1821 55.2757 49.8548 55.2658 48.4254 53.8353L41.6789 47.0832ZM45.9103 30.5604C45.9103 38.6496 39.3527 45.2072 31.2634 45.2072C23.1742 45.2072 16.6166 38.6496 16.6166 30.5604C16.6166 22.4711 23.1742 15.9135 31.2634 15.9135C39.3527 15.9135 45.9103 22.4711 45.9103 30.5604Z",
                fill: "var(--icon-color)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                opacity: "0.4",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M38.0325 23.7921C37.2915 23.0511 36.0902 23.0511 35.3492 23.7921L31.2648 27.8765L27.1804 23.7921C26.4395 23.0511 25.2381 23.0511 24.4972 23.7921C23.7562 24.5331 23.7562 25.7344 24.4972 26.4754L28.5815 30.5597L24.4971 34.6441C23.7562 35.3851 23.7562 36.5865 24.4971 37.3274C25.2381 38.0684 26.4394 38.0684 27.1804 37.3274L31.2648 33.243L35.3493 37.3275C36.0902 38.0685 37.2916 38.0685 38.0325 37.3275C38.7735 36.5865 38.7735 35.3852 38.0325 34.6442L33.9481 30.5597L38.0325 26.4753C38.7735 25.7344 38.7735 24.533 38.0325 23.7921Z",
                fill: "var(--icon-color)"
            })
        ]
    });
}
function landscapeIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
            x: "0.75",
            y: "16.25",
            width: "12.5",
            height: "18.5",
            rx: "1.25",
            transform: "rotate(-90 0.75 16.25)",
            stroke: "var(--icon-color)",
            strokeWidth: "1.5"
        })
    });
}
function portraitIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
            x: "3.75",
            y: "0.75",
            width: "12.5",
            height: "18.5",
            rx: "1.25",
            stroke: "var(--icon-color)",
            strokeWidth: "1.5"
        })
    });
}
function searchIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "6.51149",
                cy: "6.51149",
                r: "5.51149",
                stroke: "var(--icon-color)",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10.7266 10.7265L13.3202 13.3202",
                stroke: "var(--icon-color)",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/***/ }),

/***/ 8255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ FeedbackMessagePopup; },
/* harmony export */   "_": function() { return /* binding */ FeedbackMessage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6154);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2213);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1455);
/* harmony import */ var _comps_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5896);
/* harmony import */ var _comps_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9612);
/* harmony import */ var _comps_message__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9034);
/* harmony import */ var _comps_textarea__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1411);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(177);
/* harmony import */ var _utils_notification__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4371);
/* harmony import */ var _kartyom_shared_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8976);















function FeedbackMessage(props) {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("flex w-full gap-[18px] rounded-[12px] bg-color-popup-cell p-[16px]", "relative mt-[100px] flex-col tablet:gap-0"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex w-full items-start justify-between tablet:items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col gap-[6px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-[18px] font-500 text-blue-700",
                                children: t("txt_give_feedback")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-[16px] font-400 text-blue-700",
                                children: t("txt_do_you_like_result")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: props.action,
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("h-[24px] w-[24px] [--icon-color:var(--color-blue-400)]", "hover:[--icon-color:var(--color-blue-500)]"),
                        children: (0,_comps_ai_tools_icons__WEBPACK_IMPORTED_MODULE_3__/* .newCloseIcon */ .DS)()
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                onClick: function() {
                    var feedback = document.getElementById("feedback-message-background");
                    if (feedback) {
                        feedback.style.display = "flex";
                    }
                },
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("flex w-full items-center justify-center py-[12px] outline-none", "rounded-[6px] border border-blue-200 tablet:w-[151px]", "tablet:absolute tablet:top-1/2 tablet:-translate-y-1/2", " transition-all duration-300 hover:bg-blue-100 tablet:right-[52px]"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "text-[16px] font-500 leading-[20px] text-blue-800",
                    children: t("txt_leave_feedback")
                })
            })
        ]
    });
}
function FeedbackMessagePopup(props) {
    var id = props.id, changeShowRating = props.changeShowRating;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_utils_notification__WEBPACK_IMPORTED_MODULE_8__/* .NotificationContext */ .u).notify;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), feedbackText = ref[0], setFeedbackText = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), selectedEmotion = ref1[0], setSelectedEmotion = ref1[1];
    (0,_kartyom_shared_components__WEBPACK_IMPORTED_MODULE_9__/* .useShortCut */ .Xg)({
        shortCut: "Escape",
        handler: function() {
            var feedback = document.getElementById("feedback-message-background");
            if (feedback) {
                feedback.style.display = "none";
            }
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "feedback-message-background",
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("fixed left-0 top-0 z-[105] h-[100svh] w-screen bg-color-popup", "flex items-end tablet:items-center tablet:justify-center"),
        style: {
            display: "none"
        },
        onClick: function(e) {
            if (e.currentTarget) {
                if (e.currentTarget.id !== "feedback-message") {
                    var feedback = document.getElementById("feedback-message-background");
                    if (feedback) {
                        feedback.style.display = "none";
                    }
                }
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            onClick: function(e) {
                return e.stopPropagation();
            },
            id: "feedback-message",
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("flex w-full flex-col bg-color-popup-cell pt-[24px]", "h-[555px] gap-[24px] rounded-t-[12px] tablet:w-[520px]", "tablet:h-auto tablet:rounded-b-[10px] tablet:rounded-t-[10px]", "desktop:relative"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col items-center gap-[12px] px-[24px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-[26px] font-700 text-blue-900 tablet:text-[28px]",
                            children: t("txt_give_feedback")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-[18px] font-400 text-blue-700 tablet:text-[20px]",
                            children: t("txt_feedback_matters_you")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mx-[24px] h-[1px] w-[calc(100%-48px)] bg-color-separator"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex w-full flex-col gap-[18px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col gap-[12px] px-[24px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-[18px] font-400 text-blue-700",
                                    children: t("txt_rate_your_experience")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex items-center justify-between",
                                    children: rateEmotions.map(function(elem) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Emotion, {
                                            name: elem.name,
                                            icon: elem.icon,
                                            selected: selectedEmotion === elem.rate,
                                            setSelected: function() {
                                                return setSelectedEmotion(elem.rate);
                                            }
                                        }, elem.name);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col gap-[12px] px-[24px] pt-[10px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-[18px] font-400 leading-[24px] text-blue-700",
                                    children: t("txt_what_you_want_to_change")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("h-[95px] w-full rounded-[8px] border border-color-separator", "bg-color-surface-cell px-[12px] py-[8px]"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_textarea__WEBPACK_IMPORTED_MODULE_7__/* .Textarea */ .g, {
                                        value: feedbackText,
                                        setValue: setFeedbackText,
                                        placeholder: t("txt_feedback_placeholder"),
                                        background: "bg-color-surface-cell"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("flex w-full px-[24px] tablet:border-t tablet:bg-color-popup-cell tablet:py-[24px]", "tablet:rounded-b-[10px] tablet:border-color-separator"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                                text: t("txt_send_feedback"),
                                primary: true,
                                className: "w-full",
                                disabled: selectedEmotion === null || feedbackText === "",
                                onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function() {
                                    var feedback;
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    axios__WEBPACK_IMPORTED_MODULE_13__/* ["default"].post */ .Z.post("/api/wizard-rate-session", {
                                                        session_id: id,
                                                        rating: selectedEmotion,
                                                        message: feedbackText
                                                    }).then(function() {
                                                        return notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_6__/* .SuccessMessage */ .kk, {
                                                            children: t("txt_thanks_feedback")
                                                        }));
                                                    }).catch(function() {
                                                        return notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_6__/* .ErrorMessage */ .Bc, {
                                                            children: t("txt_something_wrong")
                                                        }));
                                                    })
                                                ];
                                            case 1:
                                                _state.sent();
                                                setSelectedEmotion(null);
                                                setFeedbackText("");
                                                changeShowRating();
                                                feedback = document.getElementById("feedback-message-background");
                                                if (feedback) {
                                                    feedback.style.display = "none";
                                                }
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    onClick: function() {
                        var feedback = document.getElementById("feedback-message-background");
                        if (feedback) {
                            feedback.style.display = "none";
                        }
                    },
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("absolute right-[-40px] top-0 hidden bg-color-surface desktop:flex", "h-[32px] w-[32px] items-center justify-center rounded-full", "border border-color-separator"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_5__/* .CustomThemedResource */ .aK, {
                        format: "svg",
                        source: "/general/close"
                    })
                })
            ]
        })
    });
}
function Emotion(props) {
    var name = props.name, icon = props.icon, selected = props.selected, setSelected = props.setSelected;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        onClick: setSelected,
        className: "group flex flex-col items-center gap-[8px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(selected ? "border-primary-400 bg-primary-100" : "border-color-surface bg-color-surface", "rounded-[8px] transition-colors duration-300 tablet:rounded-[12px]", "border-[1.5px] p-[7px] group-hover:bg-primary-100 tablet:p-[11px]"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_14__/* .assetUrl */ .p)(icon),
                    alt: "emotion",
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("h-[40px] w-[40px] transition-all duration-300", "group-hover:scale-105 tablet:h-[54px] tablet:w-[54px]")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(selected ? "text-primary-500" : "text-blue-500", "text-[13px] font-400 leading-[22px] tracking-[0.24px]", "transition-all duration-300"),
                children: t("lbl_".concat(name))
            })
        ]
    });
}
var rateEmotions = [
    {
        name: "awful",
        icon: "/general/awful.png",
        rate: 1
    },
    {
        name: "poor",
        icon: "/general/poor.png",
        rate: 2
    },
    {
        name: "neutral",
        icon: "/general/neutral.png",
        rate: 3
    },
    {
        name: "good",
        icon: "/general/good.png",
        rate: 4
    },
    {
        name: "exellent",
        icon: "/general/exellent.png",
        rate: 5
    }, 
];


/***/ }),

/***/ 342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ mimeTypeMapper; },
/* harmony export */   "e": function() { return /* binding */ useUploadActions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(253);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_message__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9034);
/* harmony import */ var _comps_simple_drop_area__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(356);
/* harmony import */ var controllers_editors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2213);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7294);
/* harmony import */ var _notification__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4371);











function useUploadActions(tool, setFile) {
    var notify = (0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(_notification__WEBPACK_IMPORTED_MODULE_6__/* .NotificationContext */ .u).notify;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(""), fileName = ref[0], setFileName = ref[1];
    if (tool === null) {
        return null;
    }
    var formats = getMimes(tool);
    var openExplorer = function() {
        var fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.accept = formats.join(",");
        fileInput.onchange = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(_) {
                var _files, file, isOk;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!fileInput.files) return [
                                3,
                                2
                            ];
                            _files = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(fileInput.files, 1), file = _files[0];
                            return [
                                4,
                                (0,controllers_editors__WEBPACK_IMPORTED_MODULE_3__/* .isImageOrVideo */ .c2)(file)
                            ];
                        case 1:
                            isOk = _state.sent();
                            if (!isOk) {
                                notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_1__/* .ErrorMessage */ .Bc, {
                                    children: t("txt_wrong_file_uploaded")
                                }));
                            } else {
                                setFile(file);
                                setFileName(file.name);
                            }
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        fileInput.click();
    };
    var onDrop = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(files) {
            var _files, file, isOk;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _files = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(files, 1), file = _files[0];
                        if (!file) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            (0,controllers_editors__WEBPACK_IMPORTED_MODULE_3__/* .isImageOrVideo */ .c2)(file)
                        ];
                    case 1:
                        isOk = _state.sent();
                        if (!isOk) {
                            notify(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_message__WEBPACK_IMPORTED_MODULE_1__/* .ErrorMessage */ .Bc, {
                                children: t("txt_wrong_file_uploaded")
                            }));
                        } else {
                            setFile(file);
                            setFileName(file.name);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onDrop(files) {
            return _ref.apply(this, arguments);
        };
    }();
    var removeUploaded = function() {
        setFile(null);
    };
    return {
        openExplorer: openExplorer,
        formats: formats,
        onDrop: onDrop,
        removeUploaded: removeUploaded,
        fileName: fileName
    };
}
function getMimes(tool) {
    var mimeType = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_comps_simple_drop_area__WEBPACK_IMPORTED_MODULE_2__/* .mimeTypes.images */ .aN.images).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_comps_simple_drop_area__WEBPACK_IMPORTED_MODULE_2__/* .mimeTypes.videos */ .aN.videos));
    switch(tool){
        case "ai_restyle":
            mimeType = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_comps_simple_drop_area__WEBPACK_IMPORTED_MODULE_2__/* .mimeTypes.videos */ .aN.videos);
            break;
        case "text_to_image":
        case "ai_photo":
            mimeType = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_comps_simple_drop_area__WEBPACK_IMPORTED_MODULE_2__/* .mimeTypes.images */ .aN.images);
            break;
    }
    return mimeType;
}
var mimeTypeMapper = {
    "image/jpeg": ".jpg",
    "image/png": ".png",
    "image/gif": ".gif",
    "image/bmp": ".bmp",
    "image/webp": ".webp",
    "image/svg+xml": ".svg",
    "video/mp4": ".mp4",
    "video/x-msvideo": ".avi",
    "video/mpeg": ".mpeg",
    "video/quicktime": ".mov",
    "video/x-ms-wmv": ".wmv",
    "video/webm": ".webm"
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4593,8336,9774,2888,179], function() { return __webpack_exec__(1296); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);